
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aSqur", function(module, exports) {

$parcel$export(module.exports, "default", () => $14bcd30e01630f71$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $8MNbz = parcelRequire("8MNbz");

var $i90p0 = parcelRequire("i90p0");

var $i9fvx = parcelRequire("i9fvx");

var $aMBx3 = parcelRequire("aMBx3");
/**
 * Synchronous renderer node mapping for media nodes
 *
 * WARNING: This is an EXPERIMENTAL entry point and may change without notice in the future. Use it only at your own risk!
 *
 * Context: https://hello.atlassian.net/wiki/spaces/JIE/pages/5342146338 (Atlassian-internal)
 */ const $14bcd30e01630f71$var$nodeToReact = {
    media: (0, $8MNbz.default),
    mediaGroup: (0, $i90p0.default),
    mediaInline: (0, $i9fvx.default),
    mediaSingle: (0, $aMBx3.default)
};
var $14bcd30e01630f71$export$2e2bcd8739ae039 = $14bcd30e01630f71$var$nodeToReact;

});
parcelRegister("8MNbz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a84ad158cf7251ec$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $kbNdD = parcelRequire("kbNdD");

var $bVYhW = parcelRequire("bVYhW");

var $hiA9t = parcelRequire("hiA9t");

var $3W9Ri = parcelRequire("3W9Ri");

var $3yOzf = parcelRequire("3yOzf");

var $88i6h = parcelRequire("88i6h");

var $kFNiy = parcelRequire("kFNiy");

var $UvioM = parcelRequire("UvioM");

var $idZJp = parcelRequire("idZJp");
var $as7E1 = parcelRequire("as7E1");

var $hFKXd = parcelRequire("hFKXd");

var $4q2AX = parcelRequire("4q2AX");

var $fCgEB = parcelRequire("fCgEB");

var $3FPsB = parcelRequire("3FPsB");
var $8FBWe = parcelRequire("8FBWe");
var $khcvr = parcelRequire("khcvr");
var $70qY2 = parcelRequire("70qY2");

var $8RXs9 = parcelRequire("8RXs9");

var $9ZaL9 = parcelRequire("9ZaL9");

var $63TGy = parcelRequire("63TGy");

var $fj21T = parcelRequire("fj21T");

var $2VAFB = parcelRequire("2VAFB");
function $a84ad158cf7251ec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a84ad158cf7251ec$var$linkStyle = {
    name: "14m5vmv",
    styles: "position:absolute;background:transparent;top:0;right:0;bottom:0;left:0;cursor:pointer;width:100% !important;height:100% !important"
};
const $a84ad158cf7251ec$var$borderStyle = {
    name: "10uwk9w",
    styles: "position:absolute;width:100% !important;height:100% !important"
};
const $a84ad158cf7251ec$var$MediaBorder = ({ mark: mark, children: children })=>{
    if (!mark) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, children);
    const borderColor = mark?.attrs.color ?? '';
    const borderWidth = mark?.attrs.size ?? 0;
    const paletteColorValue = (0, $kFNiy.hexToEditorBorderPaletteColor)(borderColor) || borderColor;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-mark-type": "border",
        "data-color": borderColor,
        "data-size": borderWidth,
        css: $a84ad158cf7251ec$var$borderStyle,
        style: {
            borderRadius: `${borderWidth}px`,
            boxShadow: `0 0 0 ${borderWidth}px ${paletteColorValue}`
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3W9Ri.MediaBorderGapFiller), {
        borderColor: borderColor
    }), children);
};
const $a84ad158cf7251ec$var$MediaLink = ({ mark: mark, children: children, onClick: onClick })=>{
    if (!mark) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, children);
    const linkHref = mark?.attrs.href;
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $f8Sb3.jsx)("a", {
        href: linkHref,
        rel: "noreferrer noopener",
        onClick: onClick,
        "data-block-link": linkHref,
        css: $a84ad158cf7251ec$var$linkStyle
    }, children));
};
const $a84ad158cf7251ec$var$MediaAnnotation = ({ mark: mark, children: children })=>{
    if (!mark) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, children);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fCgEB.default), {
        id: mark.attrs.id,
        annotationType: mark.attrs.annotationType,
        dataAttributes: {
            'data-renderer-mark': true,
            'data-block-mark': true
        },
        // This should be fine being empty [] since the serializer serializeFragmentChild getMarkProps call always passes
        annotationParentIds: [],
        allowAnnotations: true,
        useBlockLevel: true
    }, children);
};
const $a84ad158cf7251ec$var$MediaAnnotations = ({ marks: marks = [], children: children })=>{
    // Early Exit
    if (marks.length === 0) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, children);
    // Recursive marks
    const currentMark = marks[0];
    const otherMarks = marks.slice(1);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)($a84ad158cf7251ec$var$MediaAnnotation, {
        key: currentMark.attrs.id,
        mark: currentMark
    }, otherMarks.length ? /*#__PURE__*/ (0, $f8Sb3.jsx)($a84ad158cf7251ec$var$MediaAnnotations, {
        marks: otherMarks
    }, children) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, children)));
};
const $a84ad158cf7251ec$var$CommentBadge = (0, $8RXs9.default)((0, $3FPsB.CommentBadge));
const $a84ad158cf7251ec$var$CommentBadgeWrapper = ({ marks: marks, mediaSingleElement: mediaSingleElement, isDrafting: isDrafting = false, ...rest })=>{
    const [status, setStatus] = (0, $5uXOq.useState)('default');
    const [entered, setEntered] = (0, $5uXOq.useState)(false);
    const updateSubscriber = (0, $63TGy.useInlineCommentSubscriberContext)();
    const activeParentIds = (0, $9ZaL9.useInlineCommentsFilter)({
        annotationIds: marks?.map((mark)=>mark.attrs.id) ?? [
            ''
        ],
        filter: {
            state: (0, $88i6h.AnnotationMarkStates).ACTIVE
        }
    });
    (0, $5uXOq.useEffect)(()=>{
        const observer = new MutationObserver((mutationList)=>{
            mutationList.forEach((mutation)=>{
                const parentNode = mutation.target.parentNode;
                if (mutation.attributeName === 'data-has-focus') {
                    const isMediaCaption = parentNode?.closest('[data-media-caption="true"]');
                    const elementHasFocus = parentNode?.querySelector('[data-has-focus="true"]') && !isMediaCaption;
                    elementHasFocus ? setStatus('active') : setStatus('default');
                }
            });
        });
        if (mediaSingleElement) observer.observe(mediaSingleElement, {
            attributes: true,
            subtree: true,
            attributeFilter: [
                'data-has-focus'
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaSingleElement,
        setStatus
    ]);
    if (!isDrafting && !activeParentIds.length) return null;
    const onClick = (e)=>{
        e.preventDefault();
        if (updateSubscriber) updateSubscriber.emit((0, $fj21T.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: activeParentIds,
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            eventTarget: e.target,
            // use mediaSingle here to align with annotation viewed event dispatched in editor
            eventTargetType: 'mediaSingle',
            viewMethod: (0, $as7E1.VIEW_METHOD).BADGE
        });
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($a84ad158cf7251ec$var$CommentBadge, {
        onMouseEnter: ()=>setEntered(true),
        onMouseLeave: ()=>setEntered(false),
        status: entered ? 'entered' : status,
        onClick: onClick,
        ...rest
    });
};
const $a84ad158cf7251ec$var$CommentBadgeNextWrapper = ({ marks: marks, mediaSingleElement: mediaSingleElement, isDrafting: isDrafting = false, ...rest })=>{
    const [status, setStatus] = (0, $5uXOq.useState)('default');
    const [entered, setEntered] = (0, $5uXOq.useState)(false);
    const updateSubscriber = (0, $63TGy.useInlineCommentSubscriberContext)();
    const activeParentIds = (0, $9ZaL9.useInlineCommentsFilter)({
        annotationIds: marks?.map((mark)=>mark.attrs.id) ?? [
            ''
        ],
        filter: {
            state: (0, $88i6h.AnnotationMarkStates).ACTIVE
        }
    });
    (0, $5uXOq.useEffect)(()=>{
        const observer = new MutationObserver((mutationList)=>{
            mutationList.forEach((mutation)=>{
                const parentNode = mutation.target.parentNode;
                if (mutation.attributeName === 'data-has-focus') {
                    const isMediaCaption = parentNode?.closest('[data-media-caption="true"]');
                    const elementHasFocus = parentNode?.querySelector('[data-has-focus="true"]') && !isMediaCaption;
                    elementHasFocus ? setStatus('active') : setStatus('default');
                }
            });
        });
        if (mediaSingleElement) observer.observe(mediaSingleElement, {
            attributes: true,
            subtree: true,
            attributeFilter: [
                'data-has-focus'
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaSingleElement,
        setStatus
    ]);
    if (!isDrafting && !activeParentIds.length) return null;
    const onClick = (e)=>{
        e.preventDefault();
        if (updateSubscriber) updateSubscriber.emit((0, $fj21T.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: activeParentIds,
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            eventTarget: e.target,
            // use mediaSingle here to align with annotation viewed event dispatched in editor
            eventTargetType: 'mediaSingle',
            viewMethod: (0, $as7E1.VIEW_METHOD).BADGE
        });
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8FBWe.CommentBadgeNext), {
        onMouseEnter: ()=>setEntered(true),
        onMouseLeave: ()=>setEntered(false),
        status: entered ? 'entered' : status,
        onClick: onClick,
        mediaSingleElement: mediaSingleElement,
        ...rest
    });
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $a84ad158cf7251ec$var$Media extends (0, $5uXOq.PureComponent) {
    constructor(props){
        super(props), this.renderCard = (providers = {})=>{
            const { contextIdentifierProvider: contextIdentifierProvider } = providers;
            const { allowAltTextOnImages: allowAltTextOnImages, alt: alt, featureFlags: featureFlags, shouldOpenMediaViewer: allowMediaViewer, enableDownloadButton: enableDownloadButton, ssr: ssr, width: width, height: height, mediaSingleElement: mediaSingleElement, isDrafting: isDrafting = false } = this.props;
            const annotationMarks = this.props.isAnnotationMark ? this.props.marks.filter(this.props.isAnnotationMark) : undefined;
            const borderMark = this.props.marks.find(this.props.isBorderMark);
            const linkMark = this.props.marks.find(this.props.isLinkMark);
            const linkHref = linkMark?.attrs.href;
            const eventHandlers = linkHref ? undefined : this.props.eventHandlers;
            const shouldOpenMediaViewer = !linkHref && allowMediaViewer;
            const isInPageInclude = mediaSingleElement?.closest('[data-node-type="include"]');
            const isIncludeExcerpt = !!mediaSingleElement?.closest('.ak-excerpt-include');
            const showCommentBadge = !!annotationMarks && !isInPageInclude && !isIncludeExcerpt;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)($a84ad158cf7251ec$var$MediaLink, {
                mark: linkMark,
                onClick: this.handleMediaLinkClickFn
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)($a84ad158cf7251ec$var$MediaAnnotations, {
                marks: annotationMarks
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)($a84ad158cf7251ec$var$MediaBorder, {
                mark: borderMark
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kbNdD.default), {
                data: {
                    [(0, $bVYhW.MEDIA_CONTEXT)]: {
                        border: !!borderMark
                    }
                }
            }, (0, $hFKXd.fg)('platform_editor_add_media_from_url_rollout') && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $70qY2.MediaBadges), {
                mediaElement: mediaSingleElement,
                mediaWidth: width,
                mediaHeight: height,
                useMinimumZIndex: true
            }, ({ visible: visible })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, visible && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $khcvr.ExternalImageBadge), {
                    type: this.props.type,
                    url: this.props.type === 'external' ? this.props.url : undefined
                }), showCommentBadge && /*#__PURE__*/ (0, $f8Sb3.jsx)($a84ad158cf7251ec$var$CommentBadgeNextWrapper, {
                    marks: annotationMarks,
                    mediaSingleElement: mediaSingleElement,
                    isDrafting: isDrafting
                }))), !(0, $hFKXd.fg)('platform_editor_add_media_from_url_rollout') && showCommentBadge && /*#__PURE__*/ (0, $f8Sb3.jsx)($a84ad158cf7251ec$var$CommentBadgeWrapper, {
                marks: annotationMarks,
                mediaSingleElement: mediaSingleElement,
                width: width,
                height: height,
                isDrafting: isDrafting
            }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3yOzf.MediaCard), {
                contextIdentifierProvider: contextIdentifierProvider,
                ...this.props,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                eventHandlers: eventHandlers,
                alt: allowAltTextOnImages ? alt : undefined,
                featureFlags: featureFlags,
                shouldEnableDownloadButton: enableDownloadButton,
                ssr: ssr
            })))));
        }, this.handleMediaLinkClick = (event)=>{
            const { fireAnalyticsEvent: fireAnalyticsEvent, isLinkMark: isLinkMark, marks: marks } = this.props;
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $idZJp.ACTION).VISITED,
                actionSubject: (0, $idZJp.ACTION_SUBJECT).MEDIA,
                actionSubjectId: (0, $idZJp.ACTION_SUBJECT_ID).LINK,
                eventType: (0, $idZJp.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $4q2AX.PLATFORM).WEB,
                    mode: (0, $4q2AX.MODE).RENDERER
                }
            });
            const linkMark = this.props.marks.find(this.props.isLinkMark);
            const linkHref = linkMark?.attrs.href;
            const handler = (0, $UvioM.getEventHandler)(this.props.eventHandlers, 'link');
            if (handler) {
                const linkMark = marks.find(isLinkMark);
                handler(event, linkMark && linkHref);
            }
        };
        this.handleMediaLinkClickFn = this.handleMediaLinkClick.bind(this);
    }
    render() {
        const { providers: providers } = this.props;
        if (!providers) return this.renderCard();
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hiA9t.WithProviders), {
            providers: [
                'mediaProvider',
                'contextIdentifierProvider'
            ],
            providerFactory: providers,
            renderNode: this.renderCard
        });
    }
}
const $a84ad158cf7251ec$var$MediaWithDraftAnnotation = (props)=>{
    const { hoverDraftDocumentPosition: draftPosition } = (0, $2VAFB.useAnnotationRangeState)();
    const { dataAttributes: dataAttributes } = props;
    const pos = dataAttributes && dataAttributes['data-renderer-start-pos'];
    const [position, setPosition] = (0, $5uXOq.useState)();
    const [shouldApplyDraftAnnotation, setShouldApplyDraftAnnotation] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (pos === undefined) return;
        const posToCheck = (draftPosition?.from ?? 0) + 1;
        if (draftPosition !== null && posToCheck === pos) {
            setShouldApplyDraftAnnotation(true);
            setPosition(posToCheck);
        } else if (draftPosition === null && shouldApplyDraftAnnotation) {
            setShouldApplyDraftAnnotation(false);
            setPosition(undefined);
        }
    }, [
        draftPosition,
        pos,
        shouldApplyDraftAnnotation
    ]);
    const applyDraftAnnotation = props.allowAnnotationsDraftMode && shouldApplyDraftAnnotation && position !== undefined;
    const dataAttributesWithDraftAnnotation = (0, $5uXOq.useMemo)(()=>applyDraftAnnotation ? {
            ...dataAttributes,
            'data-annotation-draft-mark': true,
            'data-renderer-mark': true
        } : dataAttributes, [
        applyDraftAnnotation,
        dataAttributes
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($a84ad158cf7251ec$var$Media, {
        ...props,
        dataAttributes: dataAttributesWithDraftAnnotation,
        isDrafting: shouldApplyDraftAnnotation
    });
};
var $a84ad158cf7251ec$export$2e2bcd8739ae039 = $a84ad158cf7251ec$var$MediaWithDraftAnnotation;

});
parcelRegister("3W9Ri", function(module, exports) {

$parcel$export(module.exports, "MediaSingleDimensionHelper", () => $238f84753260b190$export$2b2737a2ef2f5b46);
$parcel$export(module.exports, "MediaWrapper", () => $238f84753260b190$export$542000db99cecf28);
$parcel$export(module.exports, "MediaBorderGapFiller", () => $238f84753260b190$export$e18e95249d813157);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $9KcbK = parcelRequire("9KcbK");

var $hFKXd = parcelRequire("hFKXd");

var $lP8gk = parcelRequire("lP8gk");

var $ij3UO = parcelRequire("ij3UO");

var $gmCM1 = parcelRequire("gmCM1");
function $238f84753260b190$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $238f84753260b190$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
function $238f84753260b190$var$getWidthIfFullWidthMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $9KcbK.akEditorFullWidthLayoutWidth) ? `${Math.min(containerWidth, (0, $9KcbK.akEditorFullWidthLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $9KcbK.akEditorFullWidthLayoutWidth) ? '100%' : `${originalWidth}px`;
}
function $238f84753260b190$var$getWidthIfDefaultMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $9KcbK.akEditorFullPageMaxWidth) ? `${Math.min(containerWidth, (0, $9KcbK.akEditorDefaultLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $9KcbK.akEditorFullPageMaxWidth) ? '100%' : `${originalWidth}px`;
}
function $238f84753260b190$export$326222fa0d211f8e(layout, width, containerWidth = 0, fullWidthMode, isResized, isInsideOfInlineExtension) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return isInsideOfInlineExtension ? (0, $gmCM1.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`) : (0, $gmCM1.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $gmCM1.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $238f84753260b190$var$getWidthIfFullWidthMode(width, containerWidth, isInsideOfInlineExtension) : $238f84753260b190$var$getWidthIfDefaultMode(width, containerWidth, isInsideOfInlineExtension);
    }
}
function $238f84753260b190$export$e4db998a333a342e(layout, width, containerWidth = 0, fullWidthMode, isResized) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return (0, $gmCM1.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`);
        case 'full-width':
            return (0, $gmCM1.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $238f84753260b190$var$getWidthIfFullWidthMode(width, containerWidth) : $238f84753260b190$var$getWidthIfDefaultMode(width, containerWidth);
    }
}
function $238f84753260b190$export$d48e8f24f681763e(layout, width, containerWidth = 0) {
    switch(layout){
        case 'wide':
            return (0, $gmCM1.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $gmCM1.calcBreakoutWidth)(layout, containerWidth);
        default:
            return `${width}px`;
    }
}
function $238f84753260b190$var$calcMaxWidth(layout, containerWidth) {
    switch(layout){
        case 'wide':
            return (0, $gmCM1.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $gmCM1.calcBreakoutWidth)(layout, containerWidth);
        default:
            return '100%';
    }
}
function $238f84753260b190$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
function $238f84753260b190$var$isImageAligned(layout) {
    switch(layout){
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
function $238f84753260b190$export$c832331b07480714(widthValue) {
    try {
        if (widthValue.endsWith('px')) {
            const pxWidth = parseInt(widthValue.slice(0, -2));
            return `${pxWidth - pxWidth % 2}px`;
        }
        return widthValue;
    } catch  {
        return widthValue;
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 * @param root0
 * @param root0.containerWidth
 * @param root0.fullWidthMode
 * @param root0.isResized
 * @param root0.layout
 * @param root0.mediaSingleWidth
 * @param root0.width
 * @param root0.isExtendedResizeExperienceOn
 * @param root0.isNestedNode
 * @param root0.isInsideOfInlineExtension
 * @param root0.nodeType
 * @example
 */ var $238f84753260b190$var$_ref = {
    name: "1ejvwbh",
    styles: "@container view-page-content (min-width: 1px){max-width:100cqw;}"
};
var $238f84753260b190$var$_ref2 = {
    name: "1bxycju",
    styles: "min-width:100%"
};
const $238f84753260b190$export$2b2737a2ef2f5b46 = ({ containerWidth: containerWidth = 0, fullWidthMode: fullWidthMode, isResized: isResized, layout: layout, mediaSingleWidth: mediaSingleWidth, width: width, isExtendedResizeExperienceOn: // original media width
isExtendedResizeExperienceOn, isNestedNode: isNestedNode = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, nodeType: nodeType })=>{
    const calculatedWidth = $238f84753260b190$export$c832331b07480714(isExtendedResizeExperienceOn ? `${mediaSingleWidth || width}px` : mediaSingleWidth ? $238f84753260b190$export$d48e8f24f681763e(layout, width || 0, containerWidth) : $238f84753260b190$export$326222fa0d211f8e(layout, width || 0, containerWidth, fullWidthMode, isResized, isInsideOfInlineExtension));
    const calculatedMaxWidth = $238f84753260b190$export$c832331b07480714(isExtendedResizeExperienceOn ? `${containerWidth}px` : $238f84753260b190$var$calcMaxWidth(layout, containerWidth));
    // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)("tr &,[data-layout-column] &,[data-node-type='expand'] &,[data-panel-type] &,li &{max-width:100%;}width:", calculatedWidth, ";", layout === 'full-width' && /* This causes issues for new experience where we don't strip layout attributes
   when copying top-level node and pasting into a table/layout,
   because full-width layout will remain, causing node to be edge-to-edge */ !isExtendedResizeExperienceOn && $238f84753260b190$var$_ref2, " ", isExtendedResizeExperienceOn && (0, $hFKXd.fg)('platform_fix_media_image_resizing') ? $238f84753260b190$var$_ref : '', "max-width:", (0, $lP8gk.isSSR)() && !calculatedMaxWidth.endsWith('%') && (0, $hFKXd.fg)('platform_editor_fix_image_size_diff_during_ssr') ? Math.max(parseInt(calculatedWidth.replace('px', '')), parseInt(calculatedMaxWidth.replace('px', ''))) + 'px' : calculatedMaxWidth, ";", isExtendedResizeExperienceOn && `&[class*='is-resizing'] {
    .new-file-experience-wrapper {
      box-shadow: none !important;
    }

    ${!isNestedNode && (0, $ij3UO.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
      transform: translateX(-50%);`}
  }`, " &:not(.is-resizing){transition:width 100ms ease-in;}float:", $238f84753260b190$var$float(layout), ";margin:", $238f84753260b190$var$calcMargin(layout), ";&[class*='not-resizing']{", isNestedNode ? /* Make nested node appear responsive when resizing table cell */ `max-width: 100%;` : (0, $ij3UO.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
        transform: translateX(-50%);`, ";}", $238f84753260b190$var$isImageAligned(layout), ";");
};
const $238f84753260b190$var$RenderFallbackContainer = ({ hasFallbackContainer: hasFallbackContainer, paddingBottom: paddingBottom, height: height })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $f8Sb3.css)(hasFallbackContainer ? `
  &::after {
    content: '';
    display: block;
    ${height ? `height: ${height}px;` : paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}

    /* Fixes extra padding problem in Firefox */
    font-size: 0;
    line-height: 0;
  }
  ` : '', ";");
const $238f84753260b190$export$9e3fd9f6215dd7b6 = (props)=>/*#__PURE__*/ (0, $f8Sb3.css)("position:relative;", $238f84753260b190$var$RenderFallbackContainer(props), "&>figure{position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}&>div:not([data-comment-badge='true'], [data-media-badges='true']){position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}& * [data-mark-annotation-type='inlineComment']{width:100%;height:100%;}&[data-node-type='embedCard']>div{width:100%;}[data-node-type='media']{position:static!important;>div{position:absolute;height:100%;}}");
const $238f84753260b190$export$542000db99cecf28 = ({ children: children, ...rest })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $238f84753260b190$export$9e3fd9f6215dd7b6(rest)
    }, children);
$238f84753260b190$export$542000db99cecf28.displayName = 'WrapperMediaSingle';
const $238f84753260b190$export$e18e95249d813157 = ({ borderColor: borderColor })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            inset: '0px',
            border: `0.5px solid ${borderColor}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: '1px'
        }
    });
};

});
parcelRegister("ij3UO", function(module, exports) {

$parcel$export(module.exports, "shouldAddDefaultWrappedWidth", () => $996c88f40e908f91$export$7cd5aab2c4f1fb1e);
$parcel$export(module.exports, "nonWrappedLayouts", () => $996c88f40e908f91$export$607795ead6e50626);
$parcel$export(module.exports, "floatingLayouts", () => $996c88f40e908f91$export$7c0073a4d21b222d);
$parcel$export(module.exports, "isRichMediaInsideOfBlockNode", () => $996c88f40e908f91$export$55fb9d6810f2e04b);
$parcel$export(module.exports, "alignAttributes", () => $996c88f40e908f91$export$b2258912a400ba32);
$parcel$export(module.exports, "calculateSnapPoints", () => $996c88f40e908f91$export$de65085e667b4bf1);

var $5r0mK = parcelRequire("5r0mK");

var $9KcbK = parcelRequire("9KcbK");

var $5vbcx = parcelRequire("5vbcx");
const $996c88f40e908f91$export$7cd5aab2c4f1fb1e = (layout, width, lineLength)=>{
    return (0, $5vbcx.wrappedLayouts).indexOf(layout) > -1 && lineLength && width && width > 0.5 * lineLength;
};
const $996c88f40e908f91$export$607795ead6e50626 = [
    'center',
    'wide',
    'full-width'
];
const $996c88f40e908f91$export$7c0073a4d21b222d = [
    'wrap-left',
    'wrap-right'
];
const $996c88f40e908f91$export$55fb9d6810f2e04b = (view, pos)=>{
    if (typeof pos !== 'number' || isNaN(pos) || !view) return false;
    const $pos = view.state.doc.resolve(pos);
    const { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } = view.state.schema.nodes;
    return !!(0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
        expand,
        nestedExpand,
        layoutColumn
    ]);
};
const $996c88f40e908f91$export$b2258912a400ba32 = (layout, oldAttrs, gridSize = 12, originalWidth, lineLength)=>{
    let width = oldAttrs.width;
    const oldLayout = oldAttrs.layout;
    const oldLayoutIsNonWrapped = $996c88f40e908f91$export$607795ead6e50626.indexOf(oldLayout) > -1;
    const newLayoutIsNonWrapped = $996c88f40e908f91$export$607795ead6e50626.indexOf(layout) > -1;
    const newLayoutIsWrapped = (0, $5vbcx.wrappedLayouts).indexOf(layout) > -1;
    const oldLayoutIsWrapped = (0, $5vbcx.wrappedLayouts).indexOf(oldLayout) > -1;
    if (oldLayoutIsNonWrapped && $996c88f40e908f91$export$7cd5aab2c4f1fb1e(layout, originalWidth, lineLength)) // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
    {
        if (!width || width >= 100 || oldLayout !== 'center' // == 'full-width' or 'wide'
        ) width = 50;
    } else if (layout !== oldLayout && [
        'full-width',
        'wide'
    ].indexOf(oldLayout) > -1) // 'full-width' -> 'center' or 'wide'
    // 'wide' -> 'center' or 'full-width'
    // unset width
    width = undefined;
    else if (width) {
        const cols = Math.round(width / 100 * gridSize);
        let targetCols = cols;
        if (oldLayoutIsWrapped && newLayoutIsNonWrapped) {
            // wrap -> center needs to align to even grid
            targetCols = Math.floor(targetCols / 2) * 2;
            width = undefined;
        } else if (oldLayoutIsNonWrapped && newLayoutIsWrapped) {
            // Can be here only if
            // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
            // AND
            // !originalWidth || !lineLength || small image
            // AND
            // width defined!
            // cannot resize to full column width, and cannot resize to 1 column
            if (cols <= 1) targetCols = 2;
            else if (cols >= gridSize) targetCols = 10;
        }
        if (targetCols !== cols) width = targetCols / gridSize * 100;
    }
    return {
        ...oldAttrs,
        layout: layout,
        width: width
    };
};
function $996c88f40e908f91$export$de65085e667b4bf1({ $pos: $pos, akEditorWideLayoutWidth: akEditorWideLayoutWidth, allowBreakoutSnapPoints: allowBreakoutSnapPoints, containerWidth: containerWidth, gridSize: gridSize, gridWidth: gridWidth, insideInlineLike: insideInlineLike, insideLayout: insideLayout, isVideoFile: isVideoFile, lineLength: lineLength, offsetLeft: offsetLeft, wrappedLayout: wrappedLayout }) {
    const snapTargets = [];
    for(let i = 0; i < gridWidth; i++){
        const pxFromColumns = (0, $5vbcx.calcPxFromColumns)(i, lineLength, gridWidth);
        snapTargets.push(insideLayout ? pxFromColumns : pxFromColumns - offsetLeft);
    }
    // full width
    snapTargets.push(lineLength - offsetLeft);
    const columns = wrappedLayout || insideInlineLike ? 1 : 2;
    const minimumWidth = (0, $5vbcx.calcPxFromColumns)(columns, lineLength, gridSize);
    let snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
    if (!$pos) return snapPoints;
    snapPoints = isVideoFile ? snapPoints.filter((width)=>width > 320) : snapPoints;
    const isTopLevel = $pos.parent.type.name === 'doc';
    if (isTopLevel && allowBreakoutSnapPoints) {
        snapPoints.push(akEditorWideLayoutWidth);
        const fullWidthPoint = containerWidth - (0, $9KcbK.akEditorBreakoutPadding);
        if (fullWidthPoint > akEditorWideLayoutWidth) snapPoints.push(fullWidthPoint);
    }
    // EDM-1107: Ensure new snapPoints are sorted with existing points
    snapPoints = snapPoints.sort((a, b)=>a - b);
    return snapPoints;
}

});
parcelRegister("5vbcx", function(module, exports) {

$parcel$export(module.exports, "calcPxFromColumns", () => $957d8e262dec9be4$export$1e3701608f0cee80);
$parcel$export(module.exports, "calcColumnsFromPx", () => $957d8e262dec9be4$export$10912f14d8d54640);
$parcel$export(module.exports, "calcPctFromPx", () => $957d8e262dec9be4$export$55ddb36b3404ec6d);
$parcel$export(module.exports, "wrappedLayouts", () => $957d8e262dec9be4$export$405baca3d8bc263d);
$parcel$export(module.exports, "calcMediaPxWidth", () => $957d8e262dec9be4$export$5e51fc02b9ada5af);

var $9KcbK = parcelRequire("9KcbK");

var $3jRR8 = parcelRequire("3jRR8");
const $957d8e262dec9be4$var$validWidthModes = [
    'center',
    'wrap-left',
    'wrap-right',
    'align-start',
    'align-end'
];
const $957d8e262dec9be4$export$adfc02948d64a4f2 = (layout)=>$957d8e262dec9be4$var$validWidthModes.indexOf(layout) > -1;
function $957d8e262dec9be4$export$1e3701608f0cee80(columns, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $3jRR8.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth / gridSize * columns - (0, $3jRR8.MEDIA_SINGLE_GUTTER_SIZE);
}
function $957d8e262dec9be4$export$10912f14d8d54640(width, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $3jRR8.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $3jRR8.MEDIA_SINGLE_GUTTER_SIZE)) * gridSize / maxWidth;
}
function $957d8e262dec9be4$export$e70e278a1f662f8d(pct, lineLength) {
    const maxWidth = lineLength + (0, $3jRR8.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth * pct - (0, $3jRR8.MEDIA_SINGLE_GUTTER_SIZE);
}
function $957d8e262dec9be4$export$55ddb36b3404ec6d(width, lineLength) {
    const maxWidth = lineLength + (0, $3jRR8.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $3jRR8.MEDIA_SINGLE_GUTTER_SIZE)) / maxWidth;
}
const $957d8e262dec9be4$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $957d8e262dec9be4$export$144a1e648ed4962e = (containerWidth, pctWidth, origWidth, origHeight)=>pctWidth && origWidth && origHeight && Math.ceil($957d8e262dec9be4$export$e70e278a1f662f8d(pctWidth / 100, containerWidth.lineLength || containerWidth.width));
const $957d8e262dec9be4$export$5e51fc02b9ada5af = (opts)=>{
    const { origWidth: origWidth, origHeight: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, resizedPctWidth: resizedPctWidth } = opts;
    const { width: width, lineLength: lineLength } = containerWidth;
    const calculatedPctWidth = $957d8e262dec9be4$export$144a1e648ed4962e(containerWidth, pctWidth, origWidth, origHeight);
    const calculatedResizedPctWidth = $957d8e262dec9be4$export$144a1e648ed4962e(containerWidth, resizedPctWidth, origWidth, origHeight);
    if (layout === 'wide') {
        if (lineLength) {
            const wideWidth = Math.ceil(lineLength * (0, $9KcbK.breakoutWideScaleRatio));
            return wideWidth > width ? lineLength : wideWidth;
        }
    } else if (layout === 'full-width') return width - (0, $9KcbK.akEditorBreakoutPadding);
    else if (calculatedPctWidth) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if ($957d8e262dec9be4$export$405baca3d8bc263d.indexOf(layout) > -1) {
            if (calculatedResizedPctWidth) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (resizedPctWidth < 50) return calculatedResizedPctWidth;
                return calculatedPctWidth;
            }
            return Math.min(calculatedPctWidth, origWidth);
        }
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return calculatedPctWidth;
    } else if (layout === 'center') {
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return Math.min(origWidth, lineLength || width);
    } else if (layout && $957d8e262dec9be4$export$405baca3d8bc263d.indexOf(layout) !== -1) {
        const halfLineLength = Math.ceil((lineLength || width) / 2);
        return origWidth <= halfLineLength ? origWidth : halfLineLength;
    }
    return origWidth;
};
const $957d8e262dec9be4$export$195604d042fd3f87 = (gridWidth, width, height, lineLength, gridSize)=>{
    const pxWidth = $957d8e262dec9be4$export$e70e278a1f662f8d(gridWidth / 100, lineLength);
    const columnSpan = Math.round($957d8e262dec9be4$export$10912f14d8d54640(pxWidth, lineLength, gridSize));
    const alignedWidth = $957d8e262dec9be4$export$1e3701608f0cee80(columnSpan, lineLength, gridSize);
    return {
        height: height / width * alignedWidth,
        width: alignedWidth
    };
};

});
parcelRegister("3jRR8", function(module, exports) {

$parcel$export(module.exports, "MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH", () => $26742756efc1ef87$export$5937600f4cc784f0);
$parcel$export(module.exports, "MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH", () => $26742756efc1ef87$export$71d660e8ca5b8f73);
$parcel$export(module.exports, "MEDIA_SINGLE_SNAP_GAP", () => $26742756efc1ef87$export$cd11d7d46412c89b);
$parcel$export(module.exports, "MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN", () => $26742756efc1ef87$export$8c5ac0b0c62a3d21);
$parcel$export(module.exports, "MEDIA_SINGLE_GUTTER_SIZE", () => $26742756efc1ef87$export$68d0abe4f03863fb);
$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $26742756efc1ef87$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $26742756efc1ef87$export$da894f7669b4e67c);
$parcel$export(module.exports, "MEDIA_SINGLE_RESIZE_THROTTLE_TIME", () => $26742756efc1ef87$export$e13825c38da2ce1);
$parcel$export(module.exports, "wrappedLayouts", () => $26742756efc1ef87$export$405baca3d8bc263d);
$parcel$export(module.exports, "DEFAULT_ROUNDING_INTERVAL", () => $26742756efc1ef87$export$4d41d008e9cd4f34);
$parcel$export(module.exports, "CAPTION_PLACEHOLDER_ID", () => $26742756efc1ef87$export$b4b560efd3c61856);
const $26742756efc1ef87$export$5937600f4cc784f0 = 24;
const $26742756efc1ef87$export$71d660e8ca5b8f73 = 320;
const $26742756efc1ef87$export$cd11d7d46412c89b = 3;
const $26742756efc1ef87$export$71482734bb54ac3 = 10;
const $26742756efc1ef87$export$fd2b09475ada41cc = 12;
const $26742756efc1ef87$export$8c5ac0b0c62a3d21 = 8;
const $26742756efc1ef87$export$68d0abe4f03863fb = $26742756efc1ef87$export$fd2b09475ada41cc * 2;
const $26742756efc1ef87$export$d722b7527b1834a8 = 250;
const $26742756efc1ef87$export$da894f7669b4e67c = 200;
const $26742756efc1ef87$export$e13825c38da2ce1 = 100;
var $26742756efc1ef87$export$c84671f46d6a1ca = /*#__PURE__*/ function(Layout) {
    Layout["FULL_WIDTH"] = "full-width";
    Layout["WIDE"] = "wide";
    Layout["CENTER"] = "center";
    Layout["ALIGN_START"] = "align-start";
    Layout["ALIGN_END"] = "align-end";
    Layout["WRAP_RIGHT"] = "wrap-right";
    Layout["WRAP_LEFT"] = "wrap-left";
    return Layout;
}({});
const $26742756efc1ef87$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $26742756efc1ef87$export$4d41d008e9cd4f34 = 0.5;
const $26742756efc1ef87$export$b4b560efd3c61856 = 'caption-placeholder';

});




parcelRegister("3yOzf", function(module, exports) {

$parcel$export(module.exports, "mediaIdentifierMap", () => $5c946256c3042074$export$7da2d00ddd5627a6);
$parcel$export(module.exports, "getClipboardAttrs", () => $5c946256c3042074$export$92bef806f5be5d7c);
$parcel$export(module.exports, "MediaCard", () => $5c946256c3042074$export$a6543a2e3828db2c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $l4xdx = parcelRequire("l4xdx");

var $dzcM0 = parcelRequire("dzcM0");
var $jJ2F7 = parcelRequire("jJ2F7");
var $kLMgD = parcelRequire("kLMgD");

var $4sicK = parcelRequire("4sicK");

var $lQSSl = parcelRequire("lQSSl");
const $5c946256c3042074$export$7da2d00ddd5627a6 = new Map();
const $5c946256c3042074$export$e689a46890560dbd = (doc)=>{
    if (!doc) return [];
    return (0, $l4xdx.filter)(doc, (node)=>node.type === 'media').reduce((identifierList, mediaNode)=>{
        if (mediaNode.attrs) {
            const { type: type, url: dataURI, id: id } = mediaNode.attrs;
            if (type === 'file' && id) identifierList.push({
                mediaItemType: 'file',
                id: id
            });
            else if (type === 'external' && dataURI) identifierList.push({
                mediaItemType: 'external-image',
                dataURI: dataURI,
                name: dataURI
            });
        }
        return identifierList;
    }, []);
};
class $5c946256c3042074$export$cfff5eb155a82d30 extends (0, $5uXOq.Component) {
    async componentDidMount() {
        const { rendererContext: rendererContext, contextIdentifierProvider: contextIdentifierProvider, id: id, url: url, collection: collectionName } = this.props;
        if (contextIdentifierProvider) this.setState({
            contextIdentifierProvider: await contextIdentifierProvider
        });
        const nodeIsInCache = id && $5c946256c3042074$export$7da2d00ddd5627a6.has(id) || url && $5c946256c3042074$export$7da2d00ddd5627a6.has(url);
        if (rendererContext && rendererContext.adDoc && !nodeIsInCache) $5c946256c3042074$export$e689a46890560dbd(rendererContext.adDoc).forEach((identifier)=>{
            if (identifier.mediaItemType === 'file' && identifier.id === id) $5c946256c3042074$export$7da2d00ddd5627a6.set(identifier.id, {
                ...identifier,
                collectionName: collectionName
            });
            else if (identifier.mediaItemType === 'external-image') $5c946256c3042074$export$7da2d00ddd5627a6.set(identifier.dataURI, identifier);
        });
        if (id) this.saveFileState(id);
    }
    componentDidUpdate(prevProps) {
        const { id: oldId } = prevProps;
        if (this.props.id && oldId !== this.props.id) this.saveFileState(this.props.id);
    }
    componentWillUnmount() {
        const { id: id, url: dataURI } = this.props;
        if (id) $5c946256c3042074$export$7da2d00ddd5627a6.delete(id);
        else if (dataURI) $5c946256c3042074$export$7da2d00ddd5627a6.delete(dataURI);
    }
    renderExternal(shouldOpenMediaViewer) {
        const { cardDimensions: cardDimensions, resizeMode: resizeMode, appearance: appearance, url: url, imageStatus: imageStatus, disableOverlay: disableOverlay, alt: alt, featureFlags: featureFlags, ssr: ssr, mediaClient: mediaClient, dataAttributes: dataAttributes } = this.props;
        if (imageStatus === 'loading' || !url) return this.renderLoadingCard();
        const identifier = {
            dataURI: url,
            name: url,
            mediaItemType: 'external-image'
        };
        // we need this statement for the mandatory mediaClientConfig below
        const mediaClientConfig = mediaClient?.mediaClientConfig;
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ...dataAttributes,
            "data-node-type": "media",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dzcM0.default), {
                // TODO: MPT-315 - clean up after we move mediaClientConfig into FileIdentifier
                // context is not really used when the type is external and we want to render the component asap
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mediaClientConfig: mediaClientConfig,
                alt: alt,
                identifier: identifier,
                dimensions: cardDimensions,
                appearance: appearance,
                resizeMode: resizeMode,
                disableOverlay: disableOverlay,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: Array.from($5c946256c3042074$export$7da2d00ddd5627a6.values()),
                featureFlags: featureFlags,
                ssr: ssr?.mode,
                shouldHideTooltip: false
            })
        }));
    }
    render() {
        const { contextIdentifierProvider: contextIdentifierProvider, fileState: fileState } = this.state;
        const { id: id, alt: alt, type: type, collection: collection, occurrenceKey: occurrenceKey, cardDimensions: cardDimensions, resizeMode: resizeMode, disableOverlay: disableOverlay, useInlinePlayer: useInlinePlayer, originalDimensions: originalDimensions, shouldOpenMediaViewer: forceOpenMediaViewer, featureFlags: featureFlags, shouldEnableDownloadButton: shouldEnableDownloadButton, ssr: ssr, mediaClient: mediaClient, dataAttributes: dataAttributes } = this.props;
        const isMobile = false;
        const shouldPlayInline = useInlinePlayer !== undefined ? useInlinePlayer : true;
        const isInlinePlayer = isMobile ? false : shouldPlayInline;
        const onCardClick = this.getOnCardClickCallback(isInlinePlayer);
        const shouldOpenMediaViewer = typeof forceOpenMediaViewer === 'boolean' ? forceOpenMediaViewer : !isMobile && !onCardClick;
        if (type === 'external') return this.renderExternal(shouldOpenMediaViewer);
        if (type === 'link') return null;
        const mediaClientConfig = !!ssr ? ssr.config : mediaClient?.mediaClientConfig;
        if (!mediaClientConfig || !id) return this.renderLoadingCard();
        if (!id || type !== 'file') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jJ2F7.CardError), {
            dimensions: cardDimensions
        });
        const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
        const identifier = {
            id: id,
            mediaItemType: 'file',
            collectionName: collection,
            occurrenceKey: occurrenceKey
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ...$5c946256c3042074$export$92bef806f5be5d7c({
                id: id,
                alt: alt,
                collection: collection,
                contextIdentifierProvider: contextIdentifierProvider,
                originalDimensions: originalDimensions,
                fileState: fileState
            }),
            ...dataAttributes,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dzcM0.default), {
                identifier: identifier,
                alt: alt,
                contextId: contextId,
                mediaClientConfig: mediaClientConfig,
                dimensions: cardDimensions,
                originalDimensions: originalDimensions,
                onClick: onCardClick,
                resizeMode: resizeMode,
                isLazy: !isMobile,
                disableOverlay: disableOverlay,
                useInlinePlayer: isInlinePlayer,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: Array.from($5c946256c3042074$export$7da2d00ddd5627a6.values()),
                featureFlags: featureFlags,
                shouldEnableDownloadButton: shouldEnableDownloadButton,
                ssr: ssr?.mode,
                shouldHideTooltip: isMobile
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {}, this.saveFileState = async (id)=>{
            const { collection: collectionName, mediaClient: mediaClient } = this.props;
            const options = {
                collectionName: collectionName
            };
            try {
                if (mediaClient) {
                    const fileState = await mediaClient.file.getCurrentState(id, options);
                    this.setState({
                        fileState: fileState
                    });
                }
            } catch (error) {
            // do not set state on error
            }
        }, this.renderLoadingCard = ()=>{
            const { cardDimensions: cardDimensions } = this.props;
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kLMgD.CardLoading), {
                dimensions: cardDimensions,
                interactionName: "renderer-media-card-loading"
            });
        }, /**
	 * We want to call provided `eventHandlers.media.onClick` when it's provided,
	 * but we also don't want to call it when it's a video and inline video player is enabled.
	 * This is due to consumers normally process this onClick call by opening media viewer and
	 * we don't want that to happened described above text.
	 */ this.getOnCardClickCallback = (isInlinePlayer)=>{
            const { eventHandlers: eventHandlers } = this.props;
            if (eventHandlers && eventHandlers.media && eventHandlers.media.onClick) return (result, analyticsEvent)=>{
                const isVideo = result.mediaItemDetails && result.mediaItemDetails.mediaType === 'video';
                const isVideoWithInlinePlayer = isInlinePlayer && isVideo;
                if (!isVideoWithInlinePlayer && eventHandlers && eventHandlers.media && eventHandlers.media.onClick) eventHandlers.media.onClick(result, analyticsEvent);
            };
            return undefined;
        };
    }
}
const $5c946256c3042074$export$92bef806f5be5d7c = ({ id: id, alt: alt, collection: collection, contextIdentifierProvider: contextIdentifierProvider, originalDimensions: originalDimensions, fileState: fileState })=>{
    const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
    const width = originalDimensions && originalDimensions.width;
    const height = originalDimensions && originalDimensions.height;
    let fileName = 'file'; // default name is needed for Confluence
    let fileSize = 1;
    let fileMimeType = '';
    if (fileState && fileState.status !== 'error') {
        fileSize = fileState.size;
        fileName = fileState.name;
        fileMimeType = fileState.mimeType;
    }
    return {
        'data-context-id': contextId,
        'data-type': 'file',
        'data-node-type': 'media',
        'data-width': width,
        'data-height': height,
        'data-id': id,
        'data-collection': collection,
        'data-file-name': fileName,
        'data-file-size': fileSize,
        'data-file-mime-type': fileMimeType,
        'data-alt': alt
    };
};
const $5c946256c3042074$export$fae4803d1ca121c8 = (props)=>{
    const mediaClient = (0, $5uXOq.useContext)((0, $4sicK.MediaClientContext));
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)($5c946256c3042074$export$cfff5eb155a82d30, {
        ...props,
        mediaClient: mediaClient
    });
};
const $5c946256c3042074$export$a6543a2e3828db2c = (0, $lQSSl.withImageLoader)($5c946256c3042074$export$fae4803d1ca121c8);

});
parcelRegister("l4xdx", function(module, exports) {

$parcel$export(module.exports, "filter", () => $5040ad1c670a6ab9$export$3dea766d36a8935f);

var $1mzqd = parcelRequire("1mzqd");
function $5040ad1c670a6ab9$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $1mzqd.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});

parcelRegister("dzcM0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0363f98b505a65f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $kLMgD = parcelRequire("kLMgD");

var $hRrcd = parcelRequire("hRrcd");
const $f0363f98b505a65f$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
const $f0363f98b505a65f$var$CardLoadingWithContext = ()=>{
    const props = (0, $5uXOq.useContext)($f0363f98b505a65f$var$MediaCardContext);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kLMgD.CardLoading), {
        ...props,
        interactionName: "media-card-async-loading"
    });
};

const $f0363f98b505a65f$var$MediaCardWithMediaClientProvider = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("84SZs")).then((mod)=>mod.CardWithMediaClient),
    loading: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($f0363f98b505a65f$var$CardLoadingWithContext, {})
});
const $f0363f98b505a65f$var$CardLoader = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hRrcd.default), {
        name: "media-card",
        mode: "list",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($f0363f98b505a65f$var$MediaCardContext.Provider, {
            value: props,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($f0363f98b505a65f$var$MediaCardWithMediaClientProvider, {
                ...props
            })
        })
    });
};
$f0363f98b505a65f$var$CardLoader.preload = ()=>$f0363f98b505a65f$var$MediaCardWithMediaClientProvider.preload();
var $f0363f98b505a65f$export$2e2bcd8739ae039 = $f0363f98b505a65f$var$CardLoader;

});
parcelRegister("kLMgD", function(module, exports) {

$parcel$export(module.exports, "CardLoading", () => $90cb2ef023e88acb$export$5d25853fd6bdf402);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5VIAr = parcelRequire("5VIAr");

var $jc2dp = parcelRequire("jc2dp");

var $dyckQ = parcelRequire("dyckQ");
class $90cb2ef023e88acb$export$5d25853fd6bdf402 extends (0, $5uXOq.Component) {
    render() {
        const { dimensions: dimensionsProp, testId: testId, interactionName: interactionName } = this.props;
        const dimensions = (0, $5VIAr.getDimensionsWithDefault)(dimensionsProp);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jc2dp.Wrapper), {
            "data-testid": testId || 'media-card-loading',
            "data-test-loading": true,
            dimensions: dimensions,
            "data-vc": "media-card-loading",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dyckQ.default), {
                interactionName: interactionName || 'media-card-loading'
            })
        });
    }
}

});
parcelRegister("5VIAr", function(module, exports) {

$parcel$export(module.exports, "getDimensionsWithDefault", () => $ac5e0cc21f8800c1$export$36acad525b1fb57b);
const $ac5e0cc21f8800c1$export$36acad525b1fb57b = (dimensions = {
    width: '100%',
    height: '100%'
})=>{
    return {
        height: typeof dimensions.height === 'number' ? `${dimensions.height}px` : dimensions.height,
        width: typeof dimensions.width === 'number' ? `${dimensions.width}px` : dimensions.width
    };
};

});

parcelRegister("jc2dp", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $bc23822567356a10$export$e6dfd72ab29f8598);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $dYf3Z = parcelRequire("dYf3Z");
const $bc23822567356a10$export$e6dfd72ab29f8598 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $dYf3Z.wrapperStyles)({
            dimensions: props.dimensions
        }),
        ...props
    }, props.children));
};

});
parcelRegister("dYf3Z", function(module, exports) {

$parcel$export(module.exports, "wrapperStyles", () => $a8f6b9aca4b839d7$export$491e6397d7c1480b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $2bcs8 = parcelRequire("2bcs8");

const $a8f6b9aca4b839d7$export$491e6397d7c1480b = ({ dimensions: dimensions })=>/*#__PURE__*/ (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $2bcs8.center), {
        background: `var(--ds-background-neutral, ${(0, $dbda9f692ace54dd$export$9fdfb749e33cdf97)})`,
        color: `var(--ds-icon, ${(0, $dbda9f692ace54dd$export$8754fc7e6d8b3000)})`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $2bcs8.borderRadius), {
        maxHeight: '100%',
        maxWidth: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: dimensions.width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: dimensions.height
    });

});
parcelRegister("2bcs8", function(module, exports) {

$parcel$export(module.exports, "ellipsis", () => $9d16fe96aec919b9$export$a5b94313d6908893);
$parcel$export(module.exports, "size", () => $9d16fe96aec919b9$export$346677f925de839c);
$parcel$export(module.exports, "center", () => $9d16fe96aec919b9$export$3481c78889e8fbe8);
$parcel$export(module.exports, "borderRadius", () => $9d16fe96aec919b9$export$7a57f79000377ca2);

var $1wToE = parcelRequire("1wToE");
const $9d16fe96aec919b9$export$a5b94313d6908893 = (maxWidth = '100%')=>{
    const unit = typeof maxWidth === 'number' ? 'px' : '';
    return `
    max-width: ${maxWidth}${unit};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `;
};
const $9d16fe96aec919b9$export$346677f925de839c = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `
    width: ${value}${unit};
    height: ${value}${unit};
  `;
};
const $9d16fe96aec919b9$export$3481c78889e8fbe8 = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $9d16fe96aec919b9$export$d31af2dc8039efd3 = (top = 0, left = 0)=>`
  position: absolute;
  top: ${top}px;
  left: ${left}px;
`;
const $9d16fe96aec919b9$export$7a57f79000377ca2 = `
  border-radius: ${(0, $1wToE.borderRadius)()}px;
`;
const $9d16fe96aec919b9$export$a98155aef1bfd63 = `
  border-bottom-left-radius: ${(0, $1wToE.borderRadius)()}px;
  border-bottom-right-radius: ${(0, $1wToE.borderRadius)()}px;
`;
const $9d16fe96aec919b9$export$24656b269d8df7d6 = 'cubic-bezier(0.645, 0.045, 0.355, 1)';

});

var $dbda9f692ace54dd$exports = {};

$parcel$export($dbda9f692ace54dd$exports, "R50", () => $dbda9f692ace54dd$export$4b84fd0e2c617bd);
$parcel$export($dbda9f692ace54dd$exports, "R75", () => $dbda9f692ace54dd$export$b34b069eff244586);
$parcel$export($dbda9f692ace54dd$exports, "R100", () => $dbda9f692ace54dd$export$be802dd0d8b57f35);
$parcel$export($dbda9f692ace54dd$exports, "R200", () => $dbda9f692ace54dd$export$60847d42f9da92a6);
$parcel$export($dbda9f692ace54dd$exports, "R300", () => $dbda9f692ace54dd$export$4a7404f376229999);
$parcel$export($dbda9f692ace54dd$exports, "R400", () => $dbda9f692ace54dd$export$2010d0fb4295b346);
$parcel$export($dbda9f692ace54dd$exports, "R500", () => $dbda9f692ace54dd$export$2837b5a1a71d5c02);
$parcel$export($dbda9f692ace54dd$exports, "Y50", () => $dbda9f692ace54dd$export$8d9596b529bbb9cf);
$parcel$export($dbda9f692ace54dd$exports, "Y75", () => $dbda9f692ace54dd$export$41060a744ab0b7ae);
$parcel$export($dbda9f692ace54dd$exports, "Y100", () => $dbda9f692ace54dd$export$1cc05bbbf340e559);
$parcel$export($dbda9f692ace54dd$exports, "Y200", () => $dbda9f692ace54dd$export$5aae31392d72caaa);
$parcel$export($dbda9f692ace54dd$exports, "Y300", () => $dbda9f692ace54dd$export$c6930421db9fa514);
$parcel$export($dbda9f692ace54dd$exports, "Y400", () => $dbda9f692ace54dd$export$59619663aa6500fb);
$parcel$export($dbda9f692ace54dd$exports, "Y500", () => $dbda9f692ace54dd$export$874739ea9e379ab6);
$parcel$export($dbda9f692ace54dd$exports, "G50", () => $dbda9f692ace54dd$export$8a6341c32b6a3ee6);
$parcel$export($dbda9f692ace54dd$exports, "G75", () => $dbda9f692ace54dd$export$69a3bf21b9686c2b);
$parcel$export($dbda9f692ace54dd$exports, "G100", () => $dbda9f692ace54dd$export$afbce1382ec95f73);
$parcel$export($dbda9f692ace54dd$exports, "G200", () => $dbda9f692ace54dd$export$747d86715d4175de);
$parcel$export($dbda9f692ace54dd$exports, "G300", () => $dbda9f692ace54dd$export$940e1f69e873f202);
$parcel$export($dbda9f692ace54dd$exports, "G400", () => $dbda9f692ace54dd$export$a49394138f7b8e85);
$parcel$export($dbda9f692ace54dd$exports, "G500", () => $dbda9f692ace54dd$export$6fa04827ac68a4fb);
$parcel$export($dbda9f692ace54dd$exports, "B50", () => $dbda9f692ace54dd$export$226de0355ed012f8);
$parcel$export($dbda9f692ace54dd$exports, "B75", () => $dbda9f692ace54dd$export$8c13c2ee36917869);
$parcel$export($dbda9f692ace54dd$exports, "B100", () => $dbda9f692ace54dd$export$ecfc1dff386a3e7a);
$parcel$export($dbda9f692ace54dd$exports, "B200", () => $dbda9f692ace54dd$export$215b7063051591f1);
$parcel$export($dbda9f692ace54dd$exports, "B300", () => $dbda9f692ace54dd$export$e62e8919cca44969);
$parcel$export($dbda9f692ace54dd$exports, "B400", () => $dbda9f692ace54dd$export$b3de0ae08da2ce64);
$parcel$export($dbda9f692ace54dd$exports, "B500", () => $dbda9f692ace54dd$export$a6ee3d71bc067634);
$parcel$export($dbda9f692ace54dd$exports, "B600", () => $dbda9f692ace54dd$export$67f15409e87642a1);
$parcel$export($dbda9f692ace54dd$exports, "B700", () => $dbda9f692ace54dd$export$f0539dbc42dbb067);
$parcel$export($dbda9f692ace54dd$exports, "P50", () => $dbda9f692ace54dd$export$363e4475840015bb);
$parcel$export($dbda9f692ace54dd$exports, "P75", () => $dbda9f692ace54dd$export$4b0a4417ed59760f);
$parcel$export($dbda9f692ace54dd$exports, "P100", () => $dbda9f692ace54dd$export$6011520a64d9a187);
$parcel$export($dbda9f692ace54dd$exports, "P200", () => $dbda9f692ace54dd$export$a7175d4e9206bc80);
$parcel$export($dbda9f692ace54dd$exports, "P300", () => $dbda9f692ace54dd$export$b48405b95304b5a1);
$parcel$export($dbda9f692ace54dd$exports, "P400", () => $dbda9f692ace54dd$export$c71e4279dd54a18d);
$parcel$export($dbda9f692ace54dd$exports, "P500", () => $dbda9f692ace54dd$export$147899de772240ec);
$parcel$export($dbda9f692ace54dd$exports, "T50", () => $dbda9f692ace54dd$export$2cf711fe14c66f06);
$parcel$export($dbda9f692ace54dd$exports, "T75", () => $dbda9f692ace54dd$export$7a8f4d33f6f9772c);
$parcel$export($dbda9f692ace54dd$exports, "T100", () => $dbda9f692ace54dd$export$776c9c497ef08533);
$parcel$export($dbda9f692ace54dd$exports, "T200", () => $dbda9f692ace54dd$export$69cb3ca10c1e330e);
$parcel$export($dbda9f692ace54dd$exports, "T300", () => $dbda9f692ace54dd$export$9dc1ef0f3f48059b);
$parcel$export($dbda9f692ace54dd$exports, "T400", () => $dbda9f692ace54dd$export$7c835c78b6fcdef8);
$parcel$export($dbda9f692ace54dd$exports, "T500", () => $dbda9f692ace54dd$export$6036577f95c3877e);
$parcel$export($dbda9f692ace54dd$exports, "N0", () => $dbda9f692ace54dd$export$29a4f05edc054374);
$parcel$export($dbda9f692ace54dd$exports, "N10", () => $dbda9f692ace54dd$export$e655ef011c4aa1a2);
$parcel$export($dbda9f692ace54dd$exports, "N20", () => $dbda9f692ace54dd$export$9fdfb749e33cdf97);
$parcel$export($dbda9f692ace54dd$exports, "N30", () => $dbda9f692ace54dd$export$3e51e8f1440314ba);
$parcel$export($dbda9f692ace54dd$exports, "N40", () => $dbda9f692ace54dd$export$1ce2d1575d444ceb);
$parcel$export($dbda9f692ace54dd$exports, "N50", () => $dbda9f692ace54dd$export$8754fc7e6d8b3000);
$parcel$export($dbda9f692ace54dd$exports, "N60", () => $dbda9f692ace54dd$export$c2e91cbeada39b8b);
$parcel$export($dbda9f692ace54dd$exports, "N70", () => $dbda9f692ace54dd$export$5f71e19f3a7ad9de);
$parcel$export($dbda9f692ace54dd$exports, "N80", () => $dbda9f692ace54dd$export$eaa8c8a70ac22806);
$parcel$export($dbda9f692ace54dd$exports, "N90", () => $dbda9f692ace54dd$export$7c87d337fb91a97d);
$parcel$export($dbda9f692ace54dd$exports, "N100", () => $dbda9f692ace54dd$export$d6447c357493214f);
$parcel$export($dbda9f692ace54dd$exports, "N200", () => $dbda9f692ace54dd$export$f563ee71e9ee74cd);
$parcel$export($dbda9f692ace54dd$exports, "N300", () => $dbda9f692ace54dd$export$e2ef2124cf4024b1);
$parcel$export($dbda9f692ace54dd$exports, "N400", () => $dbda9f692ace54dd$export$eece5f492e429f08);
$parcel$export($dbda9f692ace54dd$exports, "N500", () => $dbda9f692ace54dd$export$c39c0fe0f26207ae);
$parcel$export($dbda9f692ace54dd$exports, "N600", () => $dbda9f692ace54dd$export$7090862dc3038a9f);
$parcel$export($dbda9f692ace54dd$exports, "N700", () => $dbda9f692ace54dd$export$ad0bacf983b7ddaa);
$parcel$export($dbda9f692ace54dd$exports, "N800", () => $dbda9f692ace54dd$export$7d61b15e0da132af);
$parcel$export($dbda9f692ace54dd$exports, "N900", () => $dbda9f692ace54dd$export$fbda843f0a27fe96);
$parcel$export($dbda9f692ace54dd$exports, "N10A", () => $dbda9f692ace54dd$export$791e57b27ca738ef);
$parcel$export($dbda9f692ace54dd$exports, "N20A", () => $dbda9f692ace54dd$export$8d43898f60b96a82);
$parcel$export($dbda9f692ace54dd$exports, "N30A", () => $dbda9f692ace54dd$export$920c0d5c49070351);
$parcel$export($dbda9f692ace54dd$exports, "N40A", () => $dbda9f692ace54dd$export$46987b49aab6d1a8);
$parcel$export($dbda9f692ace54dd$exports, "N50A", () => $dbda9f692ace54dd$export$7d3359664e8bb0e5);
$parcel$export($dbda9f692ace54dd$exports, "N60A", () => $dbda9f692ace54dd$export$d2d3bedfb276cac0);
$parcel$export($dbda9f692ace54dd$exports, "N70A", () => $dbda9f692ace54dd$export$6e5e7499ff054f6d);
$parcel$export($dbda9f692ace54dd$exports, "N80A", () => $dbda9f692ace54dd$export$59264b346c877fa7);
$parcel$export($dbda9f692ace54dd$exports, "N90A", () => $dbda9f692ace54dd$export$d092757d7c64925c);
$parcel$export($dbda9f692ace54dd$exports, "N100A", () => $dbda9f692ace54dd$export$486ab785e4bac3c6);
$parcel$export($dbda9f692ace54dd$exports, "N200A", () => $dbda9f692ace54dd$export$fba592bbc6419fea);
$parcel$export($dbda9f692ace54dd$exports, "N300A", () => $dbda9f692ace54dd$export$13609db0e6812ab8);
$parcel$export($dbda9f692ace54dd$exports, "N400A", () => $dbda9f692ace54dd$export$fbae4efaa892d883);
$parcel$export($dbda9f692ace54dd$exports, "N500A", () => $dbda9f692ace54dd$export$f13946d26f440ce6);
$parcel$export($dbda9f692ace54dd$exports, "N600A", () => $dbda9f692ace54dd$export$19f58225ac52a306);
$parcel$export($dbda9f692ace54dd$exports, "N700A", () => $dbda9f692ace54dd$export$6384f09da70e7b62);
$parcel$export($dbda9f692ace54dd$exports, "N800A", () => $dbda9f692ace54dd$export$d0dccc730683edc2);
$parcel$export($dbda9f692ace54dd$exports, "DN900", () => $dbda9f692ace54dd$export$2f6319cf7d736c2a);
$parcel$export($dbda9f692ace54dd$exports, "DN800", () => $dbda9f692ace54dd$export$95126bc8884d6634);
$parcel$export($dbda9f692ace54dd$exports, "DN700", () => $dbda9f692ace54dd$export$8338d8c35d44ff1);
$parcel$export($dbda9f692ace54dd$exports, "DN600", () => $dbda9f692ace54dd$export$5368d76ae4fbbda7);
$parcel$export($dbda9f692ace54dd$exports, "DN500", () => $dbda9f692ace54dd$export$9f0a771d16ec8d36);
$parcel$export($dbda9f692ace54dd$exports, "DN400", () => $dbda9f692ace54dd$export$abcf8c38338b4aa5);
$parcel$export($dbda9f692ace54dd$exports, "DN300", () => $dbda9f692ace54dd$export$97e81faa16a182c7);
$parcel$export($dbda9f692ace54dd$exports, "DN200", () => $dbda9f692ace54dd$export$bfe21c59123ecf33);
$parcel$export($dbda9f692ace54dd$exports, "DN100", () => $dbda9f692ace54dd$export$ee82aa2ea6a1558);
$parcel$export($dbda9f692ace54dd$exports, "DN90", () => $dbda9f692ace54dd$export$682927c6ed76be02);
$parcel$export($dbda9f692ace54dd$exports, "DN80", () => $dbda9f692ace54dd$export$91fd9994c5be9757);
$parcel$export($dbda9f692ace54dd$exports, "DN70", () => $dbda9f692ace54dd$export$d281fbfe3cff2df6);
$parcel$export($dbda9f692ace54dd$exports, "DN60", () => $dbda9f692ace54dd$export$3902c91d8b98a753);
$parcel$export($dbda9f692ace54dd$exports, "DN50", () => $dbda9f692ace54dd$export$8e8133c1ba5845b5);
$parcel$export($dbda9f692ace54dd$exports, "DN40", () => $dbda9f692ace54dd$export$33ff357f6620b39);
$parcel$export($dbda9f692ace54dd$exports, "DN30", () => $dbda9f692ace54dd$export$633847cf062b69e0);
$parcel$export($dbda9f692ace54dd$exports, "DN20", () => $dbda9f692ace54dd$export$9776a6e503bdbf76);
$parcel$export($dbda9f692ace54dd$exports, "DN10", () => $dbda9f692ace54dd$export$6c813d5160dff5db);
$parcel$export($dbda9f692ace54dd$exports, "DN0", () => $dbda9f692ace54dd$export$3d4f271a500072a);
$parcel$export($dbda9f692ace54dd$exports, "DN800A", () => $dbda9f692ace54dd$export$fe151285c22759ec);
$parcel$export($dbda9f692ace54dd$exports, "DN700A", () => $dbda9f692ace54dd$export$a101c6190d0da34);
$parcel$export($dbda9f692ace54dd$exports, "DN600A", () => $dbda9f692ace54dd$export$4b16f52932fda51);
$parcel$export($dbda9f692ace54dd$exports, "DN500A", () => $dbda9f692ace54dd$export$a74bcd7b9845b0d8);
$parcel$export($dbda9f692ace54dd$exports, "DN400A", () => $dbda9f692ace54dd$export$9209c179316d1751);
$parcel$export($dbda9f692ace54dd$exports, "DN300A", () => $dbda9f692ace54dd$export$88f55133f636c8dd);
$parcel$export($dbda9f692ace54dd$exports, "DN200A", () => $dbda9f692ace54dd$export$51126f85d1009512);
$parcel$export($dbda9f692ace54dd$exports, "DN100A", () => $dbda9f692ace54dd$export$a069b547bd23af78);
$parcel$export($dbda9f692ace54dd$exports, "DN90A", () => $dbda9f692ace54dd$export$40cce05af3b2600a);
$parcel$export($dbda9f692ace54dd$exports, "DN80A", () => $dbda9f692ace54dd$export$b78942185925a0d);
$parcel$export($dbda9f692ace54dd$exports, "DN70A", () => $dbda9f692ace54dd$export$e058fb44b8eaafca);
$parcel$export($dbda9f692ace54dd$exports, "DN60A", () => $dbda9f692ace54dd$export$92b0b8de26920c18);
$parcel$export($dbda9f692ace54dd$exports, "DN50A", () => $dbda9f692ace54dd$export$67564f7459d3fc9e);
$parcel$export($dbda9f692ace54dd$exports, "DN40A", () => $dbda9f692ace54dd$export$77868e1ca884ffa3);
$parcel$export($dbda9f692ace54dd$exports, "DN30A", () => $dbda9f692ace54dd$export$2afd71d7d3ea2cd5);
$parcel$export($dbda9f692ace54dd$exports, "DN20A", () => $dbda9f692ace54dd$export$f2a0acaab9972c70);
$parcel$export($dbda9f692ace54dd$exports, "DN10A", () => $dbda9f692ace54dd$export$9ab70e67d6475361);
$parcel$export($dbda9f692ace54dd$exports, "T30", () => $dbda9f692ace54dd$export$d2adc5dedf09fced);
$parcel$export($dbda9f692ace54dd$exports, "L50", () => $dbda9f692ace54dd$export$f51762073d2bb381);
$parcel$export($dbda9f692ace54dd$exports, "L75", () => $dbda9f692ace54dd$export$95e26d54def96891);
// Reds
const $dbda9f692ace54dd$export$4b84fd0e2c617bd = '#FFEBE6';
const $dbda9f692ace54dd$export$b34b069eff244586 = '#FFBDAD';
const $dbda9f692ace54dd$export$be802dd0d8b57f35 = '#FF8F73';
const $dbda9f692ace54dd$export$60847d42f9da92a6 = '#FF7452';
const $dbda9f692ace54dd$export$4a7404f376229999 = '#FF5630';
const $dbda9f692ace54dd$export$2010d0fb4295b346 = '#DE350B';
const $dbda9f692ace54dd$export$2837b5a1a71d5c02 = '#BF2600';
const $dbda9f692ace54dd$export$8d9596b529bbb9cf = '#FFFAE6';
const $dbda9f692ace54dd$export$41060a744ab0b7ae = '#FFF0B3';
const $dbda9f692ace54dd$export$1cc05bbbf340e559 = '#FFE380';
const $dbda9f692ace54dd$export$5aae31392d72caaa = '#FFC400';
const $dbda9f692ace54dd$export$c6930421db9fa514 = '#FFAB00';
const $dbda9f692ace54dd$export$59619663aa6500fb = '#FF991F';
const $dbda9f692ace54dd$export$874739ea9e379ab6 = '#FF8B00';
const $dbda9f692ace54dd$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $dbda9f692ace54dd$export$69a3bf21b9686c2b = '#ABF5D1';
const $dbda9f692ace54dd$export$afbce1382ec95f73 = '#79F2C0';
const $dbda9f692ace54dd$export$747d86715d4175de = '#57D9A3';
const $dbda9f692ace54dd$export$940e1f69e873f202 = '#36B37E';
const $dbda9f692ace54dd$export$a49394138f7b8e85 = '#00875A';
const $dbda9f692ace54dd$export$6fa04827ac68a4fb = '#006644';
const $dbda9f692ace54dd$export$226de0355ed012f8 = '#DEEBFF';
const $dbda9f692ace54dd$export$8c13c2ee36917869 = '#B3D4FF';
const $dbda9f692ace54dd$export$ecfc1dff386a3e7a = '#4C9AFF';
const $dbda9f692ace54dd$export$215b7063051591f1 = '#2684FF';
const $dbda9f692ace54dd$export$e62e8919cca44969 = '#0065FF';
const $dbda9f692ace54dd$export$b3de0ae08da2ce64 = '#0052CC';
const $dbda9f692ace54dd$export$a6ee3d71bc067634 = '#0747A6';
const $dbda9f692ace54dd$export$67f15409e87642a1 = '#669DF1';
const $dbda9f692ace54dd$export$f0539dbc42dbb067 = '#8FB8F6';
const $dbda9f692ace54dd$export$363e4475840015bb = '#EAE6FF';
const $dbda9f692ace54dd$export$4b0a4417ed59760f = '#C0B6F2';
const $dbda9f692ace54dd$export$6011520a64d9a187 = '#998DD9';
const $dbda9f692ace54dd$export$a7175d4e9206bc80 = '#8777D9';
const $dbda9f692ace54dd$export$b48405b95304b5a1 = '#6554C0';
const $dbda9f692ace54dd$export$c71e4279dd54a18d = '#5243AA';
const $dbda9f692ace54dd$export$147899de772240ec = '#403294';
const $dbda9f692ace54dd$export$2cf711fe14c66f06 = '#E6FCFF';
const $dbda9f692ace54dd$export$7a8f4d33f6f9772c = '#B3F5FF';
const $dbda9f692ace54dd$export$776c9c497ef08533 = '#79E2F2';
const $dbda9f692ace54dd$export$69cb3ca10c1e330e = '#00C7E6';
const $dbda9f692ace54dd$export$9dc1ef0f3f48059b = '#00B8D9';
const $dbda9f692ace54dd$export$7c835c78b6fcdef8 = '#00A3BF';
const $dbda9f692ace54dd$export$6036577f95c3877e = '#008DA6';
const $dbda9f692ace54dd$export$29a4f05edc054374 = '#FFFFFF';
const $dbda9f692ace54dd$export$e655ef011c4aa1a2 = '#FAFBFC';
const $dbda9f692ace54dd$export$9fdfb749e33cdf97 = '#F4F5F7';
const $dbda9f692ace54dd$export$3e51e8f1440314ba = '#EBECF0';
const $dbda9f692ace54dd$export$1ce2d1575d444ceb = '#DFE1E6';
const $dbda9f692ace54dd$export$8754fc7e6d8b3000 = '#C1C7D0';
const $dbda9f692ace54dd$export$c2e91cbeada39b8b = '#B3BAC5';
const $dbda9f692ace54dd$export$5f71e19f3a7ad9de = '#A5ADBA';
const $dbda9f692ace54dd$export$eaa8c8a70ac22806 = '#97A0AF';
const $dbda9f692ace54dd$export$7c87d337fb91a97d = '#8993A4';
const $dbda9f692ace54dd$export$d6447c357493214f = '#7A869A';
const $dbda9f692ace54dd$export$f563ee71e9ee74cd = '#6B778C';
const $dbda9f692ace54dd$export$e2ef2124cf4024b1 = '#5E6C84';
const $dbda9f692ace54dd$export$eece5f492e429f08 = '#505F79';
const $dbda9f692ace54dd$export$c39c0fe0f26207ae = '#42526E';
const $dbda9f692ace54dd$export$7090862dc3038a9f = '#344563';
const $dbda9f692ace54dd$export$ad0bacf983b7ddaa = '#253858';
const $dbda9f692ace54dd$export$7d61b15e0da132af = '#172B4D';
const $dbda9f692ace54dd$export$fbda843f0a27fe96 = '#091E42';
const $dbda9f692ace54dd$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $dbda9f692ace54dd$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $dbda9f692ace54dd$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $dbda9f692ace54dd$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $dbda9f692ace54dd$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $dbda9f692ace54dd$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $dbda9f692ace54dd$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $dbda9f692ace54dd$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $dbda9f692ace54dd$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $dbda9f692ace54dd$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $dbda9f692ace54dd$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $dbda9f692ace54dd$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $dbda9f692ace54dd$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $dbda9f692ace54dd$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $dbda9f692ace54dd$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $dbda9f692ace54dd$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $dbda9f692ace54dd$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $dbda9f692ace54dd$export$2f6319cf7d736c2a = '#E6EDFA';
const $dbda9f692ace54dd$export$95126bc8884d6634 = '#DCE5F5';
const $dbda9f692ace54dd$export$8338d8c35d44ff1 = '#CED9EB';
const $dbda9f692ace54dd$export$5368d76ae4fbbda7 = '#B8C7E0';
const $dbda9f692ace54dd$export$9f0a771d16ec8d36 = '#ABBBD6';
const $dbda9f692ace54dd$export$abcf8c38338b4aa5 = '#9FB0CC';
const $dbda9f692ace54dd$export$97e81faa16a182c7 = '#8C9CB8';
const $dbda9f692ace54dd$export$bfe21c59123ecf33 = '#7988A3';
const $dbda9f692ace54dd$export$ee82aa2ea6a1558 = '#67758F';
const $dbda9f692ace54dd$export$682927c6ed76be02 = '#56637A';
const $dbda9f692ace54dd$export$91fd9994c5be9757 = '#455166';
const $dbda9f692ace54dd$export$d281fbfe3cff2df6 = '#3B475C';
const $dbda9f692ace54dd$export$3902c91d8b98a753 = '#313D52';
const $dbda9f692ace54dd$export$8e8133c1ba5845b5 = '#283447';
const $dbda9f692ace54dd$export$33ff357f6620b39 = '#202B3D';
const $dbda9f692ace54dd$export$633847cf062b69e0 = '#1B2638';
const $dbda9f692ace54dd$export$9776a6e503bdbf76 = '#121A29';
const $dbda9f692ace54dd$export$6c813d5160dff5db = '#0E1624';
const $dbda9f692ace54dd$export$3d4f271a500072a = '#0D1424';
const $dbda9f692ace54dd$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $dbda9f692ace54dd$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $dbda9f692ace54dd$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $dbda9f692ace54dd$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $dbda9f692ace54dd$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $dbda9f692ace54dd$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $dbda9f692ace54dd$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $dbda9f692ace54dd$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $dbda9f692ace54dd$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $dbda9f692ace54dd$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $dbda9f692ace54dd$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $dbda9f692ace54dd$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $dbda9f692ace54dd$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $dbda9f692ace54dd$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $dbda9f692ace54dd$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $dbda9f692ace54dd$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $dbda9f692ace54dd$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $dbda9f692ace54dd$export$d2adc5dedf09fced = '#292A2E';
const $dbda9f692ace54dd$export$f51762073d2bb381 = '#94C748';
const $dbda9f692ace54dd$export$95e26d54def96891 = '#B3DF72';




parcelRegister("84SZs", function(module, exports) {

let $5e195a631e094bcb$var$load = (parcelRequire("loK1v"))(4);
module.exports = Promise.all([
    $5e195a631e094bcb$var$load("4X3wS"),
    $5e195a631e094bcb$var$load("hSQJ5"),
    $5e195a631e094bcb$var$load("aCh9P"),
    $5e195a631e094bcb$var$load("bxxT5"),
    $5e195a631e094bcb$var$load("1Fhab")
]).then(()=>parcelRequire('8fzjD'));

});


parcelRegister("jJ2F7", function(module, exports) {

$parcel$export(module.exports, "CardError", () => $25e0adb5bacffa79$export$f7f7efdefcc02999);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $e6HKY = parcelRequire("e6HKY");

var $jc2dp = parcelRequire("jc2dp");

var $5VIAr = parcelRequire("5VIAr");
class $25e0adb5bacffa79$export$f7f7efdefcc02999 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            size: 'medium'
        };
    }
    render() {
        const dimensions = (0, $5VIAr.getDimensionsWithDefault)(this.props.dimensions);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jc2dp.Wrapper), {
            dimensions: dimensions,
            children: this.icon
        });
    }
    get icon() {
        const { size: size } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e6HKY.ErrorIcon), {
            size: size
        });
    }
}

});
parcelRegister("e6HKY", function(module, exports) {

$parcel$export(module.exports, "ErrorIcon", () => $8ab9bd06b70e38a3$export$19bc16ee58e19b3d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $clGx8 = parcelRequire("clGx8");

var $jGmWJ = parcelRequire("jGmWJ");
class $8ab9bd06b70e38a3$export$19bc16ee58e19b3d extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            size: 'small'
        };
    }
    render() {
        const { size: size } = this.props;
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: (0, $jGmWJ.errorIconWrapperStyles)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($clGx8))), {
            color: "currentColor",
            label: "Error",
            LEGACY_size: size
        })));
    }
}

});
parcelRegister("clGx8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77723dece3c67bedf7bcbbec84e5d004>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8fd870768530a22a$var$_react = $8fd870768530a22a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8fd870768530a22a$var$_warning = $8fd870768530a22a$var$_interopRequireDefault((parcelRequire("6pggj")));

var $8fd870768530a22a$var$_warning2 = $8fd870768530a22a$var$_interopRequireDefault((parcelRequire("3Fijf")));
function $8fd870768530a22a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "EditorWarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8fd870768530a22a$var$WarningIcon = (props)=>/*#__PURE__*/ $8fd870768530a22a$var$_react.default.createElement($8fd870768530a22a$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $8fd870768530a22a$var$_warning2.default
    }, props));
$8fd870768530a22a$var$WarningIcon.Name = 'WarningIconMigration';
var $8fd870768530a22a$var$_default = module.exports.default = $8fd870768530a22a$var$WarningIcon;

});
parcelRegister("3Fijf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ab3674a4a40052f$var$_react = $2ab3674a4a40052f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");

var $2ab3674a4a40052f$var$_warning = $2ab3674a4a40052f$var$_interopRequireDefault((parcelRequire("6pggj")));
function $2ab3674a4a40052f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2ab3674a4a40052f$var$EditorWarningIcon = (props)=>/*#__PURE__*/ $2ab3674a4a40052f$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.31 5.343 7.359 13.17A1 1 0 0 1 19.796 20H4.204a1 1 0 0 1-.873-1.488l7.36-13.169a1.5 1.5 0 0 1 2.618 0M12 8.5a1.09 1.09 0 0 0-1.081 1.239l.513 3.766a.573.573 0 0 0 1.136 0l.513-3.766A1.09 1.09 0 0 0 12 8.5m0 8.63a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"/></svg>`
    }, props, {
        newIcon: $2ab3674a4a40052f$var$_warning.default
    }));
$2ab3674a4a40052f$var$EditorWarningIcon.displayName = 'EditorWarningIcon';
var $2ab3674a4a40052f$var$_default = module.exports.default = $2ab3674a4a40052f$var$EditorWarningIcon;

});


parcelRegister("jGmWJ", function(module, exports) {

$parcel$export(module.exports, "errorIconWrapperStyles", () => $c2518b7bebc90249$export$8dcf6b831a37de79);
function $c2518b7bebc90249$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c2518b7bebc90249$export$8dcf6b831a37de79 = {
    name: "1fo963f",
    styles: "display:flex;color:var(--ds-icon-warning, #ff991f)"
};

});



parcelRegister("lQSSl", function(module, exports) {

$parcel$export(module.exports, "withImageLoader", () => $3cd7ed78270d7670$export$9b0f795b2e33f057);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $hFKXd = parcelRequire("hFKXd");
const $3cd7ed78270d7670$export$3a0bcc6ff2e20f36 = (Wrapped)=>class WithImageLoader extends (0, $5uXOq.Component) {
        /**
		 *
		 * @example
		 */ componentDidMount() {
            this.fetchImage(this.props);
        }
        /**
		 *
		 * @param nextProps
		 * @example
		 */ // Ignored via go/ees005
        // eslint-disable-next-line react/no-unsafe
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(nextProps);
            }
        }
        /**
		 *
		 * @example
		 */ componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        /**
		 *
		 * @param root0
		 * @param root0.url
		 * @example
		 */ fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        /**
		 *
		 * @example
		 */ render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args), this.state = {
                imageStatus: 'loading'
            }, this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            }, this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };
const $3cd7ed78270d7670$var$withImageLoaderNew = (Wrapped)=>class WithImageLoader extends (0, $5uXOq.Component) {
        componentDidMount() {
            this.fetchImage(this.props);
        }
        componentDidUpdate(newProps) {
            if (newProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(newProps);
            }
        }
        componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args), this.state = {
                imageStatus: 'loading'
            }, this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            }, this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };
const $3cd7ed78270d7670$export$9b0f795b2e33f057 = (Wrapped)=>{
    if ((0, $hFKXd.fg)('platform_editor_react18_phase2_v2') || (0, $hFKXd.fg)('platform_editor_react18_phase2_v2_extended')) return $3cd7ed78270d7670$var$withImageLoaderNew(Wrapped);
    return $3cd7ed78270d7670$export$3a0bcc6ff2e20f36(Wrapped);
};

});


parcelRegister("kFNiy", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $692a288759b4349a$export$bad3c41dd33cb4bc);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $692a288759b4349a$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $692a288759b4349a$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
}
const $692a288759b4349a$export$aa000893c5e2b9c2 = {
    // gray
    /** gray - subtle */ ['#091E4224']: "var(--ds-border, #091E4224)",
    /** gray */ ['#758195']: "var(--ds-border-bold, #758195)",
    /** gray - bold */ ['#172B4D']: "var(--ds-text, #172B4D)"
};

});

parcelRegister("as7E1", function(module, exports) {

$parcel$export(module.exports, "RESOLVE_METHOD", () => $5f0af57daea9587b$export$ecd1fed429542b49);
$parcel$export(module.exports, "VIEW_METHOD", () => $5f0af57daea9587b$export$9cf3651d97128b9c);
var $5f0af57daea9587b$export$ecd1fed429542b49 = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}({});
var $5f0af57daea9587b$export$9cf3651d97128b9c = /*#__PURE__*/ function(VIEW_METHOD) {
    VIEW_METHOD["BADGE"] = "badge";
    VIEW_METHOD["COMMENT_BUTTON"] = "commentButton";
    return VIEW_METHOD;
}({});

});

parcelRegister("3FPsB", function(module, exports) {

$parcel$export(module.exports, "CommentBadge", () => $5a520fc5dde93b8c$export$ef88b752358da42);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $lFKmC = parcelRequire("lFKmC");

var $74FvT = parcelRequire("74FvT");

var $9KcbK = parcelRequire("9KcbK");

var $9XnWW = parcelRequire("9XnWW");

var $2uk0b = parcelRequire("2uk0b");

var $9fYN9 = parcelRequire("9fYN9");

var $b3r99 = parcelRequire("b3r99");
const $5a520fc5dde93b8c$var$commentBadgeWrapper = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'absolute',
    // closest parent element with position relative is .resizer-hover-zone, which includes 10px padding
    right: '2px',
    top: '2px',
    borderRadius: '3px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $9KcbK.akEditorUnitZIndex) * 10
});
const $5a520fc5dde93b8c$var$commentBadgeEditorOverrides = (badgeOffsetRight)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        right: badgeOffsetRight,
        zIndex: 100
    });
const $5a520fc5dde93b8c$export$1019384fb8540123 = (width, height)=>{
    // width is the original width of image, not resized or currently rendered to user. Defaulting to medium for now
    return width && width < 70 || height && height < 70 ? 'small' : 'medium';
};
const $5a520fc5dde93b8c$export$ef88b752358da42 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ intl: intl, width: width, height: height, status: status = 'default', mediaSingleElement: mediaSingleElement, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, badgeOffsetRight: badgeOffsetRight }, ref)=>{
    const [badgeSize, setBadgeSize] = (0, $5uXOq.useState)($5a520fc5dde93b8c$export$1019384fb8540123(width, height));
    const title = intl.formatMessage((0, $b3r99.commentMessages).viewCommentsOnMedia);
    (0, $5uXOq.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((entries)=>{
            const [entry] = entries;
            const { width: width, height: height } = entry.contentRect;
            setBadgeSize($5a520fc5dde93b8c$export$1019384fb8540123(width, height));
        }));
        if (mediaSingleElement instanceof HTMLElement) observer.observe(mediaSingleElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaSingleElement
    ]);
    const badgeDimensions = badgeSize === 'medium' ? '24px' : '16px';
    const colourToken = (0, $5uXOq.useMemo)(()=>{
        switch(status){
            case 'active':
                return "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)";
            case 'entered':
                return "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)";
            default:
                return "var(--ds-background-accent-yellow-subtlest, #FFF7D6)";
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: ref,
        css: badgeOffsetRight ? [
            $5a520fc5dde93b8c$var$commentBadgeWrapper,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            $5a520fc5dde93b8c$var$commentBadgeEditorOverrides(badgeOffsetRight)
        ] : $5a520fc5dde93b8c$var$commentBadgeWrapper,
        // This is needed so that mediaWrapperStyle in editor/editor-common/src/ui/MediaSingle/styled.tsx
        // can target the correct div
        "data-comment-badge": "true"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9fYN9.default), {
        position: "top",
        content: title
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $74FvT.default), {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: badgeDimensions,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: badgeDimensions,
            background: colourToken,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            justifyContent: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center'
        },
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        iconAfter: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9XnWW))), {
            label: title,
            spacing: "spacious",
            color: "currentColor",
            LEGACY_size: badgeSize,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2uk0b)))
        })
    })));
});

});
parcelRegister("9XnWW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $73fc33acd5932731$var$_react = $73fc33acd5932731$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $73fc33acd5932731$var$_baseNew = $73fc33acd5932731$var$_interopRequireDefault((parcelRequire("9ogAd")));
function $73fc33acd5932731$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $73fc33acd5932731$var$CommentIcon = (props)=>/*#__PURE__*/ $73fc33acd5932731$var$_react.default.createElement($73fc33acd5932731$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$73fc33acd5932731$var$CommentIcon.displayName = 'CommentIcon';
var $73fc33acd5932731$var$_default = module.exports.default = $73fc33acd5932731$var$CommentIcon;

});

parcelRegister("2uk0b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1cfde6168fd9bdab$var$_react = $1cfde6168fd9bdab$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");

var $1cfde6168fd9bdab$var$_comment = $1cfde6168fd9bdab$var$_interopRequireDefault((parcelRequire("9XnWW")));
function $1cfde6168fd9bdab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1cfde6168fd9bdab$var$CommentIcon = (props)=>/*#__PURE__*/ $1cfde6168fd9bdab$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51s7.002 2.472 7.002 5.51c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51m14.84 7.771v-.001s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716"/><rect width="10" height="2" x="7" y="9" rx="1"/><rect width="5" height="2" x="7" y="12" rx="1"/></g></svg>`
    }, props, {
        newIcon: $1cfde6168fd9bdab$var$_comment.default
    }));
$1cfde6168fd9bdab$var$CommentIcon.displayName = 'CommentIcon';
var $1cfde6168fd9bdab$var$_default = module.exports.default = $1cfde6168fd9bdab$var$CommentIcon;

});

parcelRegister("b3r99", function(module, exports) {

$parcel$export(module.exports, "commentMessages", () => $0720f8ae9f25d72e$export$4c0d145df60cfb04);

var $7VHMR = parcelRequire("7VHMR");
const $0720f8ae9f25d72e$export$4c0d145df60cfb04 = (0, $7VHMR.defineMessages)({
    addCommentOnMedia: {
        id: 'fabric.editor.addCommentOnMedia',
        defaultMessage: 'Add comment',
        description: 'Add a comment for this media (image/video)'
    },
    viewCommentsOnMedia: {
        id: 'fabric.editor.viewCommentOnMedia',
        defaultMessage: 'View comments',
        description: 'View a existing comment for this media (image/video)'
    },
    viewAndAddCommentsOnMedia: {
        id: 'fabric.editor.viewAndAddCommentsOnMedia',
        defaultMessage: 'View and add comments',
        description: 'View and add comments for this image'
    }
});

});


parcelRegister("8FBWe", function(module, exports) {

$parcel$export(module.exports, "CommentBadgeNext", () => $b1b8985b7954a892$export$d5da84b0136a0cc4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $9XnWW = parcelRequire("9XnWW");

var $2uk0b = parcelRequire("2uk0b");

var $d8maQ = parcelRequire("d8maQ");
var $ii5wQ = parcelRequire("ii5wQ");

var $9fYN9 = parcelRequire("9fYN9");

var $b3r99 = parcelRequire("b3r99");
const $b1b8985b7954a892$var$baseStyles = (0, $ii5wQ.xcss)({
    borderRadius: 'border.radius'
});
const $b1b8985b7954a892$var$mediumBadgeStyles = (0, $ii5wQ.xcss)({
    height: 'space.300',
    width: 'space.300'
});
const $b1b8985b7954a892$export$d5da84b0136a0cc4 = ({ status: status = 'default', onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>{
    const intl = (0, $koVbs.default)();
    const title = intl.formatMessage((0, $b3r99.commentMessages).viewCommentsOnMedia);
    const colourToken = (0, $5uXOq.useMemo)(()=>{
        switch(status){
            case 'active':
                return 'color.background.accent.yellow.subtlest.pressed';
            case 'entered':
                return 'color.background.accent.yellow.subtlest.hovered';
            default:
                return 'color.background.accent.yellow.subtlest';
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9fYN9.default), {
        position: "top",
        content: title,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d8maQ.default), {
            xcss: [
                $b1b8985b7954a892$var$baseStyles,
                $b1b8985b7954a892$var$mediumBadgeStyles
            ],
            padding: "space.0",
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            backgroundColor: colourToken,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9XnWW))), {
                label: title,
                spacing: "spacious",
                color: "currentColor",
                LEGACY_size: "medium",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2uk0b)))
            })
        })
    });
};

});

parcelRegister("khcvr", function(module, exports) {

$parcel$export(module.exports, "ExternalImageBadge", () => $9e9430dd2580f135$export$66bf2ed7a5d4691f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $lrje7 = parcelRequire("lrje7");

var $e65Lk = parcelRequire("e65Lk");
var $ii5wQ = parcelRequire("ii5wQ");

var $9fYN9 = parcelRequire("9fYN9");

var $9CWFL = parcelRequire("9CWFL");
const $9e9430dd2580f135$var$baseStyles = (0, $ii5wQ.xcss)({
    borderRadius: 'border.radius',
    backgroundColor: 'elevation.surface',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    cursor: 'pointer'
});
const $9e9430dd2580f135$var$NO_EXTERNAL_BADGE_HOSTS = [
    'atlassian.com',
    'loom.com'
];
const $9e9430dd2580f135$export$babb68fb5c212c90 = (url)=>{
    if (!url) return false;
    // Check if URL is valid
    try {
        new URL(url);
    } catch  {
        return false;
    }
    const parsedUrl = new URL(url || '');
    const { hostname: hostname, pathname: pathname, protocol: protocol } = parsedUrl;
    if (protocol === 'data:') return pathname?.startsWith('image/');
    return Boolean(hostname && $9e9430dd2580f135$var$NO_EXTERNAL_BADGE_HOSTS.some((host)=>hostname === host || hostname.endsWith(`.${host}`)));
};
const $9e9430dd2580f135$export$66bf2ed7a5d4691f = ({ type: type, url: url })=>{
    const intl = (0, $koVbs.default)();
    const message = intl.formatMessage((0, $9CWFL.externalMediaMessages).externalMediaFile);
    if (type !== 'external' || $9e9430dd2580f135$export$babb68fb5c212c90(url)) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $e65Lk.default), {
        padding: "space.050",
        xcss: $9e9430dd2580f135$var$baseStyles,
        tabIndex: 0,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                "data-testid": "external-image-badge"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9fYN9.default), {
                content: message,
                position: "top",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lrje7))), {
                    LEGACY_size: "small",
                    label: message
                })
            })
        ]
    });
};

});
parcelRegister("9CWFL", function(module, exports) {

$parcel$export(module.exports, "externalMediaMessages", () => $2e288937e7ce5b29$export$8e36294abfabe45e);

var $7VHMR = parcelRequire("7VHMR");
const $2e288937e7ce5b29$export$8e36294abfabe45e = (0, $7VHMR.defineMessages)({
    externalMediaFile: {
        id: 'fabric.editor.externalMediaFile',
        defaultMessage: 'External media file',
        description: 'External media file'
    }
});

});


parcelRegister("70qY2", function(module, exports) {

$parcel$export(module.exports, "MediaBadges", () => $d52c79183d1a0697$export$6a31fc38737d0e58);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $e65Lk = parcelRequire("e65Lk");
var $ii5wQ = parcelRequire("ii5wQ");
const $d52c79183d1a0697$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT = 200;
const $d52c79183d1a0697$var$containerStyles = (0, $ii5wQ.xcss)({
    display: 'flex',
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    gap: 'space.025',
    zIndex: 'card',
    height: 'fit-content',
    width: 'fit-content',
    margin: 'space.075'
});
// The above styles are used for both editor and renderer, and in renderer the
// document body is the main scroll area. This means it overscrolls the primary
// toolbar, where the z-index is "2". We have to hack in our own z-index less
// than that to ensure our badge appears under the toolbar when scrolled.
const $d52c79183d1a0697$var$hackedZIndexStyles = (0, $ii5wQ.xcss)({
    // @ts-ignore
    zIndex: '1'
});
const $d52c79183d1a0697$var$resizeOffsetStyles = (0, $ii5wQ.xcss)({
    right: 'space.150'
});
const $d52c79183d1a0697$var$getBadgeVisible = (width, height)=>{
    return width && width < $d52c79183d1a0697$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT || height && height < $d52c79183d1a0697$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT ? false : true;
};
const $d52c79183d1a0697$export$6a31fc38737d0e58 = ({ children: children, mediaElement: mediaElement, mediaWidth: mediaWidth, mediaHeight: mediaHeight, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: useMinimumZIndex = false })=>{
    const [visible, setVisible] = (0, $5uXOq.useState)($d52c79183d1a0697$var$getBadgeVisible(mediaWidth, mediaHeight));
    (0, $5uXOq.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((entries)=>{
            const [entry] = entries;
            const { width: width, height: height } = entry.contentRect;
            setVisible($d52c79183d1a0697$var$getBadgeVisible(width, height));
        }));
        if (mediaElement) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        observer.observe(mediaElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaElement
    ]);
    if (typeof children === 'function') children = children({
        visible: visible
    });
    if (!mediaElement || (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.count(children) === 0) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e65Lk.default), {
        as: "div",
        testId: "media-badges",
        "data-media-badges": "true",
        contentEditable: false,
        xcss: [
            $d52c79183d1a0697$var$containerStyles,
            useMinimumZIndex && $d52c79183d1a0697$var$hackedZIndexStyles,
            extendedResizeOffset && $d52c79183d1a0697$var$resizeOffsetStyles
        ],
        children: children
    });
};

});


parcelRegister("i90p0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5837f91c8b5815d5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $93jTu = parcelRequire("93jTu");

var $5HbQK = parcelRequire("5HbQK");

var $kXjCv = parcelRequire("kXjCv");

var $hFKXd = parcelRequire("hFKXd");
class $5837f91c8b5815d5$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    render() {
        const numChildren = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.count(this.props.children);
        let content;
        const mediaGroupProps = (0, $hFKXd.fg)('platform_editor_fix_vc90_bug_with_files') ? (0, $kXjCv.VcMediaWrapperProps) : {};
        if (numChildren === 1) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const card = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(this.props.children)[0];
            switch(card.props.type){
                case 'file':
                    content = this.renderSingleFile(card);
                    break;
                case 'link':
                    content = null;
                    break;
                default:
                    content = this.renderSingleLink(card);
            }
        } else content = this.renderStrip();
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: "MediaGroup",
                ...mediaGroupProps,
                children: content
            })
        });
    }
    renderSingleFile(child) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
            resizeMode: 'stretchy-fit',
            cardDimensions: (0, $93jTu.defaultImageCardDimensions),
            useInlinePlayer: false,
            featureFlags: this.props.featureFlags,
            enableDownloadButton: this.props.enableDownloadButton
        });
    }
    renderSingleLink(child) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
            appearance: 'auto',
            featureFlags: this.props.featureFlags
        });
    }
    cloneFileCard(child, surroundingItems) {
        const cardClickHandler = this.props && this.props.eventHandlers && this.props.eventHandlers.media && this.props.eventHandlers.media.onClick;
        const onClick = cardClickHandler ? this.onMediaClick(cardClickHandler, child, surroundingItems) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
            useInlinePlayer: false,
            eventHandlers: {
                ...child.props.eventHandlers,
                media: {
                    onClick: onClick
                }
            },
            featureFlags: this.props.featureFlags,
            enableDownloadButton: this.props.enableDownloadButton
        });
    }
    renderStrip() {
        const { children: children } = this.props;
        const { animate: animate, offset: offset } = this.state;
        const childIdentifiers = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (child)=>{
            if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) return this.mapMediaPropsToIdentifier(child.props);
        });
        const surroundingItems = (childIdentifiers || []).filter((identifier)=>!!identifier);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HbQK.FilmstripView), {
            animate: animate,
            offset: offset,
            onSize: this.handleSize,
            onScroll: this.handleScroll,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (rawChild)=>{
                const child = rawChild;
                switch(child.props.type){
                    case 'file':
                        return this.cloneFileCard(child, surroundingItems);
                    case 'link':
                        return null;
                    default:
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                            featureFlags: this.props.featureFlags,
                            enableDownloadButton: this.props.enableDownloadButton
                        });
                }
            })
        });
    }
    mapMediaPropsToIdentifier({ id: id, type: type, occurrenceKey: occurrenceKey, collection: collection }) {
        switch(type){
            case 'file':
                return {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: id,
                    mediaItemType: type,
                    occurrenceKey: occurrenceKey,
                    collectionName: collection
                };
            case 'link':
                return undefined;
            case 'external':
                return {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: id,
                    mediaItemType: 'file',
                    occurrenceKey: occurrenceKey,
                    collectionName: collection
                };
        }
    }
    constructor(...args){
        super(...args), this.state = {
            animate: false,
            offset: 0
        }, this.handleSize = ({ offset: offset })=>this.setState({
                offset: offset
            }), this.handleScroll = ({ animate: animate, offset: offset })=>this.setState({
                animate: animate,
                offset: offset
            }), this.onMediaClick = (cardClickHandler, child, surroundingItems)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (event, analyticsEvent)=>{
                const surroundings = {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    collectionName: child.props.collection,
                    list: surroundingItems
                };
                cardClickHandler(event, surroundings, analyticsEvent);
            };
    }
}

});
parcelRegister("93jTu", function(module, exports) {

$parcel$export(module.exports, "defaultImageCardDimensions", () => $a6812fa5b53daa4d$export$d87a47989c00f322);
$parcel$export(module.exports, "getDefaultCardDimensions", () => $a6812fa5b53daa4d$export$ed7b8a4728e9c63);
const $a6812fa5b53daa4d$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $a6812fa5b53daa4d$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $a6812fa5b53daa4d$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $a6812fa5b53daa4d$export$ed7b8a4728e9c63 = (appearance)=>{
    if (appearance === 'image') return $a6812fa5b53daa4d$export$d87a47989c00f322;
    if (appearance === 'square') return $a6812fa5b53daa4d$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $a6812fa5b53daa4d$export$aeb48196afcd236a;
    return $a6812fa5b53daa4d$export$d87a47989c00f322;
};

});

parcelRegister("5HbQK", function(module, exports) {

$parcel$export(module.exports, "MediaFilmStripListItemSelector", () => $58c8c56f9eeff655$export$9f2ec2b609810bce);
$parcel$export(module.exports, "FilmstripView", () => $58c8c56f9eeff655$export$817db220b90d8024);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jKqh4 = parcelRequire("jKqh4");

var $j3qyL = parcelRequire("j3qyL");
const $58c8c56f9eeff655$var$DURATION_MIN = 0.5;
const $58c8c56f9eeff655$var$DURATION_MAX = 1.0;
const $58c8c56f9eeff655$var$EXTRA_PADDING = 4;
const $58c8c56f9eeff655$export$ba458cf715b18bd1 = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
};
const $58c8c56f9eeff655$export$9f2ec2b609810bce = 'media-filmstrip-list-item';
class $58c8c56f9eeff655$export$817db220b90d8024 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            animate: false,
            offset: 0
        };
    }
    constructor(props){
        super(props), this.previousOffset = 0, this.state = {
            bufferWidth: 0,
            windowWidth: 0,
            touchMoveStartPosition: 0,
            isTouchMoveInProgress: false
        }, this.handleSizeChange = ()=>{
            // get the new widths
            const { windowElement: windowElement, bufferElement: bufferElement } = this;
            let bufferWidth = 0;
            let windowWidth = 0;
            let childOffsets = [];
            if (windowElement && bufferElement) {
                bufferWidth = bufferElement.getBoundingClientRect().width;
                windowWidth = windowElement.getBoundingClientRect().width;
                // we're calculating `left` based on `width` because `rect.left` can be a negative value after resizing the window (considered scrolled??)
                const children = Array.prototype.slice.call(bufferElement.children, 0);
                let left = 0;
                childOffsets = children.map((child, index)=>{
                    const width = child.getBoundingClientRect().width;
                    const offset = {
                        left: left,
                        right: left + width - 1
                    };
                    left += width;
                    return offset;
                });
            }
            // make sure the state has changed before we update state and notify the integrator
            // (otherwise, since this method() is called in componentDidUpdate() we'll recurse until the stack size is exceeded)
            const { bufferWidth: prevBufferWidth, windowWidth: prevWindowWidth } = this.state;
            if (bufferWidth === prevBufferWidth && windowWidth === prevWindowWidth) // NOTE: we're not checking here if childOffsets has changed... if the children change size but
            // result in the exact same size buffer, we're not going to update, resulting in incorrect navigations
            return;
            // store the widths
            this.setState({
                bufferWidth: bufferWidth,
                windowWidth: windowWidth
            }, ()=>{
                this.childOffsets = childOffsets;
                // notify the integrator
                const { onSize: onSize } = this.props;
                if (onSize) onSize({
                    offset: Math.min(this.maxOffset, this.offset),
                    offsets: childOffsets,
                    width: windowWidth,
                    minOffset: this.minOffset,
                    maxOffset: this.maxOffset
                });
            });
        }, this.handleWindowElementChange = (windowElement)=>{
            this.windowElement = windowElement;
            this.handleSizeChange();
        }, this.handleBufferElementChange = (bufferElement)=>{
            if (!bufferElement) return;
            this.bufferElement = bufferElement;
            this.handleSizeChange();
            this.initMutationObserver();
        }, this.handleMutation = (mutationList)=>{
            // there are edge cases where the DOM may change outside of the normal React life-cycle
            // https://product-fabric.atlassian.net/browse/MSW-425
            this.handleSizeChange();
        }, this.handleLeftClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForLeft(this.offset - windowWidth);
                if (newOffset >= this.offset) // if for some reason we tried to scroll left but it didn't scroll or scrolls right instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.max(this.offset - windowWidth, this.minOffset);
                onScroll({
                    direction: 'left',
                    offset: newOffset,
                    animate: true
                });
            }
        }, this.handleRightClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForRight(this.offset + windowWidth);
                if (newOffset <= this.offset) // if for some reason we tried to scroll right but it didn't scroll or scrolls left instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.min(this.offset + windowWidth, this.maxOffset);
                onScroll({
                    direction: 'right',
                    offset: newOffset,
                    animate: true
                });
            }
        }, this.handleScroll = (event)=>{
            const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            if (!isHorizontalScroll) return;
            // don't actually let the element scroll because we'll fake scrolling with `transform: translateX()`
            event.preventDefault();
            // notify the integrator of the offset change
            const { onScroll: onScroll } = this.props;
            if (onScroll && isHorizontalScroll) {
                const newOffset = Math.max(this.minOffset, Math.min(this.maxOffset, this.offset + event.deltaX));
                onScroll({
                    direction: event.deltaX < 0 ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        }, this.handleTouchStart = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: true
            });
        }, this.handleTouchEnd = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: false
            });
        }, this.handleTouchMove = (event)=>{
            const { onScroll: onScroll } = this.props;
            if (this.state.isTouchMoveInProgress && onScroll) {
                const currentPosition = event.touches[0].clientX;
                const newOffset = this.state.touchMoveStartPosition ? this.offset - (currentPosition - this.state.touchMoveStartPosition) : this.offset;
                onScroll({
                    direction: newOffset > this.offset ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.childOffsets = [];
        try {
            this.mutationObserver = new MutationObserver((0, (/*@__PURE__*/$parcel$interopDefault($jKqh4)))(this.handleMutation, 30, true));
        } catch (e) {
        // in the case where we are running on an unsupported browser,
        // or where tests include the FilmstripView but do not mock the MutationObserver - we catch it and handle safely here.
        // NOTE: this won't effect the component, it just means mutations won't be observerd
        }
    }
    get offset() {
        const { offset: offset } = this.props;
        if (!offset) return 0;
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    get minOffset() {
        return 0;
    }
    /**
	 * The furthest we can scroll, where the end of the buffer is just in view
	 */ get maxOffset() {
        const { bufferWidth: bufferWidth, windowWidth: windowWidth } = this.state;
        return Math.max(this.minOffset, bufferWidth - windowWidth - 1);
    }
    get canGoLeft() {
        return this.offset > this.minOffset;
    }
    get canGoRight() {
        return this.offset < this.maxOffset;
    }
    get transitionDuration() {
        const { animate: animate } = this.props;
        const { windowWidth: windowWidth } = this.state;
        if (!animate) return 0;
        if (Math.abs(this.offset - this.previousOffset) < 1e-6) return $58c8c56f9eeff655$var$DURATION_MIN;
        else {
            const diff = Math.abs(this.offset - this.previousOffset);
            const relativeOffset = diff / windowWidth;
            const duration = $58c8c56f9eeff655$var$DURATION_MAX - $58c8c56f9eeff655$var$DURATION_MIN * relativeOffset;
            return Math.max(Math.min(duration, $58c8c56f9eeff655$var$DURATION_MAX), $58c8c56f9eeff655$var$DURATION_MIN);
        }
    }
    initMutationObserver() {
        const { mutationObserver: mutationObserver } = this;
        if (mutationObserver && this.bufferElement) {
            mutationObserver.disconnect();
            mutationObserver.observe(this.bufferElement, $58c8c56f9eeff655$export$ba458cf715b18bd1);
        }
    }
    triggerScrollEvent() {
        if (!this.windowElement) return;
        const event = document.createEvent('MouseEvents');
        event.initEvent('scroll', true, true);
        this.windowElement.dispatchEvent(event);
    }
    // find the child that is cut off on the left edge of the window and change the window offset to
    // start to the left of that child
    getClosestForLeft(offset) {
        const leftWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset));
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (leftWindowEdge >= childBounds.left && leftWindowEdge <= childBounds.right) {
                const newOffset = i === 0 ? childBounds.left : childBounds.right;
                if (newOffset >= $58c8c56f9eeff655$var$EXTRA_PADDING) return newOffset - $58c8c56f9eeff655$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    // find the child that is cut off on the right edge of the window and change the window offset
    // to finish at start of the next child
    getClosestForRight(offset) {
        const { windowWidth: windowWidth } = this.state;
        const rightWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset)) + windowWidth;
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (rightWindowEdge >= childBounds.left && rightWindowEdge <= childBounds.right) {
                const newOffset = (i === this.childOffsets.length - 1 ? childBounds.right : childBounds.left) - windowWidth;
                if (newOffset + $58c8c56f9eeff655$var$EXTRA_PADDING <= this.maxOffset) return newOffset + $58c8c56f9eeff655$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    renderLeftArrow() {
        const { canGoLeft: canGoLeft } = this;
        if (!canGoLeft) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j3qyL.LeftArrow), {
            onClick: this.handleLeftClick
        });
    }
    renderRightArrow() {
        const { canGoRight: canGoRight } = this;
        if (!canGoRight) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j3qyL.RightArrow), {
            onClick: this.handleRightClick
        });
    }
    componentDidMount() {
        this.previousOffset = this.offset;
        window.addEventListener('resize', this.handleSizeChange);
    }
    componentWillUnmount() {
        const { mutationObserver: mutationObserver } = this;
        window.removeEventListener('resize', this.handleSizeChange);
        if (mutationObserver) mutationObserver.disconnect();
    }
    componentDidUpdate() {
        this.previousOffset = this.offset;
        // trigger a "real" scroll event so lazily loaded cards realize they've been shown
        // note: we have to wait for the transition to end, otherwise the cards not visible when the scroll
        // event is triggered will be forever stuck in the loading screen (due to the lazy load)
        window.setTimeout(()=>this.triggerScrollEvent(), this.transitionDuration * 1000);
    }
    render() {
        const { animate: animate, children: children, testId: testId } = this.props;
        const transform = `translateX(${-this.offset}px)`;
        const transitionProperty = animate ? 'transform' : 'none';
        const transitionDuration = `${this.transitionDuration}s`;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $j3qyL.FilmStripViewWrapper), {
            "data-testid": testId,
            children: [
                this.renderLeftArrow(),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j3qyL.FilmStripListWrapper), {
                    ref: this.handleWindowElementChange,
                    onWheel: this.handleScroll,
                    onTouchStart: this.handleTouchStart,
                    onTouchMove: this.handleTouchMove,
                    onTouchEnd: this.handleTouchEnd,
                    "data-testid": "filmstrip-list-wrapper",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j3qyL.FilmStripList), {
                        ref: this.handleBufferElementChange,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            transform: transform,
                            transitionProperty: transitionProperty,
                            transitionDuration: transitionDuration
                        },
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, $58c8c56f9eeff655$var$mapReactChildToReactNode)
                    })
                }),
                this.renderRightArrow()
            ]
        });
    }
}
function $58c8c56f9eeff655$var$mapReactChildToReactNode(child, index) {
    const key = $58c8c56f9eeff655$var$isReactElement(child) && child.key || index;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j3qyL.FilmStripListItem), {
        index: key,
        children: child
    }, key);
}
function $58c8c56f9eeff655$var$isReactElement(child) {
    return !!child.type;
}

});
parcelRegister("jKqh4", function(module, exports) {
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $e606b1b9737cea37$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$e606b1b9737cea37$var$debounce.debounce = $e606b1b9737cea37$var$debounce;
module.exports = $e606b1b9737cea37$var$debounce;

});

parcelRegister("j3qyL", function(module, exports) {

$parcel$export(module.exports, "LeftArrow", () => $098bb57cf5e49424$export$b39b1b86b48b621f);
$parcel$export(module.exports, "RightArrow", () => $098bb57cf5e49424$export$6208675820d4cc50);
$parcel$export(module.exports, "FilmStripViewWrapper", () => $098bb57cf5e49424$export$d37eb83491863cbb);
$parcel$export(module.exports, "FilmStripListWrapper", () => $098bb57cf5e49424$export$4b7fe5339e3afada);
$parcel$export(module.exports, "FilmStripList", () => $098bb57cf5e49424$export$710ee13c74b7a1f0);
$parcel$export(module.exports, "FilmStripListItem", () => $098bb57cf5e49424$export$54cfc70c184c0713);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $hFKXd = parcelRequire("hFKXd");

var $7y1c0 = parcelRequire("7y1c0");

var $7iE7j = parcelRequire("7iE7j");
const $098bb57cf5e49424$export$924abd21043fc000 = (props)=>(0, $hFKXd.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7iE7j.ArrowLeftWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7y1c0.ArrowLeftWrapper), {
        ...props
    });
const $098bb57cf5e49424$export$a5ffe38c17bbc0a1 = (props)=>(0, $hFKXd.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7iE7j.ShadowRight), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7y1c0.ShadowRight), {
        ...props
    });
const $098bb57cf5e49424$export$abf07652016c7e56 = (props)=>(0, $hFKXd.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7iE7j.ArrowRightWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7y1c0.ArrowRightWrapper), {
        ...props
    });
const $098bb57cf5e49424$export$b39b1b86b48b621f = (props)=>(0, $hFKXd.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7iE7j.LeftArrow), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7y1c0.LeftArrow), {
        ...props
    });
const $098bb57cf5e49424$export$6208675820d4cc50 = (props)=>(0, $hFKXd.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7iE7j.RightArrow), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7y1c0.RightArrow), {
        ...props
    });
const $098bb57cf5e49424$export$d37eb83491863cbb = (props)=>(0, $hFKXd.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7iE7j.FilmStripViewWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7y1c0.FilmStripViewWrapper), {
        ...props
    });
const $098bb57cf5e49424$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>(0, $hFKXd.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7iE7j.FilmStripListWrapper), {
        ...props,
        ref: ref
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7y1c0.FilmStripListWrapper), {
        ...props,
        ref: ref
    }));
const $098bb57cf5e49424$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>(0, $hFKXd.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7iE7j.FilmStripList), {
        ...props,
        ref: ref
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7y1c0.FilmStripList), {
        ...props,
        ref: ref
    }));
const $098bb57cf5e49424$export$54cfc70c184c0713 = (props)=>(0, $hFKXd.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7iE7j.FilmStripListItem), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7y1c0.FilmStripListItem), {
        ...props
    });

});
parcelRegister("7y1c0", function(module, exports) {

$parcel$export(module.exports, "ArrowLeftWrapper", () => $1a410010765270de$export$924abd21043fc000);
$parcel$export(module.exports, "ShadowRight", () => $1a410010765270de$export$a5ffe38c17bbc0a1);
$parcel$export(module.exports, "ArrowRightWrapper", () => $1a410010765270de$export$abf07652016c7e56);
$parcel$export(module.exports, "LeftArrow", () => $1a410010765270de$export$b39b1b86b48b621f);
$parcel$export(module.exports, "RightArrow", () => $1a410010765270de$export$6208675820d4cc50);
$parcel$export(module.exports, "FilmStripViewWrapper", () => $1a410010765270de$export$d37eb83491863cbb);
$parcel$export(module.exports, "FilmStripListWrapper", () => $1a410010765270de$export$4b7fe5339e3afada);
$parcel$export(module.exports, "FilmStripList", () => $1a410010765270de$export$710ee13c74b7a1f0);
$parcel$export(module.exports, "FilmStripListItem", () => $1a410010765270de$export$54cfc70c184c0713);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $kLBiN = parcelRequire("kLBiN");

var $9stFr = parcelRequire("9stFr");

var $5HbQK = parcelRequire("5HbQK");

function $1a410010765270de$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1a410010765270de$var$filmStripViewStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'relative',
    padding: `${"var(--ds-space-025, 3px)"} 0`,
    borderRadius: '3px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover .arrow': {
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ellipsed-text': {
        whiteSpace: 'initial'
    }
});
const $1a410010765270de$var$filmStripListWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 'inherit',
    overflow: 'hidden',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-025, 3px)"}`
});
const $1a410010765270de$var$filmStripListStyles = {
    name: "fsf3or",
    styles: "margin:0;padding:0;transition-property:transform;transition-timing-function:cubic-bezier(0.77, 0, 0.175, 1);white-space:nowrap;display:inline-block"
};
const $1a410010765270de$var$filmStripListItemStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    listStyleType: 'none',
    margin: 0,
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':first-of-type': {
        paddingLeft: 0
    },
    display: 'inline-block',
    verticalAlign: 'middle',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 0
});
const $1a410010765270de$var$arrowWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $dbda9f692ace54dd$export$9fdfb749e33cdf97)})`,
    borderRadius: '100%',
    display: 'flex',
    cursor: 'pointer',
    transition: 'opacity 0.3s',
    boxShadow: "var(--ds-shadow-overlay, 0 1px 6px 0 rgba(0, 0, 0, 0.6))",
    color: "var(--ds-icon, black)",
    width: '30px',
    height: '30px',
    justifyContent: 'center',
    opacity: 0,
    '&:hover': {
        color: "var(--ds-text-subtle, black)",
        backgroundColor: `var(--ds-surface-overlay-hovered, ${(0, $dbda9f692ace54dd$export$1ce2d1575d444ceb)})`
    },
    '&:active': {
        color: `var(--ds-text-selected, ${(0, $dbda9f692ace54dd$export$b3de0ae08da2ce64)})`,
        backgroundColor: `var(--ds-background-selected, ${(0, $dbda9f692ace54dd$export$226de0355ed012f8)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    svg: {
        height: '30px',
        width: '20px'
    }
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $1a410010765270de$var$arrowLeftWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)($1a410010765270de$var$arrowWrapperStyles, "left:var(--ds-space-100, 8px);svg{padding-right:var(--ds-space-025, 2px);}");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $1a410010765270de$var$arrowRightWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)($1a410010765270de$var$arrowWrapperStyles, "right:var(--ds-space-100, 8px);svg{padding-left:var(--ds-space-025, 2px);}");
const $1a410010765270de$var$shadowStyles = {
    name: "atrqgo",
    styles: "position:absolute;z-index:10;height:100%;top:0;width:2px;background-color:var(--ds-border, rgba(0, 0, 0, 0.2))"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $1a410010765270de$var$shadowLeftStyles = /*#__PURE__*/ (0, $f8Sb3.css)($1a410010765270de$var$shadowStyles, "left:0;");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $1a410010765270de$var$shadowRightStyles = /*#__PURE__*/ (0, $f8Sb3.css)($1a410010765270de$var$shadowStyles, "right:0;");
const $1a410010765270de$var$ShadowLeft = ({ children: children })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $1a410010765270de$var$shadowLeftStyles
    }, children);
const $1a410010765270de$export$924abd21043fc000 = ({ children: children, onClick: onClick })=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlaskit/ui-styling-standard/no-classname-prop,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $1a410010765270de$var$arrowLeftWrapperStyles,
        className: "arrow",
        onClick: onClick
    }, children);
const $1a410010765270de$export$a5ffe38c17bbc0a1 = ({ children: children })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $1a410010765270de$var$shadowRightStyles
    }, children);
const $1a410010765270de$export$abf07652016c7e56 = ({ children: children, onClick: onClick })=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlaskit/ui-styling-standard/no-classname-prop,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $1a410010765270de$var$arrowRightWrapperStyles,
        className: "arrow",
        onClick: onClick
    }, children);
const $1a410010765270de$export$b39b1b86b48b621f = ({ onClick: onClick })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($1a410010765270de$var$ShadowLeft, null, /*#__PURE__*/ (0, $f8Sb3.jsx)($1a410010765270de$export$924abd21043fc000, {
        onClick: onClick
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kLBiN))), {
        color: "currentColor",
        spacing: "spacious",
        label: "left"
    })));
const $1a410010765270de$export$6208675820d4cc50 = ({ onClick: onClick })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($1a410010765270de$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, $f8Sb3.jsx)($1a410010765270de$export$abf07652016c7e56, {
        onClick: onClick
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9stFr))), {
        color: "currentColor",
        spacing: "spacious",
        label: "right"
    })));
const $1a410010765270de$export$d37eb83491863cbb = ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $1a410010765270de$var$filmStripViewStyles,
        "data-testid": dataTestId
    }, children);
const $1a410010765270de$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $1a410010765270de$var$filmStripListWrapperStyles,
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId
    }, children));
const $1a410010765270de$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("ul", {
        css: $1a410010765270de$var$filmStripListStyles,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, children));
const $1a410010765270de$export$54cfc70c184c0713 = ({ children: children, index: index })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("li", {
        css: $1a410010765270de$var$filmStripListItemStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $5HbQK.MediaFilmStripListItemSelector),
        "data-testid": "media-filmstrip-list-item",
        key: index
    }, children);

});
parcelRegister("kLBiN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::707984c4bf43fbcb724a560e605082a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1e521e46a4bbca9$var$_react = $f1e521e46a4bbca9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f1e521e46a4bbca9$var$_arrowLeft = $f1e521e46a4bbca9$var$_interopRequireDefault((parcelRequire("aGUgk")));

var $f1e521e46a4bbca9$var$_arrowLeft2 = $f1e521e46a4bbca9$var$_interopRequireDefault((parcelRequire("7QNFc")));
function $f1e521e46a4bbca9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1e521e46a4bbca9$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $f1e521e46a4bbca9$var$_react.default.createElement($f1e521e46a4bbca9$var$_arrowLeft.default, Object.assign({
        LEGACY_fallbackIcon: $f1e521e46a4bbca9$var$_arrowLeft2.default
    }, props));
$f1e521e46a4bbca9$var$ArrowLeftIcon.Name = 'ArrowLeftIconMigration';
var $f1e521e46a4bbca9$var$_default = module.exports.default = $f1e521e46a4bbca9$var$ArrowLeftIcon;

});
parcelRegister("aGUgk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efa63c6a59a6ee993a0458e40fc93a18>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c897826f4df3586$var$_react = $7c897826f4df3586$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7c897826f4df3586$var$_baseNew = $7c897826f4df3586$var$_interopRequireDefault((parcelRequire("9ogAd")));
function $7c897826f4df3586$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c897826f4df3586$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $7c897826f4df3586$var$_react.default.createElement($7c897826f4df3586$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$7c897826f4df3586$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $7c897826f4df3586$var$_default = module.exports.default = $7c897826f4df3586$var$ArrowLeftIcon;

});

parcelRegister("7QNFc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5b73e9e2f97dcc64$var$_react = $5b73e9e2f97dcc64$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");

var $5b73e9e2f97dcc64$var$_arrowLeft = $5b73e9e2f97dcc64$var$_interopRequireDefault((parcelRequire("aGUgk")));
function $5b73e9e2f97dcc64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5b73e9e2f97dcc64$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $5b73e9e2f97dcc64$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.207 5.793a1 1 0 0 1 0 1.414L8.414 11H18a1 1 0 1 1 0 2H8.414l3.793 3.793a1 1 0 1 1-1.415 1.414l-5.499-5.5A1 1 0 0 1 5 12.028v-.057a1 1 0 0 1 .293-.678l5.499-5.5a1 1 0 0 1 1.415 0" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $5b73e9e2f97dcc64$var$_arrowLeft.default
    }));
$5b73e9e2f97dcc64$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $5b73e9e2f97dcc64$var$_default = module.exports.default = $5b73e9e2f97dcc64$var$ArrowLeftIcon;

});


parcelRegister("9stFr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::101a51255f7076752a2af1f3fc652adc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e2dbde88a9fc647$var$_react = $6e2dbde88a9fc647$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6e2dbde88a9fc647$var$_arrowRight = $6e2dbde88a9fc647$var$_interopRequireDefault((parcelRequire("44F5d")));

var $6e2dbde88a9fc647$var$_arrowRight2 = $6e2dbde88a9fc647$var$_interopRequireDefault((parcelRequire("hMgiQ")));
function $6e2dbde88a9fc647$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6e2dbde88a9fc647$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $6e2dbde88a9fc647$var$_react.default.createElement($6e2dbde88a9fc647$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $6e2dbde88a9fc647$var$_arrowRight2.default
    }, props));
$6e2dbde88a9fc647$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $6e2dbde88a9fc647$var$_default = module.exports.default = $6e2dbde88a9fc647$var$ArrowRightIcon;

});
parcelRegister("44F5d", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f776767afd249a7$var$_react = $2f776767afd249a7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2f776767afd249a7$var$_baseNew = $2f776767afd249a7$var$_interopRequireDefault((parcelRequire("9ogAd")));
function $2f776767afd249a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2f776767afd249a7$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $2f776767afd249a7$var$_react.default.createElement($2f776767afd249a7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$2f776767afd249a7$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $2f776767afd249a7$var$_default = module.exports.default = $2f776767afd249a7$var$ArrowRightIcon;

});

parcelRegister("hMgiQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf1390ce746b6448$var$_react = $cf1390ce746b6448$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");

var $cf1390ce746b6448$var$_arrowRight = $cf1390ce746b6448$var$_interopRequireDefault((parcelRequire("44F5d")));
function $cf1390ce746b6448$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cf1390ce746b6448$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $cf1390ce746b6448$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $cf1390ce746b6448$var$_arrowRight.default
    }));
$cf1390ce746b6448$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $cf1390ce746b6448$var$_default = module.exports.default = $cf1390ce746b6448$var$ArrowRightIcon;

});



parcelRegister("7iE7j", function(module, exports) {

$parcel$export(module.exports, "ArrowLeftWrapper", () => $8f0f33ac04b959b4$export$924abd21043fc000);
$parcel$export(module.exports, "ShadowRight", () => $8f0f33ac04b959b4$export$a5ffe38c17bbc0a1);
$parcel$export(module.exports, "ArrowRightWrapper", () => $8f0f33ac04b959b4$export$abf07652016c7e56);
$parcel$export(module.exports, "LeftArrow", () => $8f0f33ac04b959b4$export$b39b1b86b48b621f);
$parcel$export(module.exports, "RightArrow", () => $8f0f33ac04b959b4$export$6208675820d4cc50);
$parcel$export(module.exports, "FilmStripViewWrapper", () => $8f0f33ac04b959b4$export$d37eb83491863cbb);
$parcel$export(module.exports, "FilmStripListWrapper", () => $8f0f33ac04b959b4$export$4b7fe5339e3afada);
$parcel$export(module.exports, "FilmStripList", () => $8f0f33ac04b959b4$export$710ee13c74b7a1f0);
$parcel$export(module.exports, "FilmStripListItem", () => $8f0f33ac04b959b4$export$54cfc70c184c0713);
/* wrappers-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $kLBiN = parcelRequire("kLBiN");

var $9stFr = parcelRequire("9stFr");

var $5HbQK = parcelRequire("5HbQK");
const $8f0f33ac04b959b4$var$filmStripViewStyles = null;
const $8f0f33ac04b959b4$var$filmStripListWrapperStyles = null;
const $8f0f33ac04b959b4$var$filmStripListStyles = null;
const $8f0f33ac04b959b4$var$filmStripListItemStyles = null;
const $8f0f33ac04b959b4$var$arrowWrapperStyles = null;
const $8f0f33ac04b959b4$var$arrowLeftWrapperStyles = null;
const $8f0f33ac04b959b4$var$arrowRightWrapperStyles = null;
const $8f0f33ac04b959b4$var$shadowStyles = null;
const $8f0f33ac04b959b4$var$shadowLeftStyles = null;
const $8f0f33ac04b959b4$var$shadowRightStyles = null;
const $8f0f33ac04b959b4$var$ShadowLeft = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhkbq8d",
            "_1ltvidpf"
        ]),
        children: children
    });
const $8f0f33ac04b959b4$export$924abd21043fc000 = ({ children: children, onClick: onClick })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_2rko1osq _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhkexu1 _1e0c1txw _80omtlke _16qs1wkk _syazgpis _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3lyvy _irr3376n _9h8h1ldt _1di629zg",
            "_1ltvu2gc _uhasv77o",
            "arrow"
        ]),
        onClick: onClick,
        children: children
    });
const $8f0f33ac04b959b4$export$a5ffe38c17bbc0a1 = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhkbq8d",
            "_1xi2idpf"
        ]),
        children: children
    });
const $8f0f33ac04b959b4$export$abf07652016c7e56 = ({ children: children, onClick: onClick })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_2rko1osq _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhkexu1 _1e0c1txw _80omtlke _16qs1wkk _syazgpis _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3lyvy _irr3376n _9h8h1ldt _1di629zg",
            "_1xi2u2gc _7wy9v77o",
            "arrow"
        ]),
        onClick: onClick,
        children: children
    });
const $8f0f33ac04b959b4$export$b39b1b86b48b621f = ({ onClick: onClick })=>/*#__PURE__*/ (0, $2OMIu.jsx)($8f0f33ac04b959b4$var$ShadowLeft, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($8f0f33ac04b959b4$export$924abd21043fc000, {
            onClick: onClick,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kLBiN))), {
                color: "currentColor",
                spacing: "spacious",
                label: "left"
            })
        })
    });
const $8f0f33ac04b959b4$export$6208675820d4cc50 = ({ onClick: onClick })=>/*#__PURE__*/ (0, $2OMIu.jsx)($8f0f33ac04b959b4$export$a5ffe38c17bbc0a1, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($8f0f33ac04b959b4$export$abf07652016c7e56, {
            onClick: onClick,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9stFr))), {
                color: "currentColor",
                spacing: "spacious",
                label: "right"
            })
        })
    });
const $8f0f33ac04b959b4$export$d37eb83491863cbb = ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": dataTestId,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _kqswh2mm _ca0q1ysw _u5f3idpf _n3td1ysw _19bvidpf _1yqxkb7n _1ajs4jg8"
        ]),
        children: children
    });
const $8f0f33ac04b959b4$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bsb1kw7 _ca0qv77o _u5f31ysw _n3tdv77o _19bv1ysw"
        ]),
        children: children
    }));
const $8f0f33ac04b959b4$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _k8m01e03 _6fl41kli _o5721q9c _1e0c1o8l"
        ]),
        children: children
    }));
const $8f0f33ac04b959b4$export$54cfc70c184c0713 = ({ children: children, index: index })=>/*#__PURE__*/ (0, $2OMIu.jsx)("li", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2mzuglyw _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1e0c1o8l _s7n4nkob _1wybidpf _1lhcidpf",
            (0, $5HbQK.MediaFilmStripListItemSelector)
        ]),
        "data-testid": "media-filmstrip-list-item",
        children: children
    }, index);

});




parcelRegister("i9fvx", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5b17c2affb45cc4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5cBJL = parcelRequire("5cBJL");

var $1pQx1 = parcelRequire("1pQx1");

var $bcBme = parcelRequire("bcBme");

var $fOcgu = parcelRequire("fOcgu");
var $4sicK = parcelRequire("4sicK");

var $8EjzJ = parcelRequire("8EjzJ");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $3yOzf = parcelRequire("3yOzf");

var $2Dcc2 = parcelRequire("2Dcc2");

var $fRIYS = parcelRequire("fRIYS");

var $3j5o6 = parcelRequire("3j5o6");

var $idZJp = parcelRequire("idZJp");
const $f5b17c2affb45cc4$var$RenderMediaInline = ({ rendererAppearance: rendererAppearance, clipboardAttrs: clipboardAttrs, collection: collectionName, eventHandlers: eventHandlers, identifier: identifier })=>{
    const [contextIdentifier, setContextIdentifier] = (0, $5uXOq.useState)();
    const [fileState, setFileState] = (0, $5uXOq.useState)();
    const mediaClient = (0, $5uXOq.useContext)((0, $4sicK.MediaClientContext));
    const contextIdentifierProvider = (0, $1pQx1.useProvider)('contextIdentifierProvider');
    (0, $5uXOq.useEffect)(()=>{
        if (contextIdentifierProvider) contextIdentifierProvider.then((resolvedContextID)=>{
            if (contextIdentifier !== resolvedContextID) setContextIdentifier(resolvedContextID);
        });
    }, [
        contextIdentifier,
        contextIdentifierProvider
    ]);
    const updateFileState = (0, $5uXOq.useCallback)(async (id)=>{
        const options = {
            collectionName: collectionName
        };
        try {
            if (mediaClient) {
                const fileState = await mediaClient.file.getCurrentState(id, options);
                setFileState(fileState);
            }
        } catch (error) {
        // do not set state on error
        }
    }, [
        collectionName,
        mediaClient
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const { id: id } = identifier;
        const nodeIsInCache = id && (0, $3yOzf.mediaIdentifierMap).has(id);
        if (!nodeIsInCache) (0, $3yOzf.mediaIdentifierMap).set(identifier.id, {
            ...identifier,
            collectionName: collectionName
        });
        return ()=>{
            (0, $3yOzf.mediaIdentifierMap).delete(id);
        };
    }, [
        identifier,
        collectionName
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const { id: id } = clipboardAttrs;
        id && updateFileState(id);
    }, [
        contextIdentifier,
        clipboardAttrs,
        updateFileState
    ]);
    /*
	 * Only show the loading view if the media client is not ready
	 * prevents calling the media API before the provider is ready
	 */ if (!mediaClient) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8EjzJ.MediaInlineCardLoadingView), {
        message: "",
        isSelected: false
    });
    const handleMediaInlineClick = (result)=>{
        if (eventHandlers?.media?.onClick) eventHandlers?.media?.onClick(result);
    };
    const shouldOpenMediaViewer = true;
    const shouldDisplayToolTip = true;
    const { id: id, collection: collection } = clipboardAttrs;
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...(0, $3yOzf.getClipboardAttrs)({
            id: id,
            collection: collection,
            contextIdentifierProvider: contextIdentifier,
            fileState: fileState
        }),
        "data-node-type": "mediaInline",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bcBme.default), {
            identifier: identifier,
            onClick: handleMediaInlineClick,
            shouldOpenMediaViewer: shouldOpenMediaViewer,
            shouldDisplayToolTip: shouldDisplayToolTip,
            mediaClientConfig: mediaClient.mediaClientConfig,
            mediaViewerItems: Array.from((0, $3yOzf.mediaIdentifierMap).values())
        })
    }));
};
const $f5b17c2affb45cc4$var$MediaInline = (props)=>{
    const { collection: collection, id: id, intl: intl, rendererAppearance: rendererAppearance, featureFlags: featureFlags, type: fileType, alt: alt, width: width, height: height, marks: marks, ssr: ssr } = props;
    const clipboardAttrs = {
        id: id,
        collection: collection
    };
    const identifier = {
        id: id,
        mediaItemType: 'file',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        collectionName: collection
    };
    const mediaClient = (0, $5uXOq.useContext)((0, $4sicK.MediaClientContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2Dcc2.useAnalyticsEvents)();
    if (fileType === 'image') {
        const hasLinkMark = marks?.find((mark)=>mark.type.name === 'link');
        const borderMark = marks?.find((mark)=>mark?.type.name === 'border');
        const borderColor = borderMark?.attrs.color ?? '';
        const borderSize = borderMark?.attrs.size ?? 0;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fRIYS.ErrorBoundary), {
            component: (0, $3j5o6.ACTION_SUBJECT).RENDERER,
            componentId: (0, $idZJp.ACTION_SUBJECT_ID).MEDIA_INLINE_IMAGE,
            createAnalyticsEvent: createAnalyticsEvent,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5cBJL.MediaInlineImageCard), {
                mediaClient: ssr?.config ? (0, $fOcgu.getMediaClient)(ssr.config) : mediaClient,
                identifier: identifier,
                alt: alt,
                width: width,
                height: height,
                ssr: ssr,
                border: {
                    borderSize: borderSize,
                    borderColor: borderColor
                },
                serializeDataAttrs: true,
                shouldOpenMediaViewer: !hasLinkMark
            })
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)($f5b17c2affb45cc4$var$RenderMediaInline, {
        identifier: identifier,
        clipboardAttrs: clipboardAttrs,
        eventHandlers: props.eventHandlers,
        rendererAppearance: rendererAppearance,
        intl: intl,
        collection: collection,
        featureFlags: featureFlags
    });
};
var $f5b17c2affb45cc4$export$2e2bcd8739ae039 = (0, $8RXs9.default)($f5b17c2affb45cc4$var$MediaInline);

});
parcelRegister("5cBJL", function(module, exports) {

$parcel$export(module.exports, "MediaInlineImageCard", () => $544ea345c39247f3$export$fca833ae4278270f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $7nsd3 = parcelRequire("7nsd3");

var $i5FdW = parcelRequire("i5FdW");
var $8RXs9 = parcelRequire("8RXs9");

var $2Dcc2 = parcelRequire("2Dcc2");

var $cMFyO = parcelRequire("cMFyO");
var $aGLuG = parcelRequire("aGLuG");

var $5j4YJ = parcelRequire("5j4YJ");

var $4sicK = parcelRequire("4sicK");

var $8aaiS = parcelRequire("8aaiS");

var $2qH5P = parcelRequire("2qH5P");

var $hygIE = parcelRequire("hygIE");

var $3HMUH = parcelRequire("3HMUH");

var $36XXg = parcelRequire("36XXg");

var $1V0Bs = parcelRequire("1V0Bs");

var $8DPuN = parcelRequire("8DPuN");

var $1jG3J = parcelRequire("1jG3J");
const $544ea345c39247f3$export$5d2cd1bea8591ba3 = ({ mediaClient: mediaClient, identifier: identifier, isSelected: isSelected, intl: intl, alt: alt, isLazy: isLazy, width: width, height: height, border: border, ssr: ssr, serializeDataAttrs: serializeDataAttrs, shouldOpenMediaViewer: shouldOpenMediaViewer, isViewOnly: isViewOnly })=>{
    const [fileState, setFileState] = (0, $5uXOq.useState)();
    const [subscribeError, setSubscribeError] = (0, $5uXOq.useState)();
    const [isFailedEventSent, setIsFailedEventSent] = (0, $5uXOq.useState)(false);
    const [isSucceededEventSent, setIsSucceededEventSent] = (0, $5uXOq.useState)(false);
    const [isMediaViewerVisible, setMediaViewerVisible] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = intl || (0, $i5FdW.createIntl)({
        locale: 'en'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2Dcc2.useAnalyticsEvents)();
    const fireFailedOperationalEvent = (error = new (0, $aGLuG.MediaCardError)('missing-error-data'), failReason)=>{
        if (!isFailedEventSent && fileState) {
            setIsFailedEventSent(true);
            (0, $cMFyO.fireFailedOperationalEvent)(fileState, error, failReason, createAnalyticsEvent);
        }
    };
    const fireSucceededOperationalEvent = ()=>{
        if (!isSucceededEventSent && fileState) {
            setIsSucceededEventSent(true);
            (0, $cMFyO.fireSucceededOperationalEvent)(fileState, createAnalyticsEvent);
        }
    };
    (0, $5uXOq.useEffect)(()=>{
        if (mediaClient) {
            const subscription = mediaClient.file.getFileState(identifier.id, {
                collectionName: identifier.collectionName
            }).subscribe({
                next: (fileState)=>{
                    setFileState(fileState);
                    setSubscribeError(undefined);
                },
                error: (e)=>{
                    setSubscribeError(e);
                }
            });
            return ()=>{
                subscription.unsubscribe();
            };
        }
    }, [
        identifier,
        mediaClient
    ]);
    const content = (dimensions)=>{
        if (!mediaClient) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1jG3J.InlineImageCardLoadingView), null);
        if (!ssr) {
            if (subscribeError) {
                const isUploading = fileState?.status === 'uploading';
                const errorMessage = isUploading ? (0, $hygIE.messages).failedToUpload : (0, $hygIE.messages).unableToLoadContent;
                const errorReason = fileState?.status === 'uploading' ? 'upload' : 'metadata-fetch';
                fireFailedOperationalEvent(new (0, $aGLuG.MediaCardError)(errorReason, subscribeError));
                return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8DPuN.InlineImageCardErrorView), {
                    message: formatMessage(errorMessage)
                });
            }
            if (!fileState || fileState?.status === 'uploading') return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1jG3J.InlineImageCardLoadingView), null);
            if (fileState.status === 'error') {
                fireFailedOperationalEvent(new (0, $aGLuG.MediaCardError)('error-file-state', new Error(fileState.message)));
                return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8DPuN.InlineImageCardErrorView), {
                    message: formatMessage((0, $hygIE.messages).unableToLoadContent)
                });
            } else if (fileState.status === 'failed-processing') {
                fireFailedOperationalEvent(undefined, 'failed-processing');
                return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8DPuN.InlineImageCardErrorView), {
                    message: formatMessage((0, $hygIE.messages).unableToLoadContent)
                });
            } else if (!fileState.name) {
                fireFailedOperationalEvent(new (0, $aGLuG.MediaCardError)('metadata-fetch', new (0, $5j4YJ.FileFetcherError)('emptyFileName', {
                    id: fileState.id
                })));
                return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8DPuN.InlineImageCardErrorView), {
                    message: formatMessage((0, $hygIE.messages).unableToLoadContent)
                });
            }
            if (fileState.status === 'processed') fireSucceededOperationalEvent();
        }
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4sicK.MediaClientContext).Provider, {
            value: mediaClient
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $36XXg.InlineImageCard), {
            dimensions: dimensions,
            identifier: identifier,
            renderError: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8DPuN.InlineImageCardErrorView), {
                    message: formatMessage((0, $hygIE.messages).unableToLoadContent)
                }),
            alt: alt,
            ssr: ssr?.mode,
            isLazy: isLazy,
            crop: true,
            stretch: false
        }));
    };
    const aspectRatio = (0, $5uXOq.useMemo)(()=>width && height ? width / height : undefined, [
        width,
        height
    ]);
    /**
   * scaledDimensions is used to define the correct media size fetched from media service
   * inline images will only ever be rendered at a maximum height of H1 and so scaled dimensions
   * will only ever return a width and height where the height has a maximum height of H1
   */ const scaledDimension = (0, $5uXOq.useMemo)(()=>{
        if (!width || !height || !aspectRatio) return {
            width: width,
            height: height
        };
        return {
            width: Math.round(aspectRatio * (0, $3HMUH.referenceHeights)['h1']),
            height: (0, $3HMUH.referenceHeights)['h1']
        };
    }, [
        width,
        height,
        aspectRatio
    ]);
    const htmlAttributes = (0, $5uXOq.useMemo)(()=>{
        if (serializeDataAttrs) {
            const resolvedAttrs = fileState && fileState.status !== 'error' ? {
                'data-file-size': fileState.size,
                'data-file-mime-type': fileState.mimeType,
                'data-file-name': fileState.name
            } : {};
            return {
                'data-type': 'image',
                'data-node-type': 'mediaInline',
                'data-id': identifier.id,
                'data-collection': identifier.collectionName,
                'data-width': width,
                'data-height': height,
                'data-alt': alt,
                ...resolvedAttrs
            };
        }
        return {};
    }, [
        alt,
        fileState,
        height,
        identifier,
        width,
        serializeDataAttrs
    ]);
    const onMediaInlineImageClick = (0, $5uXOq.useCallback)((e)=>{
        if (shouldOpenMediaViewer) setMediaViewerVisible(true);
        // In edit mode (node content wrapper has contenteditable set to true), link redirection is disabled by default
        // We need to call "stopPropagation" here in order to prevent in editor view mode, the browser from navigating to
        // another URL if the media node is wrapped in a link mark.
        if (isViewOnly && (0, $2qH5P.editorExperiment)('platform_editor_controls', 'variant1')) e.preventDefault();
    }, [
        shouldOpenMediaViewer,
        isViewOnly
    ]);
    const onMediaInlinePreviewClose = (0, $5uXOq.useCallback)(()=>{
        setMediaViewerVisible(false);
    }, []);
    const mediaViewer = (0, $5uXOq.useMemo)(()=>{
        if (isMediaViewerVisible && mediaClient?.mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8aaiS.default), {
            collectionName: identifier.collectionName || '',
            items: [
                identifier
            ],
            mediaClientConfig: mediaClient?.mediaClientConfig,
            selectedItem: identifier,
            onClose: onMediaInlinePreviewClose
        }), document.body);
        return null;
    }, [
        identifier,
        isMediaViewerVisible,
        mediaClient?.mediaClientConfig,
        onMediaInlinePreviewClose
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1V0Bs.InlineImageWrapper), {
        isSelected: isSelected,
        aspectRatio: aspectRatio,
        borderColor: border?.borderColor,
        borderSize: border?.borderSize,
        htmlAttrs: htmlAttributes,
        onClick: onMediaInlineImageClick
    }, content(scaledDimension)), mediaViewer);
};
const $544ea345c39247f3$export$fca833ae4278270f = (0, $8RXs9.default)($544ea345c39247f3$export$5d2cd1bea8591ba3, {
    enforceContext: false
});

});
parcelRegister("cMFyO", function(module, exports) {

$parcel$export(module.exports, "getSucceededStatusPayload", () => $7abf4b2f83b38e59$export$95e48cf5f4b392a4);
$parcel$export(module.exports, "getErrorStatusPayload", () => $7abf4b2f83b38e59$export$b37f976ad373d2e0);
$parcel$export(module.exports, "getFailedProcessingStatusPayload", () => $7abf4b2f83b38e59$export$d0b5daf3b6a26055);
$parcel$export(module.exports, "fireFailedOperationalEvent", () => $7abf4b2f83b38e59$export$d66a74eca3334206);
$parcel$export(module.exports, "fireSucceededOperationalEvent", () => $7abf4b2f83b38e59$export$3bc90882cb04fda4);

var $Zs10K = parcelRequire("Zs10K");

var $aGLuG = parcelRequire("aGLuG");
const $7abf4b2f83b38e59$export$95e48cf5f4b392a4 = (fileState)=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'success',
            fileAttributes: {
                fileId: fileState?.id || '',
                fileSize: fileState?.size,
                fileMediatype: fileState?.mediaType,
                fileMimetype: fileState?.mimeType,
                fileStatus: fileState?.status
            }
        }
    };
};
const $7abf4b2f83b38e59$export$b37f976ad373d2e0 = (fileId, error, fileState)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId,
                fileStatus: fileState?.status
            },
            ...(0, $Zs10K.extractErrorInfo)(error)
        }
    };
};
const $7abf4b2f83b38e59$export$d0b5daf3b6a26055 = (fileId, fileState)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId,
                fileStatus: fileState?.status
            },
            failReason: 'failed-processing'
        }
    };
};
const $7abf4b2f83b38e59$export$d66a74eca3334206 = (fileState, error = new (0, $aGLuG.MediaCardError)('missing-error-data'), failReason, createAnalyticsEvent)=>{
    const payload = failReason ? $7abf4b2f83b38e59$export$d0b5daf3b6a26055(fileState?.id || 'unknown-id', fileState) : $7abf4b2f83b38e59$export$b37f976ad373d2e0(fileState?.id || 'unknown-id', error, fileState);
    (0, $Zs10K.fireMediaCardEvent)(payload, createAnalyticsEvent);
};
const $7abf4b2f83b38e59$export$3bc90882cb04fda4 = (fileState, createAnalyticsEvent)=>{
    const payload = $7abf4b2f83b38e59$export$95e48cf5f4b392a4(fileState);
    (0, $Zs10K.fireMediaCardEvent)(payload, createAnalyticsEvent);
};

});
parcelRegister("Zs10K", function(module, exports) {

$parcel$export(module.exports, "getRenderSucceededEventPayload", () => $08347e65bef1a3f8$export$4006df18b24ad838);
$parcel$export(module.exports, "getDownloadSucceededEventPayload", () => $08347e65bef1a3f8$export$30f484b360b0efe8);
$parcel$export(module.exports, "getRenderErrorRequestMetadata", () => $08347e65bef1a3f8$export$1a2ec9b4a3a99d5e);
$parcel$export(module.exports, "extractErrorInfo", () => $08347e65bef1a3f8$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "getRenderErrorEventPayload", () => $08347e65bef1a3f8$export$ea8620de23983ca1);
$parcel$export(module.exports, "getDownloadFailedEventPayload", () => $08347e65bef1a3f8$export$bd721ce2bd18db4c);
$parcel$export(module.exports, "getErrorEventPayload", () => $08347e65bef1a3f8$export$d3944464e6ecd3d4);
$parcel$export(module.exports, "getRenderFailedFileStatusPayload", () => $08347e65bef1a3f8$export$116834b91a04bd49);
$parcel$export(module.exports, "fireMediaCardEvent", () => $08347e65bef1a3f8$export$60729f3fb03dcecc);
$parcel$export(module.exports, "createAndFireMediaCardEvent", () => $08347e65bef1a3f8$export$4d33ada3618f7626);

var $esqLm = parcelRequire("esqLm");

var $6EHjw = parcelRequire("6EHjw");

var $iBouS = parcelRequire("iBouS");
const $08347e65bef1a3f8$export$31786e85bf49987b = (metadata, fileStatus)=>({
        fileMediatype: metadata.mediaType,
        fileMimetype: metadata.mimeType,
        fileId: metadata.id,
        fileSize: metadata.size,
        fileStatus: fileStatus
    });
const $08347e65bef1a3f8$export$4006df18b24ad838 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'success',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
const $08347e65bef1a3f8$export$30f484b360b0efe8 = (fileAttributes, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardDownload',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            status: 'success',
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
const $08347e65bef1a3f8$export$81661af638dd90bc = (cardPreviewAttributes)=>({
        eventType: 'operational',
        action: 'cache-hit',
        actionSubject: 'mediaCardCache',
        attributes: {
            cardPreviewAttributes: cardPreviewAttributes
        }
    });
const $08347e65bef1a3f8$export$62c7b749808f1b8f = (cardPreviewAttributes)=>({
        eventType: 'operational',
        action: 'Remote-success',
        actionSubject: 'mediaCardCache',
        attributes: {
            cardPreviewAttributes: cardPreviewAttributes
        }
    });
const $08347e65bef1a3f8$export$c9d988402f74bba = (fileAttributes, performanceAttributes)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'external-uri'
        }
    });
const $08347e65bef1a3f8$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $08347e65bef1a3f8$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $esqLm.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $08347e65bef1a3f8$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $esqLm.isCommonMediaClientError)(secondaryError) && secondaryError.innerError?.message) return secondaryError.innerError?.message;
    if (secondaryError instanceof Error) return secondaryError.message;
    return error.message;
};
const $08347e65bef1a3f8$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $esqLm.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $08347e65bef1a3f8$export$1a2ec9b4a3a99d5e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $esqLm.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata;
};
const $08347e65bef1a3f8$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $08347e65bef1a3f8$export$4af9d71992e89714(error),
        error: $08347e65bef1a3f8$export$88c61dcad53762da(error),
        errorDetail: $08347e65bef1a3f8$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $08347e65bef1a3f8$export$29aa614726672b2e(error)
    };
};
const $08347e65bef1a3f8$export$ea8620de23983ca1 = (fileAttributes, performanceAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            ...$08347e65bef1a3f8$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $08347e65bef1a3f8$export$1a2ec9b4a3a99d5e(error),
            ssrReliability: ssrReliability,
            traceContext: traceContext
        }
    });
const $08347e65bef1a3f8$export$bd721ce2bd18db4c = (fileAttributes, error, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardDownload',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            status: 'fail',
            ...$08347e65bef1a3f8$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $08347e65bef1a3f8$export$1a2ec9b4a3a99d5e(error),
            traceContext: traceContext
        }
    });
const $08347e65bef1a3f8$export$d3944464e6ecd3d4 = (cardStatus, fileAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'nonCriticalFail',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            status: 'fail',
            ...$08347e65bef1a3f8$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $08347e65bef1a3f8$export$1a2ec9b4a3a99d5e(error),
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            cardStatus: cardStatus
        }
    });
const $08347e65bef1a3f8$export$116834b91a04bd49 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'failed-processing',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
function $08347e65bef1a3f8$export$60729f3fb03dcecc(payload, createAnalyticsEvent) {
    if (createAnalyticsEvent) {
        const event = createAnalyticsEvent((0, $6EHjw.sanitiseAnalyticsPayload)(payload));
        event.fire((0, $a1e01e0f42033026$export$ec1779cb96554e1));
    }
}
const $08347e65bef1a3f8$export$4d33ada3618f7626 = (payload)=>{
    return (0, $iBouS.default)((0, $a1e01e0f42033026$export$ec1779cb96554e1))((0, $6EHjw.sanitiseAnalyticsPayload)(payload));
};

});
const $a1e01e0f42033026$export$ec1779cb96554e1 = 'media';

parcelRegister("6EHjw", function(module, exports) {

$parcel$export(module.exports, "sanitiseAnalyticsPayload", () => $171deea172d62714$export$e24d38cbdf73bc1a);

var $6CZ6k = parcelRequire("6CZ6k");

var $86xFr = parcelRequire("86xFr");
const $171deea172d62714$var$sanitiseFileId = (draft)=>{
    const { fileId: fileId } = draft.attributes.fileAttributes;
    draft.attributes.fileAttributes.fileId = fileId === 'external-image' || (0, (/*@__PURE__*/$parcel$interopDefault($6CZ6k)))(fileId) ? fileId : 'INVALID_FILE_ID';
};
const $171deea172d62714$var$hasFileAttributesWithFileId = (payload)=>'attributes' in payload && !!payload.attributes && typeof payload.attributes === 'object' && 'fileAttributes' in payload.attributes && !!payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes === 'object' && 'fileId' in payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes.fileId === 'string';
const $171deea172d62714$export$e24d38cbdf73bc1a = (payload)=>$171deea172d62714$var$hasFileAttributesWithFileId(payload) ? (0, $86xFr.produce)(payload, $171deea172d62714$var$sanitiseFileId) : payload;

});


parcelRegister("aGLuG", function(module, exports) {

$parcel$export(module.exports, "MediaCardError", () => $c2bfc54019dce7f4$export$ec8d022824f41295);
$parcel$export(module.exports, "ImageLoadError", () => $c2bfc54019dce7f4$export$d0a45ab59b4606b);
$parcel$export(module.exports, "isUploadError", () => $c2bfc54019dce7f4$export$11f9f5835c5b9a04);
class $c2bfc54019dce7f4$export$ec8d022824f41295 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $c2bfc54019dce7f4$export$2c035820a31723e extends $c2bfc54019dce7f4$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $c2bfc54019dce7f4$export$10ab445310d30114 extends $c2bfc54019dce7f4$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $c2bfc54019dce7f4$export$18e89b7e50818288 extends $c2bfc54019dce7f4$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $c2bfc54019dce7f4$export$921ab4548acefaa4 = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $c2bfc54019dce7f4$export$d0a45ab59b4606b extends $c2bfc54019dce7f4$export$ec8d022824f41295 {
    constructor(source){
        super($c2bfc54019dce7f4$export$921ab4548acefaa4(source));
    }
}
function $c2bfc54019dce7f4$export$36b43e3dd9a92(err) {
    return err instanceof $c2bfc54019dce7f4$export$ec8d022824f41295;
}
const $c2bfc54019dce7f4$export$b380593ba3516c6f = (err)=>err instanceof $c2bfc54019dce7f4$export$2c035820a31723e;
const $c2bfc54019dce7f4$export$e1d87830b3784f94 = (err)=>err instanceof $c2bfc54019dce7f4$export$10ab445310d30114;
const $c2bfc54019dce7f4$export$443aeb298d35d79d = (err)=>$c2bfc54019dce7f4$export$36b43e3dd9a92(err) && err.primaryReason === 'local-preview-unsupported';
function $c2bfc54019dce7f4$export$f00bb5a138da22e1(err) {
    return err instanceof $c2bfc54019dce7f4$export$d0a45ab59b4606b;
}
const $c2bfc54019dce7f4$export$4536ca0b68b4caf9 = (primaryReason, error, updatePrimaryReason)=>{
    if ($c2bfc54019dce7f4$export$36b43e3dd9a92(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $c2bfc54019dce7f4$export$ec8d022824f41295(primaryReason, error.secondaryError);
        return error;
    }
    return new $c2bfc54019dce7f4$export$ec8d022824f41295(primaryReason, error);
};
const $c2bfc54019dce7f4$export$11f9f5835c5b9a04 = (error)=>error && error.primaryReason === 'upload';

});


parcelRegister("8aaiS", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d8b7ef202a79b22$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $hLnwJ = parcelRequire("hLnwJ");

var $eh6yN = parcelRequire("eh6yN");

const $1d8b7ef202a79b22$var$MediaViewer = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("iEuu5")).then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
function $1d8b7ef202a79b22$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hLnwJ.default), {}),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eh6yN.MediaViewerPortal), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($1d8b7ef202a79b22$var$MediaViewer, {
                ...props
            })
        })
    });
}

});
parcelRegister("hLnwJ", function(module, exports) {

$parcel$export(module.exports, "headerAndSidebarBackgroundColor", () => $c875b0b11117037d$export$442b7be89436c101);
$parcel$export(module.exports, "default", () => $c875b0b11117037d$export$2e2bcd8739ae039);
/**
 * Module loaded synchronously.
 * Must minimise dependencies.
 * */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $iGe6P = parcelRequire("iGe6P");

var $5gBas = parcelRequire("5gBas");
const $c875b0b11117037d$export$442b7be89436c101 = '#101214';
const $c875b0b11117037d$var$ModalSpinner = ()=>{
    const { colorMode: colorMode } = (0, $5gBas.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iGe6P.default), {
        blankedColor: $c875b0b11117037d$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $c875b0b11117037d$export$2e2bcd8739ae039 = $c875b0b11117037d$var$ModalSpinner;

});
parcelRegister("iGe6P", function(module, exports) {

$parcel$export(module.exports, "default", () => $14ba1267a01a0e96$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $i9nOE = parcelRequire("i9nOE");

var $kkbmD = parcelRequire("kkbmD");

var $hFKXd = parcelRequire("hFKXd");
const $14ba1267a01a0e96$var$ModalSpinner = (props)=>(0, $hFKXd.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kkbmD.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i9nOE.default), {
        ...props
    });
var $14ba1267a01a0e96$export$2e2bcd8739ae039 = $14ba1267a01a0e96$var$ModalSpinner;

});
parcelRegister("i9nOE", function(module, exports) {

$parcel$export(module.exports, "default", () => $90475f1017e2136e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1wToE = parcelRequire("1wToE");

var $dyckQ = parcelRequire("dyckQ");

var $bWGt6 = parcelRequire("bWGt6");
function $90475f1017e2136e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $90475f1017e2136e$var$overlayZindex = (0, $1wToE.layers).modal() + 10;
const $90475f1017e2136e$export$5b927fc1ef8c468b = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1if7vbe1"
})({
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: $90475f1017e2136e$var$overlayZindex
});
$90475f1017e2136e$export$5b927fc1ef8c468b.displayName = 'Blanket';
const $90475f1017e2136e$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1if7vbe0"
})({
    name: "1aslf6p",
    styles: "position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
});
$90475f1017e2136e$export$52b4dfd89a6b3a1b.displayName = 'SpinnerWrapper';
const $90475f1017e2136e$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $90475f1017e2136e$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)($90475f1017e2136e$export$5b927fc1ef8c468b, {
        style: {
            backgroundColor: blankedColor || $90475f1017e2136e$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($90475f1017e2136e$export$52b4dfd89a6b3a1b, {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dyckQ.default), {
                size: "large",
                appearance: invertSpinnerColor || $90475f1017e2136e$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
                testId: 'media-modal-spinner'
            })
        })
    });

});

parcelRegister("kkbmD", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe1da1c78f35d1e0$export$2e2bcd8739ae039);
/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dyckQ = parcelRequire("dyckQ");
const $fe1da1c78f35d1e0$var$blanketStyles = null;
const $fe1da1c78f35d1e0$var$spinnerStyles = null;
const $fe1da1c78f35d1e0$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $fe1da1c78f35d1e0$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            backgroundColor: blankedColor || $fe1da1c78f35d1e0$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $bwpsq.default)([
            "_kqsw1n9t _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _1pby1qpw"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                "_kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dyckQ.default), {
                size: "large",
                appearance: invertSpinnerColor || $fe1da1c78f35d1e0$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
                testId: 'media-modal-spinner'
            })
        })
    });

});



parcelRegister("eh6yN", function(module, exports) {

$parcel$export(module.exports, "MediaViewerPortal", () => $891b698a4a7c1cdc$export$51aee4c01b17acde);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5z2c3 = parcelRequire("5z2c3");
const $891b698a4a7c1cdc$export$51aee4c01b17acde = ({ children: children })=>// This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5z2c3.default), {
        zIndex: 510,
        children: children
    });

});

parcelRegister("iEuu5", function(module, exports) {

let $d9439bf94ed001cd$var$load = (parcelRequire("loK1v"))(4);
module.exports = Promise.all([
    $d9439bf94ed001cd$var$load("4X3wS"),
    $d9439bf94ed001cd$var$load("hSQJ5"),
    $d9439bf94ed001cd$var$load("aCh9P"),
    $d9439bf94ed001cd$var$load("bxxT5"),
    $d9439bf94ed001cd$var$load("5lwjh")
]).then(()=>parcelRequire('jonfl'));

});


parcelRegister("hygIE", function(module, exports) {

$parcel$export(module.exports, "messages", () => $fea2096c473a1063$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $fea2096c473a1063$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    unableToLoadContent: {
        id: 'fabric.editor.unableToLoadContent',
        defaultMessage: "We couldn't load this content",
        description: 'Display this message when there is an error loading file content'
    },
    failedToUpload: {
        id: 'fabric.editor.failed_to_upload',
        defaultMessage: 'Failed to upload',
        description: 'Display this message when there is an error uploading a file'
    }
});

});

parcelRegister("36XXg", function(module, exports) {

$parcel$export(module.exports, "InlineImageCard", () => $121185cd5762498d$export$bb1dd14451154199);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $lj1RC = parcelRequire("lj1RC");

var $41dvG = parcelRequire("41dvG");

var $2gKrE = parcelRequire("2gKrE");

var $1jG3J = parcelRequire("1jG3J");
const $121185cd5762498d$export$bb1dd14451154199 = ({ dimensions: dimensions, identifier: identifier, renderError: renderError, alt: alt, isLazy: isLazy, ssr: ssr, crop: crop, stretch: stretch })=>{
    // Generate unique traceId for file
    const traceContext = (0, $5uXOq.useMemo)(()=>({
            traceId: (0, $lj1RC.getRandomHex)(8)
        }), []);
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO do we need to handle nonCriticalError
    const { preview: preview, error: previewError, onImageError: onImageError, onImageLoad: onImageLoad, getSsrScriptProps: getSsrScriptProps, copyNodeRef: copyNodeRef } = (0, $41dvG.useFilePreview)({
        identifier: identifier,
        ssr: ssr,
        dimensions: dimensions,
        traceContext: traceContext
    });
    if (previewError) return renderError({
        error: previewError
    });
    if (!preview) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1jG3J.InlineImageCardLoadingView), null);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2gKrE.MediaImage), {
        dataURI: preview.dataURI,
        alt: alt,
        previewOrientation: preview.orientation,
        onImageLoad: ()=>{
            onImageLoad(preview);
        },
        onImageError: onImageError,
        loading: isLazy ? 'lazy' : undefined,
        forceSyncDisplay: !!ssr,
        crop: crop,
        stretch: stretch,
        ref: copyNodeRef
    }), getSsrScriptProps && /*#__PURE__*/ (0, $f8Sb3.jsx)("script", getSsrScriptProps()));
};

});
parcelRegister("41dvG", function(module, exports) {

$parcel$export(module.exports, "useFilePreview", () => $f326e293052e590e$export$4eaebdef02112fe4);

var $5uXOq = parcelRequire("5uXOq");

var $bBC3H = parcelRequire("bBC3H");
var $esqLm = parcelRequire("esqLm");

var $2rsbO = parcelRequire("2rsbO");
var $iqhpH = parcelRequire("iqhpH");
var $13cLp = parcelRequire("13cLp");

var $gt5KW = parcelRequire("gt5KW");

var $8vudP = parcelRequire("8vudP");

var $7cIxk = parcelRequire("7cIxk");

var $7O1Cz = parcelRequire("7O1Cz");
var $g3rsD = parcelRequire("g3rsD");
var $7fAKQ = parcelRequire("7fAKQ");

var $gHUYk = parcelRequire("gHUYk");
var $cRuXV = parcelRequire("cRuXV");

var $l6q9J = parcelRequire("l6q9J");
const $f326e293052e590e$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $13cLp.useMediaClient)();
    const [status, setStatus] = (0, $5uXOq.useState)('loading');
    const [error, setError] = (0, $5uXOq.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $5uXOq.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $5uXOq.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $5uXOq.useState)('not-resolved');
    const ssrReliabilityRef = (0, $5uXOq.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const requestDimensions = (0, $5uXOq.useMemo)(()=>dimensions ? (0, $l6q9J.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $l6q9J.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $7fAKQ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $cRuXV.getSSRData)(identifier);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $7O1Cz.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $8vudP.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $5uXOq.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $iqhpH.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $bBC3H.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $5uXOq.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $7cIxk.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $7cIxk.MediaFilePreviewError)('metadata-fetch', (0, $esqLm.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $l6q9J.useCurrentValueRef)(()=>{
        return (0, $7O1Cz.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $5uXOq.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $l6q9J.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $l6q9J.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $5uXOq.useEffect)(()=>{
        const cachedPreview = (0, $7fAKQ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $l6q9J.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $g3rsD.isSupportedLocalPreview)(mediaType) && (0, $gt5KW.isMimeTypeSupportedByBrowser)(mimeType || '')) // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
        // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
        // Then, local Preview NOT available
        (0, $7O1Cz.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
            setIsBannedLocalPreview(true);
            // CXP-2723 TODO: We might have to wrap this error in MediaCardError
            setNonCriticalError(e);
        });
        else if (!error && !nonCriticalError && (!preview || (0, $l6q9J.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $7O1Cz.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
            const wrappedError = (0, $7cIxk.ensureMediaFilePreviewError)('preview-fetch', e);
            if (!preview) {
                setStatus('error');
                setError(wrappedError);
            } else // If there is already a preview, we consider it a non-critical error
            setNonCriticalError(wrappedError);
        });
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $5uXOq.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $7O1Cz.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $8vudP.createFailedSSRObject)(failedPreview, traceContext);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if ((0, $7O1Cz.isSSRDataPreview)(failedPreview)) {
            ssrReliabilityRef.current.server = (0, $8vudP.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $8vudP.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $7O1Cz.isLocalPreview)(failedPreview);
        const isRemote = (0, $7O1Cz.isRemotePreview)(failedPreview);
        if (isLocal || isRemote) {
            const error = new (0, $7cIxk.ImageLoadError)(failedPreview?.source);
            (0, $7fAKQ.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $5uXOq.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $7O1Cz.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $7O1Cz.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $gHUYk.generateScriptProps)(identifier, preview?.dataURI, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $2rsbO.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("2rsbO", function(module, exports) {

$parcel$export(module.exports, "useCopyIntent", () => $e4cff8df83dce0ef$export$46fd859414de9d62);

var $5uXOq = parcelRequire("5uXOq");

var $2Dcc2 = parcelRequire("2Dcc2");

var $hFKXd = parcelRequire("hFKXd");

var $13cLp = parcelRequire("13cLp");

var $3RMnN = parcelRequire("3RMnN");

var $3rWO7 = parcelRequire("3rWO7");
function $e4cff8df83dce0ef$var$useCurrentValueRef(value) {
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
}
const $e4cff8df83dce0ef$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $13cLp.useMediaClient)();
    const innerRef = (0, $5uXOq.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2Dcc2.useAnalyticsEvents)();
    const registerCopyIntentRef = $e4cff8df83dce0ef$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $3RMnN.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $3RMnN.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $5uXOq.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $hFKXd.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $5uXOq.useCallback)(async ()=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) registerCopyIntentRef.current();
    }, [
        registerCopyIntentRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $hFKXd.fg)('platform_media_cross_client_copy')) (0, $3rWO7.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $3rWO7.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("13cLp", function(module, exports) {

$parcel$export(module.exports, "useMediaClient", () => $f6cde71b368acb10$export$8b3e87ea56c3a345);

var $5uXOq = parcelRequire("5uXOq");

var $4sicK = parcelRequire("4sicK");

var $gl5Ms = parcelRequire("gl5Ms");
const $f6cde71b368acb10$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $4sicK.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $gl5Ms.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};

});
parcelRegister("gl5Ms", function(module, exports) {

$parcel$export(module.exports, "MediaContext", () => $bc18b3346454cfd6$export$c94ff18a59d4c4d);
$parcel$export(module.exports, "MediaProvider", () => $bc18b3346454cfd6$export$57164260bc1f1218);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fOcgu = parcelRequire("fOcgu");

var $1WwTr = parcelRequire("1WwTr");
const $bc18b3346454cfd6$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $bc18b3346454cfd6$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $5uXOq.useMemo)(()=>(0, $fOcgu.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $1WwTr.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($bc18b3346454cfd6$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        },
        children: children
    });
};

});
parcelRegister("1WwTr", function(module, exports) {

$parcel$export(module.exports, "useMediaParsedSettings", () => $29fef2243a6af93a$export$d54af28440a5efc0);

var $5uXOq = parcelRequire("5uXOq");

var $e8HgI = parcelRequire("e8HgI");
const $29fef2243a6af93a$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $5uXOq.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $e8HgI.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};

});
parcelRegister("e8HgI", function(module, exports) {

$parcel$export(module.exports, "defaultMediaUserPreferences", () => $4339489541151578$export$2d23ed2854ac1650);
// Currently only supports boolean, string. Uncomment below to support number
const $4339489541151578$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $4339489541151578$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($4339489541151578$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $4339489541151578$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $4339489541151578$export$2d23ed2854ac1650 = $4339489541151578$export$7e209e67b965bc63($4339489541151578$var$defaultUserPreferences);

});




parcelRegister("3RMnN", function(module, exports) {

$parcel$export(module.exports, "getCopyIntentErrorPayload", () => $dcbbe0e1f2a33b6b$export$3ab52330b662b987);
$parcel$export(module.exports, "getCopyIntentSuccessPayload", () => $dcbbe0e1f2a33b6b$export$aacb463551da2e8f);

var $4peRZ = parcelRequire("4peRZ");
const $dcbbe0e1f2a33b6b$var$getRequestErrorDetails = (err)=>{
    if ((0, $4peRZ.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
};
const $dcbbe0e1f2a33b6b$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $4peRZ.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$dcbbe0e1f2a33b6b$var$getRequestErrorDetails(error)
        }
    };
};
const $dcbbe0e1f2a33b6b$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};

});

parcelRegister("3rWO7", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $61b30fdfc0e40103$export$f65ca476c09acec0);
const $61b30fdfc0e40103$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("iqhpH", function(module, exports) {

$parcel$export(module.exports, "useFileState", () => $b2bb7da056940b2e$export$90ff537b0999afb);

var $5uXOq = parcelRequire("5uXOq");

var $13cLp = parcelRequire("13cLp");

var $cmyrS = parcelRequire("cmyrS");
function $b2bb7da056940b2e$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles } = options;
    const mediaClient = (0, $13cLp.useMediaClient)();
    const fileState = (0, $cmyrS.useMediaStore)((state)=>state.files[id]);
    (0, $5uXOq.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("cmyrS", function(module, exports) {

$parcel$export(module.exports, "useMediaStore", () => $88ddd9a650462d02$export$8a9cc8c330400af8);

var $6esDR = parcelRequire("6esDR");

var $13cLp = parcelRequire("13cLp");
const $88ddd9a650462d02$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $6esDR.useStore)(store, selector, equals);
function $88ddd9a650462d02$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $13cLp.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $88ddd9a650462d02$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("6esDR", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $489a4492a45245b1$export$6ccbb43953eebf8);

var $ee7sp = parcelRequire("ee7sp");

var $5uXOq = parcelRequire("5uXOq");

var $lNQti = parcelRequire("lNQti");
var $489a4492a45245b1$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $489a4492a45245b1$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq)));
const { useSyncExternalStoreWithSelector: $489a4492a45245b1$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($lNQti)));
let $489a4492a45245b1$var$didWarnAboutEqualityFn = false;
const $489a4492a45245b1$var$identity = (arg)=>arg;
function $489a4492a45245b1$export$6ccbb43953eebf8(api, selector = $489a4492a45245b1$var$identity, equalityFn) {
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$489a4492a45245b1$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $489a4492a45245b1$var$didWarnAboutEqualityFn = true;
    }
    const slice = $489a4492a45245b1$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $489a4492a45245b1$var$useDebugValue(slice);
    return slice;
}
const $489a4492a45245b1$var$createImpl = (createState)=>{
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $ee7sp.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$489a4492a45245b1$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $489a4492a45245b1$export$185802fd694ee1f5 = (createState)=>createState ? $489a4492a45245b1$var$createImpl(createState) : $489a4492a45245b1$var$createImpl;
var $489a4492a45245b1$export$2e2bcd8739ae039 = (createState)=>{
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $489a4492a45245b1$export$185802fd694ee1f5(createState);
};

});
parcelRegister("lNQti", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hUiTL"));

});
parcelRegister("hUiTL", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $d096537a1780f6c5$export$bf730a2d8bf68b42, (v) => $d096537a1780f6c5$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d096537a1780f6c5$export$bf730a2d8bf68b42;
'use strict';

var $5uXOq = parcelRequire("5uXOq");

var $goz36 = parcelRequire("goz36");
function $d096537a1780f6c5$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $d096537a1780f6c5$var$q = "function" === typeof Object.is ? Object.is : $d096537a1780f6c5$var$p, $d096537a1780f6c5$var$r = $goz36.useSyncExternalStore, $d096537a1780f6c5$var$t = $5uXOq.useRef, $d096537a1780f6c5$var$u = $5uXOq.useEffect, $d096537a1780f6c5$var$v = $5uXOq.useMemo, $d096537a1780f6c5$var$w = $5uXOq.useDebugValue;
$d096537a1780f6c5$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $d096537a1780f6c5$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $d096537a1780f6c5$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($d096537a1780f6c5$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $d096537a1780f6c5$var$r(a, c[0], c[1]);
    $d096537a1780f6c5$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $d096537a1780f6c5$var$w(d);
    return d;
};

});
parcelRegister("goz36", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jcmQl"));

});
parcelRegister("jcmQl", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $dfa0db7ec3fca60b$export$306c0aa65ff9ec16, (v) => $dfa0db7ec3fca60b$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dfa0db7ec3fca60b$export$306c0aa65ff9ec16;
'use strict';

var $5uXOq = parcelRequire("5uXOq");
function $dfa0db7ec3fca60b$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $dfa0db7ec3fca60b$var$k = "function" === typeof Object.is ? Object.is : $dfa0db7ec3fca60b$var$h, $dfa0db7ec3fca60b$var$l = $5uXOq.useState, $dfa0db7ec3fca60b$var$m = $5uXOq.useEffect, $dfa0db7ec3fca60b$var$n = $5uXOq.useLayoutEffect, $dfa0db7ec3fca60b$var$p = $5uXOq.useDebugValue;
function $dfa0db7ec3fca60b$var$q(a, b) {
    var d = b(), f = $dfa0db7ec3fca60b$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $dfa0db7ec3fca60b$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $dfa0db7ec3fca60b$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $dfa0db7ec3fca60b$var$m(function() {
        $dfa0db7ec3fca60b$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $dfa0db7ec3fca60b$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $dfa0db7ec3fca60b$var$p(d);
    return d;
}
function $dfa0db7ec3fca60b$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$dfa0db7ec3fca60b$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $dfa0db7ec3fca60b$var$t(a, b) {
    return b();
}
var $dfa0db7ec3fca60b$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $dfa0db7ec3fca60b$var$t : $dfa0db7ec3fca60b$var$q;
$dfa0db7ec3fca60b$export$306c0aa65ff9ec16 = void 0 !== $5uXOq.useSyncExternalStore ? $5uXOq.useSyncExternalStore : $dfa0db7ec3fca60b$var$u;

});







parcelRegister("8vudP", function(module, exports) {

$parcel$export(module.exports, "extractErrorInfo", () => $4aeb50e1c1c7ae8a$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $4aeb50e1c1c7ae8a$export$768c370ed0dbaeb3);

var $esqLm = parcelRequire("esqLm");

var $7cIxk = parcelRequire("7cIxk");
const $4aeb50e1c1c7ae8a$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $esqLm.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $4aeb50e1c1c7ae8a$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $4aeb50e1c1c7ae8a$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $esqLm.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $4aeb50e1c1c7ae8a$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $esqLm.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $4aeb50e1c1c7ae8a$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $4aeb50e1c1c7ae8a$export$4af9d71992e89714(error),
        error: $4aeb50e1c1c7ae8a$export$88c61dcad53762da(error),
        errorDetail: $4aeb50e1c1c7ae8a$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $4aeb50e1c1c7ae8a$export$29aa614726672b2e(error)
    };
};
const $4aeb50e1c1c7ae8a$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$4aeb50e1c1c7ae8a$export$74aaf4784c2edb2c(new (0, $7cIxk.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("7cIxk", function(module, exports) {

$parcel$export(module.exports, "MediaFilePreviewError", () => $11c08f1a424e4d88$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $11c08f1a424e4d88$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $11c08f1a424e4d88$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $11c08f1a424e4d88$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $11c08f1a424e4d88$export$d0a45ab59b4606b);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $11c08f1a424e4d88$export$7156ce7b78b49bd7);
class $11c08f1a424e4d88$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $11c08f1a424e4d88$export$2c035820a31723e extends $11c08f1a424e4d88$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $11c08f1a424e4d88$export$10ab445310d30114 extends $11c08f1a424e4d88$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $11c08f1a424e4d88$export$18e89b7e50818288 extends $11c08f1a424e4d88$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $11c08f1a424e4d88$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $11c08f1a424e4d88$export$d0a45ab59b4606b extends $11c08f1a424e4d88$export$96e559194c287cf4 {
    constructor(source){
        super($11c08f1a424e4d88$var$getImageLoadPrimaryReason(source));
    }
}
function $11c08f1a424e4d88$export$553696a6e769784c(err) {
    return err instanceof $11c08f1a424e4d88$export$96e559194c287cf4;
}
const $11c08f1a424e4d88$export$b380593ba3516c6f = (err)=>err instanceof $11c08f1a424e4d88$export$2c035820a31723e;
const $11c08f1a424e4d88$export$e1d87830b3784f94 = (err)=>err instanceof $11c08f1a424e4d88$export$10ab445310d30114;
const $11c08f1a424e4d88$export$443aeb298d35d79d = (err)=>$11c08f1a424e4d88$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $11c08f1a424e4d88$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($11c08f1a424e4d88$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $11c08f1a424e4d88$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $11c08f1a424e4d88$export$96e559194c287cf4(primaryReason, error);
};

});


parcelRegister("7O1Cz", function(module, exports) {

$parcel$export(module.exports, "getSSRPreview", () => $d4765b7348ff58e0$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $d4765b7348ff58e0$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $d4765b7348ff58e0$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $d4765b7348ff58e0$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $d4765b7348ff58e0$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $d4765b7348ff58e0$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $d4765b7348ff58e0$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $d4765b7348ff58e0$export$98e935d981c884d);

var $kxYAa = parcelRequire("kxYAa");

var $7cIxk = parcelRequire("7cIxk");

var $7fAKQ = parcelRequire("7fAKQ");

var $g3rsD = parcelRequire("g3rsD");
const $d4765b7348ff58e0$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $kxYAa.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $7fAKQ.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $d4765b7348ff58e0$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    let dataURI;
    try {
        const rawDataURI = mediaClient.getImageUrlSync(id, params);
        // We want to embed some meta context into dataURI for Copy/Paste to work.
        dataURI = mediaBlobUrlAttrs ? (0, $kxYAa.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $7cIxk.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $d4765b7348ff58e0$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $d4765b7348ff58e0$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $d4765b7348ff58e0$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $d4765b7348ff58e0$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $d4765b7348ff58e0$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $d4765b7348ff58e0$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $g3rsD.getRemotePreview)(mediaClient, id, params, traceContext);
    return $d4765b7348ff58e0$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $d4765b7348ff58e0$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $g3rsD.getLocalPreview)(filePreview);
    return $d4765b7348ff58e0$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};

});
parcelRegister("kxYAa", function(module, exports) {

$parcel$export(module.exports, "isMediaBlobUrl", () => $62d475a72f76ea01$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $62d475a72f76ea01$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $62d475a72f76ea01$export$e51a8146182600b8);
const $62d475a72f76ea01$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $62d475a72f76ea01$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$62d475a72f76ea01$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $62d475a72f76ea01$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $62d475a72f76ea01$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $62d475a72f76ea01$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $62d475a72f76ea01$var$getStringFromParams(params, 'collection'),
        alt: $62d475a72f76ea01$var$getStringFromParams(params, 'alt'),
        height: $62d475a72f76ea01$var$getNumberFromParams(params, 'height'),
        width: $62d475a72f76ea01$var$getNumberFromParams(params, 'width'),
        size: $62d475a72f76ea01$var$getNumberFromParams(params, 'size'),
        name: $62d475a72f76ea01$var$getStringFromParams(params, 'name'),
        mimeType: $62d475a72f76ea01$var$getStringFromParams(params, 'mimeType')
    };
};
const $62d475a72f76ea01$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $62d475a72f76ea01$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$62d475a72f76ea01$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $62d475a72f76ea01$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("7fAKQ", function(module, exports) {

$parcel$export(module.exports, "mediaFilePreviewCache", () => $1532a2fdf5a7cf75$export$b7e8ee3f7a41459);

var $cD4z9 = parcelRequire("cD4z9");
const $1532a2fdf5a7cf75$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $1532a2fdf5a7cf75$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $1532a2fdf5a7cf75$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $1532a2fdf5a7cf75$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $1532a2fdf5a7cf75$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $1532a2fdf5a7cf75$export$b7e8ee3f7a41459 = new $1532a2fdf5a7cf75$export$7b50526c091bb915((0, $cD4z9.createObjectURLCache)());

});
parcelRegister("cD4z9", function(module, exports) {

$parcel$export(module.exports, "createObjectURLCache", () => $0070eb9c88cb67f0$export$ba71be67d5c32535);

var $7n9mn = parcelRequire("7n9mn");

var $iwKVT = parcelRequire("iwKVT");
const $0070eb9c88cb67f0$export$36d0f9859761643d = 50;
class $0070eb9c88cb67f0$var$ExtendedLRUCache extends (0, $iwKVT.LRUMap) {
    constructor(limit){
        super(limit);
        this.eventEmitter = new (0, $7n9mn.EventEmitter2)();
    }
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
}
class $0070eb9c88cb67f0$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.cache = new $0070eb9c88cb67f0$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $0070eb9c88cb67f0$export$ba71be67d5c32535 = ()=>new $0070eb9c88cb67f0$export$75d1c8c9ba1d0773($0070eb9c88cb67f0$export$36d0f9859761643d);

});


parcelRegister("g3rsD", function(module, exports) {

$parcel$export(module.exports, "isSupportedLocalPreview", () => $89357c5fe1e7a3c2$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $89357c5fe1e7a3c2$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $89357c5fe1e7a3c2$export$bfe20bd01db02b3);

var $5gMDA = parcelRequire("5gMDA");

var $1Dvzn = parcelRequire("1Dvzn");

var $7cIxk = parcelRequire("7cIxk");

var $llgTB = parcelRequire("llgTB");
const $89357c5fe1e7a3c2$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $89357c5fe1e7a3c2$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $1Dvzn.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $7cIxk.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $89357c5fe1e7a3c2$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $llgTB.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $7cIxk.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $89357c5fe1e7a3c2$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $7cIxk.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $5gMDA.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $89357c5fe1e7a3c2$var$getImageLocalPreview(value);
            case 'video':
                return $89357c5fe1e7a3c2$var$getVideoLocalPreview(value);
            default:
                throw new (0, $7cIxk.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $7cIxk.LocalPreviewError)('local-preview-unsupported');
};
const $89357c5fe1e7a3c2$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $7cIxk.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("1Dvzn", function(module, exports) {

$parcel$export(module.exports, "getImageInfo", () => $b9719d82c6e52a0c$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $b9719d82c6e52a0c$export$67689507e8404821);

var $9ijVN = parcelRequire("9ijVN");

var $9P6Bv = parcelRequire("9P6Bv");

var $1B9f9 = parcelRequire("1B9f9");

var $k4fr0 = parcelRequire("k4fr0");
const { Orientation: $b9719d82c6e52a0c$var$Orientation, XResolution: $b9719d82c6e52a0c$var$XResolution } = (0, $9ijVN.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $b9719d82c6e52a0c$var$DPI_WEB_BASELINE = 72;
async function $b9719d82c6e52a0c$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $b9719d82c6e52a0c$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $b9719d82c6e52a0c$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $b9719d82c6e52a0c$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $b9719d82c6e52a0c$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $b9719d82c6e52a0c$var$DPI_WEB_BASELINE;
        else return $b9719d82c6e52a0c$export$268f92356524130b(tags, $b9719d82c6e52a0c$var$XResolution, $b9719d82c6e52a0c$var$DPI_WEB_BASELINE) / $b9719d82c6e52a0c$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $b9719d82c6e52a0c$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$b9719d82c6e52a0c$var$Orientation]) {
        const tagValue = tags[$b9719d82c6e52a0c$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $9ijVN.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $b9719d82c6e52a0c$export$67689507e8404821(file) {
    const tags = await (0, $9P6Bv.readImageMetaTags)(file);
    return $b9719d82c6e52a0c$var$getOrientationFromTags(tags);
}
function $b9719d82c6e52a0c$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $b9719d82c6e52a0c$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $b9719d82c6e52a0c$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $9P6Bv.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $b9719d82c6e52a0c$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $b9719d82c6e52a0c$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $1B9f9.loadImage)(src);
        const { width: width, height: height } = (0, $1B9f9.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("9ijVN", function(module, exports) {

$parcel$export(module.exports, "ImageType", () => $0b2b6e09abffebf8$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $0b2b6e09abffebf8$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $0b2b6e09abffebf8$export$f6ea0c89fd7d156);
var $0b2b6e09abffebf8$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $0b2b6e09abffebf8$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $0b2b6e09abffebf8$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("9P6Bv", function(module, exports) {

$parcel$export(module.exports, "readImageMetaTags", () => $d333ed3e147d5ea8$export$41982b5c7acb23c4);

var $9ijVN = parcelRequire("9ijVN");

var $dIwcc = parcelRequire("dIwcc");

var $1meEh = parcelRequire("1meEh");

var $bFWaz = parcelRequire("bFWaz");
async function $d333ed3e147d5ea8$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $9ijVN.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $1meEh.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $bFWaz.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $9ijVN.ImageType).JPEG) return await (0, $dIwcc.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("dIwcc", function(module, exports) {

$parcel$export(module.exports, "readJPEGExifMetaData", () => $3d955106a0db7faf$export$556b2ccec62d7f2a);

var $9ijVN = parcelRequire("9ijVN");
const { XResolution: $3d955106a0db7faf$var$XResolution, YResolution: $3d955106a0db7faf$var$YResolution } = (0, $9ijVN.SupportedImageMetaTag);
let $3d955106a0db7faf$var$loadImage;

function $3d955106a0db7faf$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$3d955106a0db7faf$var$loadImage) {
            const module = await (parcelRequire("eL344"));
            $3d955106a0db7faf$var$loadImage = module.default || module;
        }
        $3d955106a0db7faf$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $3d955106a0db7faf$var$XResolution || key === $3d955106a0db7faf$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("eL344", function(module, exports) {

let $abe7d507a3c08e9d$var$load = (parcelRequire("loK1v"))(4);
module.exports = $abe7d507a3c08e9d$var$load("3lsfR").then(()=>parcelRequire('8aLn9'));

});


parcelRegister("1meEh", function(module, exports) {

$parcel$export(module.exports, "readPNGXMPMetaData", () => $2aabaa6befe8ad6f$export$5fb37736440fca6f);

var $1B9f9 = parcelRequire("1B9f9");
let $2aabaa6befe8ad6f$var$pngChunksExtract;

async function $2aabaa6befe8ad6f$export$5fb37736440fca6f(file) {
    if (!$2aabaa6befe8ad6f$var$pngChunksExtract) {
        const module = await (parcelRequire("6Qety"));
        $2aabaa6befe8ad6f$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $1B9f9.fileToArrayBuffer)(file);
    const chunks = $2aabaa6befe8ad6f$var$pngChunksExtract(buffer);
    return await $2aabaa6befe8ad6f$export$9185743fdd58ce45(chunks);
}
async function $2aabaa6befe8ad6f$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("1B9f9", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $2f3687bf28ff5cbc$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $2f3687bf28ff5cbc$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $2f3687bf28ff5cbc$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $2f3687bf28ff5cbc$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $2f3687bf28ff5cbc$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $2f3687bf28ff5cbc$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $2f3687bf28ff5cbc$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $2f3687bf28ff5cbc$export$61a1de0822e2820);

var $5dPf8 = parcelRequire("5dPf8");

var $7giT4 = parcelRequire("7giT4");

var $a0HpH = parcelRequire("a0HpH");

var $ffEDn = parcelRequire("ffEDn");

var $iPXVH = parcelRequire("iPXVH");

var $jDuAG = parcelRequire("jDuAG");

var $g3mqm = parcelRequire("g3mqm");

var $NLgct = parcelRequire("NLgct");

var $hIjic = parcelRequire("hIjic");

var $jbAi5 = parcelRequire("jbAi5");

var $aExYG = parcelRequire("aExYG");

var $btUUp = parcelRequire("btUUp");

var $gaxQK = parcelRequire("gaxQK");

var $3P7gd = parcelRequire("3P7gd");

var $1yzTt = parcelRequire("1yzTt");

var $d2Hz9 = parcelRequire("d2Hz9");
function $2f3687bf28ff5cbc$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $2f3687bf28ff5cbc$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $2f3687bf28ff5cbc$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $2f3687bf28ff5cbc$export$849633012686f7ee(file)
    };
}
async function $2f3687bf28ff5cbc$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $2f3687bf28ff5cbc$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $2f3687bf28ff5cbc$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $2f3687bf28ff5cbc$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $2f3687bf28ff5cbc$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $2f3687bf28ff5cbc$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $2f3687bf28ff5cbc$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5dPf8)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hIjic)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aExYG)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hIjic)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jbAi5)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($NLgct)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ffEDn)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3P7gd)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a0HpH)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7giT4)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gaxQK)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($btUUp)))
    }
];
function $2f3687bf28ff5cbc$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $2f3687bf28ff5cbc$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $d2Hz9.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yzTt)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iPXVH)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jDuAG)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g3mqm)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("5dPf8", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3cd5ea79d47d137b$var$_react = $3cd5ea79d47d137b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");
function $3cd5ea79d47d137b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3cd5ea79d47d137b$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $3cd5ea79d47d137b$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$3cd5ea79d47d137b$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $3cd5ea79d47d137b$var$_default = module.exports.default = $3cd5ea79d47d137b$var$PdfDocument24Icon;

});

parcelRegister("7giT4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $5498ad9f1d74969a$var$_react = $5498ad9f1d74969a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");
function $5498ad9f1d74969a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5498ad9f1d74969a$var$Gif24Icon = (props)=>/*#__PURE__*/ $5498ad9f1d74969a$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$5498ad9f1d74969a$var$Gif24Icon.displayName = 'Gif24Icon';
var $5498ad9f1d74969a$var$_default = module.exports.default = $5498ad9f1d74969a$var$Gif24Icon;

});

parcelRegister("a0HpH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $749b947bada91076$var$_react = $749b947bada91076$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");
function $749b947bada91076$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $749b947bada91076$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $749b947bada91076$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$749b947bada91076$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $749b947bada91076$var$_default = module.exports.default = $749b947bada91076$var$PowerpointPresentation24Icon;

});

parcelRegister("ffEDn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $b1a7c6d6bdd0aef1$var$_react = $b1a7c6d6bdd0aef1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");
function $b1a7c6d6bdd0aef1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b1a7c6d6bdd0aef1$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $b1a7c6d6bdd0aef1$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$b1a7c6d6bdd0aef1$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $b1a7c6d6bdd0aef1$var$_default = module.exports.default = $b1a7c6d6bdd0aef1$var$WordDocument24Icon;

});

parcelRegister("iPXVH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $db6b7a353b082eb3$var$_react = $db6b7a353b082eb3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");
function $db6b7a353b082eb3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $db6b7a353b082eb3$var$Sketch24Icon = (props)=>/*#__PURE__*/ $db6b7a353b082eb3$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$db6b7a353b082eb3$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $db6b7a353b082eb3$var$_default = module.exports.default = $db6b7a353b082eb3$var$Sketch24Icon;

});

parcelRegister("jDuAG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e4b96381184a1c53$var$_react = $e4b96381184a1c53$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");
function $e4b96381184a1c53$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e4b96381184a1c53$var$Figma24Icon = (props)=>/*#__PURE__*/ $e4b96381184a1c53$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e4b96381184a1c53$var$Figma24Icon.displayName = 'Figma24Icon';
var $e4b96381184a1c53$var$_default = module.exports.default = $e4b96381184a1c53$var$Figma24Icon;

});

parcelRegister("g3mqm", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $bafe52234f749513$var$_react = $bafe52234f749513$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");
function $bafe52234f749513$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bafe52234f749513$var$Executable24Icon = (props)=>/*#__PURE__*/ $bafe52234f749513$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$bafe52234f749513$var$Executable24Icon.displayName = 'Executable24Icon';
var $bafe52234f749513$var$_default = module.exports.default = $bafe52234f749513$var$Executable24Icon;

});

parcelRegister("NLgct", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $09593ca0b6921fd5$var$_react = $09593ca0b6921fd5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");
function $09593ca0b6921fd5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $09593ca0b6921fd5$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $09593ca0b6921fd5$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$09593ca0b6921fd5$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $09593ca0b6921fd5$var$_default = module.exports.default = $09593ca0b6921fd5$var$GoogleDoc24Icon;

});

parcelRegister("hIjic", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $ce5582d57437d593$var$_react = $ce5582d57437d593$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");
function $ce5582d57437d593$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ce5582d57437d593$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $ce5582d57437d593$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$ce5582d57437d593$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $ce5582d57437d593$var$_default = module.exports.default = $ce5582d57437d593$var$GoogleForm24Icon;

});

parcelRegister("jbAi5", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $df7b320169278fb6$var$_react = $df7b320169278fb6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");
function $df7b320169278fb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $df7b320169278fb6$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $df7b320169278fb6$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$df7b320169278fb6$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $df7b320169278fb6$var$_default = module.exports.default = $df7b320169278fb6$var$GoogleSheet24Icon;

});

parcelRegister("aExYG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $7c17ff1bd1912069$var$_react = $7c17ff1bd1912069$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");
function $7c17ff1bd1912069$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7c17ff1bd1912069$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $7c17ff1bd1912069$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$7c17ff1bd1912069$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $7c17ff1bd1912069$var$_default = module.exports.default = $7c17ff1bd1912069$var$GoogleSlide24Icon;

});

parcelRegister("btUUp", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $85be8c087a8478db$var$_react = $85be8c087a8478db$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");
function $85be8c087a8478db$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $85be8c087a8478db$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $85be8c087a8478db$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$85be8c087a8478db$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $85be8c087a8478db$var$_default = module.exports.default = $85be8c087a8478db$var$ExcelSpreadsheet24Icon;

});

parcelRegister("gaxQK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $bc57d66347daa1de$var$_react = $bc57d66347daa1de$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");
function $bc57d66347daa1de$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bc57d66347daa1de$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $bc57d66347daa1de$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$bc57d66347daa1de$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $bc57d66347daa1de$var$_default = module.exports.default = $bc57d66347daa1de$var$Spreadsheet24Icon;

});

parcelRegister("3P7gd", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2c8bc44ebd63c4a4$var$_react = $2c8bc44ebd63c4a4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");
function $2c8bc44ebd63c4a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2c8bc44ebd63c4a4$var$Presentation24Icon = (props)=>/*#__PURE__*/ $2c8bc44ebd63c4a4$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2c8bc44ebd63c4a4$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $2c8bc44ebd63c4a4$var$_default = module.exports.default = $2c8bc44ebd63c4a4$var$Presentation24Icon;

});

parcelRegister("1yzTt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1224cf261258fdf3$var$_react = $1224cf261258fdf3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");
function $1224cf261258fdf3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1224cf261258fdf3$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $1224cf261258fdf3$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1224cf261258fdf3$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $1224cf261258fdf3$var$_default = module.exports.default = $1224cf261258fdf3$var$SourceCode24Icon;

});

parcelRegister("d2Hz9", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $56af9ef4c38c1568$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $56af9ef4c38c1568$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $56af9ef4c38c1568$export$ba4368c844580f9e);
function $56af9ef4c38c1568$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $56af9ef4c38c1568$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $56af9ef4c38c1568$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $56af9ef4c38c1568$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $56af9ef4c38c1568$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $56af9ef4c38c1568$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $56af9ef4c38c1568$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            return null;
    }
}

});


parcelRegister("6Qety", function(module, exports) {

let $4fb2d3f55217d92c$var$load = (parcelRequire("loK1v"))(4);
module.exports = $4fb2d3f55217d92c$var$load("iLANP").then(()=>parcelRequire('eYIux'));

});


parcelRegister("bFWaz", function(module, exports) {

$parcel$export(module.exports, "parseXMPMetaData", () => $a59a4fc81aeb5c99$export$55c3bc9841b19de2);
function $a59a4fc81aeb5c99$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("k4fr0", function(module, exports) {

$parcel$export(module.exports, "isRotated", () => $e76c47b0662c7c66$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $e76c47b0662c7c66$export$43142f95b8de7a91);
const $e76c47b0662c7c66$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $e76c47b0662c7c66$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $e76c47b0662c7c66$export$43142f95b8de7a91 = (orientation)=>{
    return $e76c47b0662c7c66$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("llgTB", function(module, exports) {

$parcel$export(module.exports, "takeSnapshot", () => $1fe50eb0059972d5$export$4269d30173168e5c);
const $1fe50eb0059972d5$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("gHUYk", function(module, exports) {

$parcel$export(module.exports, "getMediaCardSSR", () => $995a5eee002cf9d5$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $995a5eee002cf9d5$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $995a5eee002cf9d5$export$de7c49925e44d75d);

var $fgCws = parcelRequire("fgCws");
const $995a5eee002cf9d5$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $995a5eee002cf9d5$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $995a5eee002cf9d5$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $995a5eee002cf9d5$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $995a5eee002cf9d5$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $995a5eee002cf9d5$var$dashed = (param)=>param ? `-${param}` : '';
const $995a5eee002cf9d5$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$995a5eee002cf9d5$var$dashed(collectionName)}${$995a5eee002cf9d5$var$dashed(occurrenceKey)}`;
const $995a5eee002cf9d5$export$4310981e0aa4ce67 = (key, dataURI, dimensions, error, globalScope = window)=>{
    const mediaCardSsr = $995a5eee002cf9d5$export$ede93d4564eaa8da(globalScope);
    mediaCardSsr[key] = {
        dataURI: dataURI,
        dimensions: dimensions,
        error: error
    };
};
const $995a5eee002cf9d5$var$generateScript = (identifier, dataURI, dimensions, error)=>{
    const functionCall = (0, $fgCws.printFunctionCall)($995a5eee002cf9d5$export$4310981e0aa4ce67, $995a5eee002cf9d5$export$a47fb462a08de82f(identifier), dataURI, dimensions, error);
    return (0, $fgCws.printScript)([
        $995a5eee002cf9d5$export$ede93d4564eaa8da.toString(),
        $995a5eee002cf9d5$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $995a5eee002cf9d5$export$de7c49925e44d75d = (identifier, dataURI, dimensions, error)=>({
        dangerouslySetInnerHTML: {
            __html: $995a5eee002cf9d5$var$generateScript(identifier, dataURI, dimensions, error)
        }
    });

});
parcelRegister("fgCws", function(module, exports) {

$parcel$export(module.exports, "printFunctionCall", () => $3488eb65c3a5ca02$export$3742967cc82ac85a);
$parcel$export(module.exports, "printScript", () => $3488eb65c3a5ca02$export$8b902fb69a2f17c1);

var $hFKXd = parcelRequire("hFKXd");
const $3488eb65c3a5ca02$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $3488eb65c3a5ca02$var$printParams = (args)=>args.map((arg)=>$3488eb65c3a5ca02$var$printParam(arg)).join(',');
const $3488eb65c3a5ca02$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$3488eb65c3a5ca02$var$printParams(args)});`;
const $3488eb65c3a5ca02$export$8b902fb69a2f17c1 = (statements)=>(0, $hFKXd.fg)('platform_remove_media_script_after_execution') ? `(function(){
 			 ${statements.join(';')}
  			document.currentScript.remove();
		})();
		` : `(function(){
   			${statements.join(';')}
 		})();`;

});


parcelRegister("cRuXV", function(module, exports) {

$parcel$export(module.exports, "getSSRData", () => $60b944d57c19c1c3$export$d3a890b0f7844b6f);

var $gHUYk = parcelRequire("gHUYk");
const $60b944d57c19c1c3$export$d3a890b0f7844b6f = (identifier)=>{
    const mediaCardSsr = (0, $gHUYk.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $gHUYk.getKey)(identifier)];
};

});

parcelRegister("l6q9J", function(module, exports) {

$parcel$export(module.exports, "isBigger", () => $bdb9b027c6213d9c$export$912a00e9a5470d9a);
$parcel$export(module.exports, "createRequestDimensions", () => $bdb9b027c6213d9c$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $bdb9b027c6213d9c$export$b3e10e1f0fbb71db);

var $5uXOq = parcelRequire("5uXOq");
const $bdb9b027c6213d9c$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $bdb9b027c6213d9c$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $bdb9b027c6213d9c$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $bdb9b027c6213d9c$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $bdb9b027c6213d9c$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
}

});


parcelRegister("2gKrE", function(module, exports) {

$parcel$export(module.exports, "MediaImage", () => $c1ced0fec844fd94$export$1f97dc1e9d072692);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $hFKXd = parcelRequire("hFKXd");

var $kXjCv = parcelRequire("kXjCv");

var $itfHy = parcelRequire("itfHy");

var $eevtr = parcelRequire("eevtr");

var $k4fr0 = parcelRequire("k4fr0");

var $3Du7S = parcelRequire("3Du7S");
const $c1ced0fec844fd94$export$1f97dc1e9d072692 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ dataURI: dataURI, alt: alt = '', crop: crop = false, stretch: stretch = false, previewOrientation: previewOrientation = 1, crossOrigin: crossOrigin, onImageLoad: onImageLoad, onImageError: onImageError, loading: loading, forceSyncDisplay: forceSyncDisplay = false }, ref)=>{
    const [{ width: parentWidth, height: parentHeight }, setParentDimensions] = (0, $5uXOq.useState)({
        width: Infinity,
        height: Infinity
    });
    const [{ width: imgWidth, height: imgHeight }, setImageDimensions] = (0, $5uXOq.useState)({
        width: 0,
        height: 0
    });
    const [isImageLoaded, setIsImageLoaded] = (0, $5uXOq.useState)(false);
    const imgRef = (0, $5uXOq.useRef)(null);
    const imageRef = (0, $5uXOq.useCallback)((imgElem)=>{
        if (!imgElem || imgRef.current) return;
        if (imgElem.parentElement) {
            const { width: width, height: height } = imgElem.parentElement.getBoundingClientRect();
            setParentDimensions({
                width: width,
                height: height
            });
        }
        imgRef.current = imgElem;
    }, []);
    const mergedRef = (0, $3Du7S.useMergeRefs)([
        imageRef,
        ref
    ]);
    const imageLoadHandler = (e)=>{
        if (!imgRef.current) return;
        setImageDimensions({
            width: imgRef.current.naturalWidth,
            height: imgRef.current.naturalHeight
        });
        setIsImageLoaded(true);
        onImageLoad?.(e.currentTarget);
    };
    const parentRatio = parentWidth / parentHeight;
    let imgRatio = imgWidth / imgHeight;
    let percentSize = '100%';
    /*
      Cover strategy means we want to full entire screen with an image. Here is an example:

         Image           Container   Result (░ - is what cropped out)
     ┌──────────────┐    ┌──────┐    ┌───┬──────┬───┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    └──────┘    └───┴──────┴───┘
     └──────────────┘
    */ const isCoverStrategy = crop;
    /*
      Fit strategy means image is fully inside container even if there is empty space left.
      Here is an example:

             Image            Container     Result
     ┌────────────────────┐    ┌──────┐    ┌──────┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     └────────────────────┘    └──────┘    └──────┘
     */ const isFitStrategy = !crop;
    const isImageRotated = previewOrientation !== 'from-image' && (0, $k4fr0.isRotated)(previewOrientation);
    /*
      When photo has orientation of 90deg or 270deg (stored in EXIF meta data)
      things get very tricky. Let me go through an two examples to explain how we deal with that:

      Example #1:

      Image comes in as    ________    But it needs to be     ┌──────┐
      horizontal picture  |        |   displayed as 750x1000  │      │
      of 1000x750         |        |   because orientation    │      │
                          |________|   say it must be rotated │      │
                                       90 degrees             │      │
                                                              └──────┘

      Container is smaller, and has dimensions of 100x200.
      So, input parameters are:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: true (means we want to cover)
        stretch: true
        previewOrientation: 6

      To see what true value of isImageMoreLandscapyThanContainer is we need to flip imgRatio.
      Since initial value is 1000/750 = 1.33 we can just do 1/1.3333 = 0.75.

      In this situation final values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: true
        isFitStrategy: false
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true

      According to this variables state css will become:
        height: 100%;

      Now here is what going to happened.
      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply height: 100%.

      ┌────┬──────┬────┐  This will scale an image according to rules of proportions:
      │░░░░│▓▓▓▓▓▓│░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      │░░░░│▓▓▓▓▓▓│░░░░│  (orig img height) -> (scaled down img height)
      │░░░░│▓▓▓▓▓▓│░░░░│  750px             -> 200px  (is === container height, since `height: 100%`)
      └────┴──────┴────┘  (orig img width)  -> (scaled down img width)
              ↑           1000px            -> (200 x 1000) / 750 = 266.66px
       266x200 image in
       100x200 container.

      And only NOW browser will apply rotate: 90deg and turn image around.
      And we end up with this:

      ┌──────────┐   Where 200x266 image
      │░░░░░░░░░░│   in the 100x200 container.
      │░┌──────┐░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░└──────┘░│
      │░░░░░░░░░░│
      └──────────┘

      To combat this we will not make height: 100% but use ratio of an image.
      In this case imgRatio is now 0.75 (after flipping)

      New math will look like this:
      (orig img height) -> (scaled down img height)
      750px             -> (0.75 x 200px) = 150px (since `height: 75%`)
      (orig img width)  -> (scaled down img width)
      1000px            -> (150 x 1000) / 750 = 200px

      ┌─┬──────┬─┐  Now 150x200 image
      │░│▓▓▓▓▓▓│░│  is in 100x200 container.
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      └─┴──────┴─┘

      Unfortunately this is not over yet.



      Example #2:

      Input parameters:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: false (means we want to fit)  <-- This is only changed parameter
        stretch: true
        previewOrientation: 6

      Final variable values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: false
        isFitStrategy: true
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true

       According to this variables state css will become:
        width: 100%;

      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply width: 100%.

      ┌────────┐  This will scale an image according to rules of proportions:
      │░░░░░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      ├────────┤  (orig img width)  -> (scaled down img width)
      │▓▓▓▓▓▓▓▓│  1000px            -> 100px (is === container width, since `width: 100%`)
      │▓▓▓▓▓▓▓▓│  (orig img height) -> (scaled down img height)
      ├────────┤  750px             -> (750x100) / 1000 = 75px
      │░░░░░░░░│
      └────────┘
          ↑
       100x75 image in
       100x200 container.

      Now browser will turn image 90degrees and we und up with:
      ┌──────────┐
      │          │  75x100 image in
      │ ┌──────┐ │  100x200 container
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ └──────┘ │
      │          │
      └──────────┘

      This looks familiar, and you might want to try what we did before and apply 75% not 100%.
      Unfortunately this will make it even worse. If you do calculation you will find out that
      final result will be 75x56 image in 100x200 container. For this and one more specific
      variables state we need to use original imgRatio for percent size. In this case it's 1.333, so
      134%

      New math will look like this:
      (orig img width)  -> (scaled down img width)
      1000px            -> (100px * 1.34) = 134px (since `width: 134%`)
      (orig img height) -> (scaled down img height)
      750px             -> (750x134) / 1000 = 100px

      So, 100x134 image in 100x200 container.
     */ if (isImageRotated) {
        imgRatio = 1 / imgRatio;
        percentSize = `${Math.ceil(imgRatio * 100)}%`;
    }
    /*
      Here is an example of when isImageMoreLandscapyThanContainer is true:

        Image      Container   OR   Image      Container
       ________      _____          ____           __
      |        | -> |     |        |    |   ->    |  |
      |________|    |_____|        |    |         |  |
                                   |    |         |  |
                                   |    |         |  |
                                   |____|         |__|

      For false just swap "Image" and "Container" in the example above.
     */ const isImageMoreLandscapyThanContainer = imgRatio > parentRatio;
    const isImgLandscape = imgWidth > imgHeight;
    /*
    This is two cases we need to cover as described in Example #2 above, but only for rotated landscape images.
     */ if (isImageRotated && isImgLandscape) {
        if (isFitStrategy || isImageMoreLandscapyThanContainer || isCoverStrategy && !isImageMoreLandscapyThanContainer) percentSize = `${Math.ceil(1 / imgRatio * 100)}%`;
    }
    /*
      When isStretchingAllowed is false image is as big as it is, but as small as container
      (according to strategy - cover or fit).
      isStretchingAllowed is true if image is bigger then container.
     */ const isStretchingAllowed = stretch;
    /*
      We do not want to show image until we finish deciding on sizing strategy.
      Though if it is a "fit" strategy (and image hasn't been rotated) we can display it right away,
      since it doesn't depend on isImageMoreLandscapyThanContainer nor it will change when isStretchingAllowed
      changes it's value after imgRatio and parentRatio get defined.
      The reason for exclude isImageRotated is that we need to calculate percentSize variable
      and we can do that only when image is loaded (and we have image size)
     */ const showImage = forceSyncDisplay || isImageLoaded || isFitStrategy && !isImageRotated;
    const style = {
        transform: 'translate(-50%, -50%)'
    };
    if (isStretchingAllowed) {
        if (isFitStrategy && isImageMoreLandscapyThanContainer) /*
          Image matches its width to container's and height scales accordingly.

            Image       Container       Result
                       ┌─────────┐    ┌─────────┐
           ┌──────┐    │         │    ├─────────┤
           │▓▓▓▓▓▓│ -> │         │ => │▓▓▓▓▓▓▓▓▓│
           │▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
           └──────┘    │         │    ├─────────┤
                       └─────────┘    └─────────┘
         */ style.width = percentSize;
        else if (isFitStrategy && !isImageMoreLandscapyThanContainer) /*
          Image matches its height to container's and width scales accordingly.
         */ style.height = percentSize;
        else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
          In order to cover whole container guaranteed (even in expense of stretching)
          image matches its height to container's. Width scales accordingly and crops out sides.

             Image       Container    Result (░ - is what cropped out)
                       ┌─────────┐    ┌──┬──────┬──┐
           ┌──────┐    │         │    │░░│▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓│ -> │         │ => │░░│▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓│    │         │    │░░│▓▓▓▓▓▓│░░│
           └──────┘    │         │    │░░│▓▓▓▓▓▓│░░│
                       └─────────┘    └──┴──────┴──┘
         */ style.height = percentSize;
        else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.width = percentSize;
    } else {
        if (isFitStrategy) {
            /*
          We want image to be as wide and as height as container but not bigger then it's own size.

            Image       Container       Result
           ┌───────────┐    ┌─────────┐    ┌─────────┐
           │▓▓▓▓▓▓▓▓▓▓▓│    │         │    ├─────────┤
           │▓▓▓▓▓▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
           │▓▓▓▓▓▓▓▓▓▓▓│->  │         │ => │▓▓▓▓▓▓▓▓▓│
           └───────────┘    │         │    │▓▓▓▓▓▓▓▓▓│
                            │         │    ├─────────┤
                            └─────────┘    └─────────┘

         And if image is smaller it doesn't change its size

            Image       Container       Result
                       ┌──────────┐    ┌──────────┐
                       │          │    │          │
           ┌──────┐    │          │    │ ┌──────┐ │
           │▓▓▓▓▓▓│ -> │          │ => │ │▓▓▓▓▓▓│ │
           │▓▓▓▓▓▓│    │          │    │ │▓▓▓▓▓▓│ │
           └──────┘    │          │    │ └──────┘ │
                       │          │    │          │
                       └──────────┘    └──────────┘
         */ style.maxWidth = percentSize;
            style.maxHeight = percentSize;
        } else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
          We want to fill container but we can't stretch an image if it's smaller then container.

            Image            Container       Result
           ┌────────────┐    ┌───────┐    ┌──┬───────┬──┐
           │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│->  │       │ => │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│    └───────┘    └──┴───────┴──┘
           └────────────┘

         */ style.maxHeight = percentSize;
        else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.maxWidth = percentSize;
    }
    if (!showImage || !dataURI) style.display = 'none';
    if (previewOrientation === 'from-image') style.imageOrientation = 'from-image';
    else if (previewOrientation > 1) {
        const transform = (0, $k4fr0.getCssFromImageOrientation)(previewOrientation);
        style.transform += ` ${transform}`;
    }
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            (0, $hFKXd.fg)('platform_media_add_ufo_custom_data') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $itfHy.default), {
                data: {
                    hasMediaComponent: true
                }
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eevtr.ImageComponent), {
                loading: loading,
                "data-testid": "media-image",
                "data-vc": "media-image",
                draggable: false,
                alt: alt,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                onLoad: imageLoadHandler,
                onError: onImageError,
                imageRef: mergedRef,
                src: dataURI,
                crossOrigin: crossOrigin,
                ...(0, $hFKXd.fg)('platform_exclude_media_offender_from_vc') && (0, $kXjCv.VcMediaWrapperProps)
            })
        ]
    });
});

});
parcelRegister("itfHy", function(module, exports) {

$parcel$export(module.exports, "default", () => $7025b2352a93d0be$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $7025b2352a93d0be$export$d12f56a472cdbe6c);

var $5uXOq = parcelRequire("5uXOq");

var $khUYu = parcelRequire("khUYu");

var $6q86P = parcelRequire("6q86P");

var $7E9G2 = parcelRequire("7E9G2");
function $7025b2352a93d0be$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $khUYu.default));
    (0, $5uXOq.useMemo)(()=>{
        if (!interactionContext) return;
        if (typeof globalThis?.structuredClone === 'function') interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $7025b2352a93d0be$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $6q86P.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    if (typeof globalThis?.structuredClone === 'function') (0, $7E9G2.addCustomData)(currentInteractionId, [], globalThis.structuredClone(data));
    else (0, $7E9G2.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("eevtr", function(module, exports) {

$parcel$export(module.exports, "ImageComponent", () => $42547327cdae0f27$export$fd536c918b58ab76);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
/*
  TODO: https://product-fabric.atlassian.net/browse/CXP-3132

  We need to revisit omitting percentage values for Design Token since the parent applies transform(-50%, -50%) on it (packages/media/media-ui/src/mediaImage/index.tsx). This styling is complex and may potentially cause a bug if not treaded carefully.
*/ const $42547327cdae0f27$var$imgStyle = {
    position: 'absolute',
    left: '50%',
    top: '50%',
    objectFit: 'contain',
    imageOrientation: 'none'
};
const $42547327cdae0f27$export$fd536c918b58ab76 = (props)=>{
    const { style: style, imageRef: imageRef, ...otherProps } = props;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, jsx-a11y/alt-text -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        ...otherProps,
        ref: imageRef,
        style: {
            ...$42547327cdae0f27$var$imgStyle,
            ...style
        }
    }));
};

});


parcelRegister("1jG3J", function(module, exports) {

$parcel$export(module.exports, "InlineImageCardLoadingView", () => $8a88dc53e34923fc$export$4b1a62d8f05056a7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $dyckQ = parcelRequire("dyckQ");


var $g4EN8 = parcelRequire("g4EN8");
const $8a88dc53e34923fc$export$4b1a62d8f05056a7 = ({ testId: testId = 'media-inline-image-card-loading-view', height: height = (0, $96cd52eb2b2c7b08$export$88e3664eef60c981) })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $g4EN8.Frame), {
        testId: testId
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dyckQ.default), {
        size: height > (0, $96cd52eb2b2c7b08$export$88e3664eef60c981) ? 'medium' : 'small',
        interactionName: "media-inline-spinner"
    }));
};

});
/** Height threshold that determines icon size to be small or medium */ const $96cd52eb2b2c7b08$export$88e3664eef60c981 = 24;

parcelRegister("g4EN8", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $d406ecc99a5e9b8c$export$b89a827e9254211a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $dYeGg = parcelRequire("dYeGg");
const $d406ecc99a5e9b8c$export$b89a827e9254211a = ({ children: children, testId: testId })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: (0, $dYeGg.wrapperStyle),
        "data-testid": testId
    }, children);

});
parcelRegister("dYeGg", function(module, exports) {

$parcel$export(module.exports, "wrapperStyle", () => $53ed0a67356f457a$export$c4d4f06a25de97f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $53ed0a67356f457a$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    boxDecorationBreak: 'clone',
    borderRadius: `${"var(--ds-border-radius, 3px)"}`,
    color: `${"var(--ds-text, #172B4D)"}`,
    backgroundColor: `${"var(--ds-background-neutral, #091E420F)"}`,
    transition: '0.1s all ease-in-out',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: `${"var(--ds-background-neutral-hovered, #091E4224)"}`
    }
});

});




parcelRegister("1V0Bs", function(module, exports) {

$parcel$export(module.exports, "InlineImageWrapper", () => $db968136d6d12169$export$8519fee8cc913056);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $kFNiy = parcelRequire("kFNiy");

var $2PwGo = parcelRequire("2PwGo");
function $db968136d6d12169$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// The MediaImage component needs to obtain its parent's dimensions.
// To achieve this, we have added an additional wrapper that allows
// for better interaction with the parent element. This is necessary
//  because the parent size changes its box-sizing with the node border.
const $db968136d6d12169$var$sizeWrapperStyle = {
    name: "1ogmv4n",
    styles: "display:inline-flex;width:100%;height:100%"
};
const $db968136d6d12169$export$8519fee8cc913056 = ({ children: children, isSelected: isSelected, aspectRatio: aspectRatio, borderSize: borderSize, borderColor: borderColor, htmlAttrs: htmlAttrs = {}, onClick: onClick })=>{
    const borderStyleVars = borderSize && borderColor ? {
        [(0, $2PwGo.INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY)]: borderSize,
        [(0, $2PwGo.INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY)]: (0, $kFNiy.hexToEditorBorderPaletteColor)(borderColor) || borderColor
    } : {};
    const aspectStyleVars = aspectRatio ? {
        [(0, $2PwGo.INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY)]: aspectRatio
    } : {};
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...borderStyleVars,
            ...aspectStyleVars
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $2PwGo.INLINE_IMAGE_WRAPPER_CLASS_NAME),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $2PwGo.wrapperStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            borderSize && borderColor && (0, $2PwGo.borderStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isSelected && (0, $2PwGo.selectedStyle)
        ],
        "data-testid": "inline-image-wrapper",
        onClick: onClick,
        ...htmlAttrs
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $db968136d6d12169$var$sizeWrapperStyle
    }, children)));
};

});

parcelRegister("8DPuN", function(module, exports) {

$parcel$export(module.exports, "InlineImageCardErrorView", () => $37c169d56671213a$export$cbdc50f98f4f8d00);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $gCFQs = parcelRequire("gCFQs");

var $9fYN9 = parcelRequire("9fYN9");


var $g4EN8 = parcelRequire("g4EN8");

var $eM6LC = parcelRequire("eM6LC");
const $37c169d56671213a$export$cbdc50f98f4f8d00 = ({ testId: testId = 'media-inline-image-card-error-view', message: message, icon: icon, height: height = (0, $96cd52eb2b2c7b08$export$88e3664eef60c981) })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $g4EN8.Frame), {
        testId: testId
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9fYN9.default), {
        content: message,
        position: "top",
        tag: "span",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eM6LC.IconWrapper), null, icon || /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gCFQs))), {
        label: "error",
        LEGACY_size: height > (0, $96cd52eb2b2c7b08$export$88e3664eef60c981) ? 'medium' : 'small',
        color: "var(--ds-icon-danger, #C9372C)"
    }))));
};

});
parcelRegister("eM6LC", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $5755f4ab7e27bc3c$export$be58b4326e23250f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $5755f4ab7e27bc3c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5755f4ab7e27bc3c$var$wrapperStyle = {
    name: "1xutr1y",
    styles: "display:flex;span > svg{vertical-align:top;}"
};
const $5755f4ab7e27bc3c$export$be58b4326e23250f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $5755f4ab7e27bc3c$var$wrapperStyle,
        "data-testid": "media-inline-image-card-icon"
    }, children);
};

});



parcelRegister("bcBme", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae82ab99d44ecf3b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8EjzJ = parcelRequire("8EjzJ");

var $kbNdD = parcelRequire("kbNdD");



class $ae82ab99d44ecf3b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.displayName = 'MediaInlineCardLoader';
    }
    async componentDidMount() {
        this.mounted = true;
        if (!this.state.MediaInlineCard) try {
            const [mediaClient, cardModule, mediaInlineErrorBoundaryModule] = await Promise.all([
                (parcelRequire("bFVuK")),
                (parcelRequire("fPz72")),
                (parcelRequire("gT9up"))
            ]);
            $ae82ab99d44ecf3b$export$2e2bcd8739ae039.MediaInlineCard = mediaClient.withMediaClient(cardModule.MediaInlineCard);
            $ae82ab99d44ecf3b$export$2e2bcd8739ae039.ErrorBoundary = mediaInlineErrorBoundaryModule.default;
            if (this.mounted) this.setState({
                MediaInlineCard: $ae82ab99d44ecf3b$export$2e2bcd8739ae039.MediaInlineCard,
                ErrorBoundary: $ae82ab99d44ecf3b$export$2e2bcd8739ae039.ErrorBoundary
            });
        } catch (error) {}
    }
    async componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { MediaInlineCard: MediaInlineCard, ErrorBoundary: ErrorBoundary } = this.state;
        const analyticsContext = {
            packageVersion: "platform-pkg",
            packageName: "0.0.0-use.local",
            componentName: 'mediaInlineCard',
            component: 'mediaInlineCard'
        };
        if (!MediaInlineCard || !ErrorBoundary) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8EjzJ.MediaInlineCardLoadingView), {
            message: ""
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kbNdD.default), {
            data: analyticsContext,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(ErrorBoundary, {
                isSelected: this.props.isSelected,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(MediaInlineCard, {
                    ...this.props
                })
            })
        });
    }
    constructor(...args){
        super(...args), this.mounted = false, this.state = {
            MediaInlineCard: $ae82ab99d44ecf3b$export$2e2bcd8739ae039.MediaInlineCard,
            ErrorBoundary: $ae82ab99d44ecf3b$export$2e2bcd8739ae039.ErrorBoundary
        };
    }
}

});
parcelRegister("8EjzJ", function(module, exports) {

$parcel$export(module.exports, "MediaInlineCardLoadingView", () => $06c48c1c00069291$export$4449fcbb2ad61ad1);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $e2OJZ = parcelRequire("e2OJZ");

var $dyckQ = parcelRequire("dyckQ");

var $iZn6M = parcelRequire("iZn6M");

var $8xURW = parcelRequire("8xURW");

var $iyPVk = parcelRequire("iyPVk");
class $06c48c1c00069291$export$4449fcbb2ad61ad1 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { message: message, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, innerRef: innerRef, testId: testId = 'media-inline-card-loading-view' } = this.props;
        if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e2OJZ.Frame), {
            innerRef: innerRef,
            testId: testId,
            onClick: onClick,
            isSelected: isSelected,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $iyPVk.IconTitleWrapper), {
                children: [
                    message,
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iyPVk.RightIconPositionWrapper), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8xURW.SpinnerWrapper), {
                            className: "inline-loading-spinner",
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dyckQ.default), {
                                size: 14
                            })
                        })
                    })
                ]
            })
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e2OJZ.Frame), {
            innerRef: innerRef,
            testId: testId,
            onClick: onClick,
            isSelected: isSelected,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iZn6M.IconAndTitleLayout), {
                title: message,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8xURW.SpinnerWrapper), {
                    className: "inline-loading-spinner",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dyckQ.default), {
                        size: 14
                    })
                })
            })
        });
    }
}

});
parcelRegister("e2OJZ", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $50923072b60b1a1f$export$b89a827e9254211a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bhCNH = parcelRequire("bhCNH");
class $50923072b60b1a1f$export$b89a827e9254211a extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isSelected: isSelected, children: children, onClick: onClick, innerRef: innerRef, testId: testId } = this.props;
        const isInteractive = Boolean(onClick);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bhCNH.Wrapper), {
            ref: innerRef,
            isSelected: isSelected,
            tabIndex: isInteractive ? 0 : undefined,
            role: isInteractive ? 'button' : undefined,
            onClick: this.handleClick,
            onKeyPress: this.handleKeyPress,
            "data-testid": testId,
            children: children
        });
    }
    constructor(...args){
        super(...args), this.handleClick = (event)=>{
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        }, this.handleKeyPress = (event)=>{
            if (event.key !== ' ' && event.key !== 'Enter') return;
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        };
    }
}

});
parcelRegister("bhCNH", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $ed3ac356062f220c$export$e6dfd72ab29f8598);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kyFKc = parcelRequire("kyFKc");

var $8cdfu = parcelRequire("8cdfu");

var $hFKXd = parcelRequire("hFKXd");
const $ed3ac356062f220c$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>(0, $hFKXd.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8cdfu.Wrapper), {
        ...props,
        ref: ref
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kyFKc.Wrapper), {
        ...props,
        ref: ref
    }));

});
parcelRegister("kyFKc", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $431428146c336393$export$e6dfd72ab29f8598);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
const $431428146c336393$var$selected = `
  cursor: pointer;
  box-shadow: 0 0 0 1px ${`var(--ds-border-selected, ${(0, $dbda9f692ace54dd$export$e62e8919cca44969)})`};
  outline: none;
  user-select: none;
  border-color: transparent;
  &, :hover, :focus, :active {
    text-decoration: none;
  }
`;
const $431428146c336393$var$isSelected = ({ isSelected: isSelected })=>{
    if (isSelected) return $431428146c336393$var$selected;
    else return 'user-select: text';
};
const $431428146c336393$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e1t1vqsr0"
})({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
    boxDecorationBreak: 'clone',
    display: 'inline',
    borderRadius: "var(--ds-border-radius, 3px)",
    color: `var(--ds-text, ${(0, $dbda9f692ace54dd$export$fbda843f0a27fe96)})`,
    backgroundColor: `var(--ds-background-neutral, ${(0, $dbda9f692ace54dd$export$920c0d5c49070351)})`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>$431428146c336393$var$isSelected(props), {
    transition: '0.1s all ease-in-out',
    MozUserSelect: 'none',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $dbda9f692ace54dd$export$46987b49aab6d1a8)})`
    }
});

});

parcelRegister("8cdfu", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $70fa6ca8c7d2dcfa$export$e6dfd72ab29f8598);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $70fa6ca8c7d2dcfa$var$selectedStyles = null;
const $70fa6ca8c7d2dcfa$var$notSelectedStyles = null;
const $70fa6ca8c7d2dcfa$var$wrapperStyles = null;
const $70fa6ca8c7d2dcfa$export$e6dfd72ab29f8598 = ({ isSelected: isSelected, children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": "frame-wrapper",
        ...props,
        className: (0, $bwpsq.default)([
            "_2rko1sit _v56415x0 _vwz47vkz _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _16d9qvcn _1e0c1nu9 _syazj3m3 _bfhk155y _1rkwglyw _80omtlke _irr3u9me",
            isSelected && "_12ji1r31 _1qu2glyw _12y31o36 _1h6d3acm _80omtlke _16qs1s9b _uiztglyw _4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1",
            !isSelected && "_uizt1kdv"
        ]),
        children: children
    });

});



parcelRegister("iZn6M", function(module, exports) {

$parcel$export(module.exports, "IconAndTitleLayout", () => $6094b705db9efdfe$export$d34be4d513116847);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bmnhy = parcelRequire("bmnhy");

var $k2AC9 = parcelRequire("k2AC9");

var $iyPVk = parcelRequire("iyPVk");

var $7Z43S = parcelRequire("7Z43S");
class $6094b705db9efdfe$export$d34be4d513116847 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    renderAtlaskitIcon() {
        const { icon: icon, emoji: emoji } = this.props;
        if (emoji) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iyPVk.EmojiWrapper), {
            children: emoji
        });
        if (!icon || typeof icon === 'string') return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iyPVk.IconWrapper), {
            children: icon
        });
    }
    renderImageIcon(errored, testId) {
        const { icon: url } = this.props;
        if (!url || typeof url !== 'string') return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmnhy))), {
            src: url,
            loaded: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k2AC9.Icon), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: "smart-link-icon",
                src: url,
                "data-testid": `${testId}-image`
            }),
            errored: errored
        });
    }
    renderIconPlaceholder(testId) {
        const { defaultIcon: defaultIcon } = this.props;
        if (defaultIcon) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iyPVk.IconWrapper), {
            children: defaultIcon
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iyPVk.IconWrapper), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7Z43S))), {
                color: "currentColor",
                label: "link",
                LEGACY_size: "small",
                testId: `${testId}-default`
            })
        });
    }
    renderIcon(testId) {
        // We render two kinds of icons here:
        // - Image: acquired from either DAC or Teamwork Platform Apps;
        // - Atlaskit Icon: an Atlaskit SVG;
        // Each of these are scaled down to 12x12.
        const icon = this.renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = this.renderIconPlaceholder(testId);
        const image = this.renderImageIcon(placeholder, testId);
        return image || placeholder;
    }
    render() {
        const { children: children, title: title, titleColor: titleColor, testId: testId = 'media-inline-card-icon-and-title' } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $iyPVk.IconTitleWrapper), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: titleColor ? {
                    color: titleColor
                } : undefined,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iyPVk.IconPositionWrapper), {
                        children: children || /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iyPVk.IconEmptyWrapper), {}),
                                this.renderIcon(testId)
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        "data-test-id": "title",
                        children: title
                    })
                ]
            })
        });
    }
}

});
parcelRegister("bmnhy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8453cf1ee7ef4644$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5uXOq = parcelRequire("5uXOq");
var $8453cf1ee7ef4644$var$React = $8453cf1ee7ef4644$var$_interopRequireWildcard($5uXOq);
function $8453cf1ee7ef4644$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $8453cf1ee7ef4644$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8453cf1ee7ef4644$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8453cf1ee7ef4644$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $8453cf1ee7ef4644$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $8453cf1ee7ef4644$var$loaded() {
    return {
        isLoaded: true
    };
}
function $8453cf1ee7ef4644$var$errored() {
    return {
        isErrored: true
    };
}
function $8453cf1ee7ef4644$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $8453cf1ee7ef4644$var$ImageRenderer = function(_React$Component) {
    $8453cf1ee7ef4644$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $8453cf1ee7ef4644$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $8453cf1ee7ef4644$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($8453cf1ee7ef4644$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($8453cf1ee7ef4644$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $8453cf1ee7ef4644$var$_possibleConstructorReturn(_this, _ret);
    }
    $8453cf1ee7ef4644$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($8453cf1ee7ef4644$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($8453cf1ee7ef4644$var$hasPropsChanged(this.props, nextProps)) this.setState($8453cf1ee7ef4644$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($8453cf1ee7ef4644$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($8453cf1ee7ef4644$var$React.Component);
module.exports.default = $8453cf1ee7ef4644$var$ImageRenderer;

});

parcelRegister("k2AC9", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $c4afabac7cc236f6$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $c4afabac7cc236f6$export$a201b065fc2e76a1);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kt3zF = parcelRequire("kt3zF");

var $gdEG2 = parcelRequire("gdEG2");

var $hFKXd = parcelRequire("hFKXd");
const $c4afabac7cc236f6$export$f04a61298a47a40f = (props)=>(0, $hFKXd.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gdEG2.Icon), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kt3zF.Icon), {
        ...props
    });
const $c4afabac7cc236f6$export$a201b065fc2e76a1 = (props)=>(0, $hFKXd.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gdEG2.AKIconWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kt3zF.AKIconWrapper), {
        ...props
    });

});
parcelRegister("kt3zF", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $14a3c1636ccfadb5$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $14a3c1636ccfadb5$export$a201b065fc2e76a1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
function $14a3c1636ccfadb5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $14a3c1636ccfadb5$export$f04a61298a47a40f = /*#__PURE__*/ (0, $bWGt6.default)("img", {
    target: "ebf58rv1"
})({
    name: "15ahtvm",
    styles: "height:14px;width:14px;margin-right:var(--ds-space-050, 4px);border-radius:2px;user-select:none;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
});
$14a3c1636ccfadb5$export$f04a61298a47a40f.defaultProps = {
    alt: 'icon'
};
const $14a3c1636ccfadb5$export$a201b065fc2e76a1 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ebf58rv0"
})({
    name: "18dmqdk",
    styles: "margin-right:var(--ds-space-negative-025, -2px)"
});

});

parcelRegister("gdEG2", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $58132e4fe62dbb4d$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $58132e4fe62dbb4d$export$a201b065fc2e76a1);
/* Icon-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Figure out a more scalable/responsive solution
// for vertical alignment.
// Current rationale: vertically positioned at the top of
// the smart card container (when set to 0). Offset this
// to position it with appropriate whitespace from the top.

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $58132e4fe62dbb4d$var$iconStyles = null;
const $58132e4fe62dbb4d$export$f04a61298a47a40f = ({ alt: alt, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        alt: alt || 'icon',
        ...props,
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _4t3idlk8 _1bsbdlk8 _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
        ])
    });
// Used for 'untrue' icons which claim to be 16x16 but
// are less than that in height/width.
// TODO: Replace this override with proper AtlasKit solution.
const $58132e4fe62dbb4d$var$akIconWrapperStyles = null;
const $58132e4fe62dbb4d$export$a201b065fc2e76a1 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_2hwx1i6y"
        ]),
        children: children
    });

});


parcelRegister("iyPVk", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $5c6f2a82b6007ce9$export$be58b4326e23250f);
$parcel$export(module.exports, "EmojiWrapper", () => $5c6f2a82b6007ce9$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "IconTitleWrapper", () => $5c6f2a82b6007ce9$export$c73a53738ef9e3f);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $5c6f2a82b6007ce9$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $5c6f2a82b6007ce9$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $5c6f2a82b6007ce9$export$ddce81e032b0736e);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bslvu = parcelRequire("bslvu");

var $2SOVU = parcelRequire("2SOVU");

var $hFKXd = parcelRequire("hFKXd");
const $5c6f2a82b6007ce9$export$be58b4326e23250f = (props)=>(0, $hFKXd.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2SOVU.IconWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bslvu.IconWrapper), {
        ...props
    });
const $5c6f2a82b6007ce9$export$e31a6cc0a4c97f0e = (props)=>(0, $hFKXd.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2SOVU.EmojiWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bslvu.EmojiWrapper), {
        ...props
    });
const $5c6f2a82b6007ce9$export$c73a53738ef9e3f = (props)=>(0, $hFKXd.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2SOVU.IconTitleWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bslvu.IconTitleWrapper), {
        ...props
    });
const $5c6f2a82b6007ce9$export$75180efdd3f4d9c2 = (props)=>(0, $hFKXd.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2SOVU.LozengeWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bslvu.LozengeWrapper), {
        ...props
    });
const $5c6f2a82b6007ce9$export$a16269f205a2f280 = (props)=>(0, $hFKXd.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2SOVU.LozengeBlockWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bslvu.LozengeBlockWrapper), {
        ...props
    });
const $5c6f2a82b6007ce9$export$91b164375b8037b5 = (props)=>(0, $hFKXd.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2SOVU.RightIconPositionWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bslvu.RightIconPositionWrapper), {
        ...props
    });
const $5c6f2a82b6007ce9$export$7291f9f954790243 = (props)=>(0, $hFKXd.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2SOVU.IconPositionWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bslvu.IconPositionWrapper), {
        ...props
    });
const $5c6f2a82b6007ce9$export$ddce81e032b0736e = (props)=>(0, $hFKXd.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2SOVU.IconEmptyWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bslvu.IconEmptyWrapper), {
        ...props
    });

});
parcelRegister("bslvu", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $6bb697b3815ce608$export$be58b4326e23250f);
$parcel$export(module.exports, "EmojiWrapper", () => $6bb697b3815ce608$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "IconTitleWrapper", () => $6bb697b3815ce608$export$c73a53738ef9e3f);
$parcel$export(module.exports, "LozengeWrapper", () => $6bb697b3815ce608$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "LozengeBlockWrapper", () => $6bb697b3815ce608$export$a16269f205a2f280);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $6bb697b3815ce608$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $6bb697b3815ce608$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $6bb697b3815ce608$export$ddce81e032b0736e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
function $6bb697b3815ce608$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6bb697b3815ce608$export$b993aa7bab57be12 = `
  & > span {
    height: 16px;
    width: 14px;
    position: absolute;
    top: 0;
    left: 0;
    line-height: 14px;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $6bb697b3815ce608$export$ded9fa9f58c8840e = `
  & > * > span {
    height: 16px;
    width: 14px;
    position: absolute;
    top: 0;
    left: 0;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $6bb697b3815ce608$export$be58b4326e23250f = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ec5pts57"
})("user-select:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$6bb697b3815ce608$export$ded9fa9f58c8840e, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$6bb697b3815ce608$export$b993aa7bab57be12);
const $6bb697b3815ce608$export$e31a6cc0a4c97f0e = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ec5pts56"
})("display:inline-block;margin-right:var(--ds-space-025, 2px);user-select:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$6bb697b3815ce608$export$ded9fa9f58c8840e, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$6bb697b3815ce608$export$b993aa7bab57be12);
const $6bb697b3815ce608$export$c73a53738ef9e3f = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ec5pts55"
})({
    name: "1h3cbh4",
    styles: "white-space:pre-wrap;word-break:break-all"
});
const $6bb697b3815ce608$export$75180efdd3f4d9c2 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ec5pts54"
})({
    display: 'inline-block',
    verticalAlign: '1px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        marginLeft: "var(--ds-space-050, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"} 0`
    }
});
const $6bb697b3815ce608$export$a16269f205a2f280 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ec5pts53"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        marginLeft: "var(--ds-space-050, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"} 0`
    }
});
const $6bb697b3815ce608$export$91b164375b8037b5 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ec5pts52"
})({
    name: "1v89jht",
    styles: "margin-left:var(--ds-space-025, 2px);margin-right:var(--ds-space-050, 4px);position:relative;display:inline-block"
});
const $6bb697b3815ce608$export$7291f9f954790243 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ec5pts51"
})({
    name: "166gprz",
    styles: "margin-right:var(--ds-space-050, 4px);position:relative;display:inline-block"
});
const $6bb697b3815ce608$export$ddce81e032b0736e = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ec5pts50"
})({
    name: "vehdi",
    styles: "width:14px;height:100%;display:inline-block;opacity:0"
});

});

parcelRegister("2SOVU", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $73b120668fd4f969$export$be58b4326e23250f);
$parcel$export(module.exports, "EmojiWrapper", () => $73b120668fd4f969$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "IconTitleWrapper", () => $73b120668fd4f969$export$c73a53738ef9e3f);
$parcel$export(module.exports, "LozengeWrapper", () => $73b120668fd4f969$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "LozengeBlockWrapper", () => $73b120668fd4f969$export$a16269f205a2f280);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $73b120668fd4f969$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $73b120668fd4f969$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $73b120668fd4f969$export$ddce81e032b0736e);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// TODO: remove this override behaviour for @atlaskit/icon-object

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $73b120668fd4f969$var$iconObjectOverrideStyles = null;
// TODO: remove this override behaviour for @atlaskit/icon
const $73b120668fd4f969$var$iconOverrideStyles = null;
const $73b120668fd4f969$var$iconWrapperStyles = null;
const $73b120668fd4f969$export$be58b4326e23250f = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_uiztglyw",
            "_1f027vkz _nbgxdlk8 _4d7tstnw _o5fvidpf _3g5ridpf _z6uadlk8 _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            "_17047vkz _iibfdlk8 _lacastnw _1kd9idpf _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe"
        ]),
        children: children
    });
const $73b120668fd4f969$var$emojiWrapperStyles = null;
const $73b120668fd4f969$export$e31a6cc0a4c97f0e = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _2hwxv77o _uiztglyw",
            "_1f027vkz _nbgxdlk8 _4d7tstnw _o5fvidpf _3g5ridpf _z6uadlk8 _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            "_17047vkz _iibfdlk8 _lacastnw _1kd9idpf _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe"
        ]),
        children: children
    });
const $73b120668fd4f969$var$iconTitleWrapperStyles = null;
const $73b120668fd4f969$export$c73a53738ef9e3f = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_o5721jtm _1nmz9jpi"
        ]),
        children: children
    });
const $73b120668fd4f969$var$lozengeWrapperStyles = null;
const $73b120668fd4f969$export$75180efdd3f4d9c2 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _s7n4t94y _1msp1b66 _1at8v77o _hjaqidpf _1cjov77o _1yg6idpf"
        ]),
        children: children
    });
const $73b120668fd4f969$var$lozengeBlockWrapperStyles = null;
const $73b120668fd4f969$export$a16269f205a2f280 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_1msp1b66 _1at8v77o _hjaqidpf _1cjov77o _1yg6idpf"
        ]),
        children: children
    });
const $73b120668fd4f969$var$rightIconPositionWrapperStyles = null;
const $73b120668fd4f969$export$91b164375b8037b5 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_18u0v77o _2hwx1b66 _kqswh2mm _1e0c1o8l"
        ]),
        children: children
    });
const $73b120668fd4f969$var$iconPositionWrapperStyles = null;
const $73b120668fd4f969$export$7291f9f954790243 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_2hwx1b66 _kqswh2mm _1e0c1o8l"
        ]),
        children: children
    });
const $73b120668fd4f969$var$iconEmptyWrapperStyles = null;
const $73b120668fd4f969$export$ddce81e032b0736e = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_1bsbdlk8 _4t3i1osq _1e0c1o8l _tzy4idpf"
        ]),
        children: children
    });

});



parcelRegister("8xURW", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $dfc40814f6ac3482$export$52b4dfd89a6b3a1b);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hwJ7y = parcelRequire("hwJ7y");

var $aESUi = parcelRequire("aESUi");

var $hFKXd = parcelRequire("hFKXd");
const $dfc40814f6ac3482$export$52b4dfd89a6b3a1b = (props)=>(0, $hFKXd.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aESUi.SpinnerWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hwJ7y.SpinnerWrapper), {
        ...props
    });

});
parcelRegister("hwJ7y", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $8878ed6189069d10$export$52b4dfd89a6b3a1b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bslvu = parcelRequire("bslvu");

var $bWGt6 = parcelRequire("bWGt6");
function $8878ed6189069d10$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8878ed6189069d10$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $bWGt6.default)((0, $bslvu.IconTitleWrapper), {
    target: "e9a5khx0"
})({
    name: "1hde2gn",
    styles: "vertical-align:baseline;margin-left:var(--ds-space-025, 2px)"
});

});

parcelRegister("aESUi", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $c2f583825881f674$export$52b4dfd89a6b3a1b);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $c2f583825881f674$var$spinnerWrapperStyles = null;
const $c2f583825881f674$export$52b4dfd89a6b3a1b = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_o5721jtm _1nmz9jpi _s7n418uv _18u0v77o"
        ]),
        children: children
    });

});



parcelRegister("bFVuK", function(module, exports) {

let $88001f5bd2f70933$var$load = (parcelRequire("loK1v"))(4);
module.exports = $88001f5bd2f70933$var$load("01Aye").then(()=>parcelRequire('4gYZm'));

});

parcelRegister("fPz72", function(module, exports) {

let $b866db0dd5d23981$var$load = (parcelRequire("loK1v"))(4);
module.exports = Promise.all([
    $b866db0dd5d23981$var$load("aCh9P"),
    $b866db0dd5d23981$var$load("bxxT5"),
    $b866db0dd5d23981$var$load("cABv4")
]).then(()=>parcelRequire('6XCkR'));

});

parcelRegister("gT9up", function(module, exports) {

let $c4b924c88c6f68fb$var$load = (parcelRequire("loK1v"))(4);
module.exports = Promise.all([
    $c4b924c88c6f68fb$var$load("aCh9P"),
    $c4b924c88c6f68fb$var$load("bxxT5"),
    $c4b924c88c6f68fb$var$load("eZTkw")
]).then(()=>parcelRequire('lNgkk'));

});



parcelRegister("aMBx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $bccdbcf50b254fc7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $2YJH4 = parcelRequire("2YJH4");
var $jIqBR = parcelRequire("jIqBR");

var $9KcbK = parcelRequire("9KcbK");

var $lP8gk = parcelRequire("lP8gk");

var $hFKXd = parcelRequire("hFKXd");


var $2VAFB = parcelRequire("2VAFB");

var $hAV1H = parcelRequire("hAV1H");
function $bccdbcf50b254fc7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bccdbcf50b254fc7$var$DEFAULT_WIDTH = 250;
const $bccdbcf50b254fc7$var$DEFAULT_HEIGHT = 200;
const $bccdbcf50b254fc7$var$uiMediaSingleBaseStyles = {
    name: "1a43hhz",
    styles: "transition:all 0.1s linear"
};
const $bccdbcf50b254fc7$var$uiMediaSingleLayoutStyles = {
    name: "1abqfmo",
    styles: "margin-left:50%;transform:translateX(-50%)"
};
const $bccdbcf50b254fc7$var$isMediaElement = (media)=>{
    if (!media) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { nodeType: nodeType, type: type } = media.props || {};
    // Use this to perform a rough check
    // better than assume the first item in children is media
    return nodeType === 'media' || [
        'external',
        'file',
        'link'
    ].indexOf(type) >= 0;
};
const $bccdbcf50b254fc7$var$checkForMediaElement = (children)=>{
    const [media] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (media && !$bccdbcf50b254fc7$var$isMediaElement(media) && media.props.children) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return $bccdbcf50b254fc7$var$checkForMediaElement(media.props.children);
    return media;
};
const $bccdbcf50b254fc7$export$507465eaf3c57f05 = (currentContainerWidth, layout)=>{
    if (!currentContainerWidth) // SSR mode fallback to default layout width
    switch(layout){
        case 'full-width':
            return 0, $9KcbK.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $9KcbK.akEditorWideLayoutWidth;
        default:
            return 0, $9KcbK.akEditorDefaultLayoutWidth;
    }
    return currentContainerWidth;
};
const $bccdbcf50b254fc7$var$MediaSingleWithChildren = (props)=>{
    const { rendererAppearance: rendererAppearance, featureFlags: featureFlags, isInsideOfBlockNode: isInsideOfBlockNode, layout: layout, width: widthAttr, widthType: widthType, allowCaptions: allowCaptions = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes, media: media, caption: caption, editorAppearance: editorAppearance } = props;
    const [externalImageDimensions, setExternalImageDimensions] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState({
        width: 0,
        height: 0
    });
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const onExternalImageLoaded = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(({ width: width, height: height })=>{
        setExternalImageDimensions({
            width: width,
            height: height
        });
    }, []);
    // Ignored via go/ees005
    // eslint-disable-next-line prefer-const
    let { width: width = $bccdbcf50b254fc7$var$DEFAULT_WIDTH, height: height = $bccdbcf50b254fc7$var$DEFAULT_HEIGHT, type: type } = media.props;
    if (type === 'external') {
        const { width: stateWidth, height: stateHeight } = externalImageDimensions;
        if (width === null) width = stateWidth || $bccdbcf50b254fc7$var$DEFAULT_WIDTH;
        if (height === null) height = stateHeight || $bccdbcf50b254fc7$var$DEFAULT_HEIGHT;
    }
    if (width === null) {
        width = $bccdbcf50b254fc7$var$DEFAULT_WIDTH;
        height = $bccdbcf50b254fc7$var$DEFAULT_HEIGHT;
    }
    const isFullPage = rendererAppearance === 'full-page';
    const isFullWidth = rendererAppearance === 'full-width';
    const padding = isFullPage ? (0, $282e973599e7e1e7$export$12fd658e5eef0d79) * 2 : 0;
    const calcDimensions = (0, $5uXOq.useCallback)((mediaContainerWidth)=>{
        const containerWidth = $bccdbcf50b254fc7$export$507465eaf3c57f05(mediaContainerWidth, layout);
        const maxWidth = (0, $lP8gk.isSSR)() && widthAttr && typeof widthAttr === 'number' && (0, $hFKXd.fg)('platform_editor_fix_image_size_diff_during_ssr') ? Math.max(widthAttr, containerWidth) : containerWidth;
        const maxHeight = height / width * maxWidth;
        const cardDimensions = {
            width: `${maxWidth}px`,
            height: `${maxHeight}px`
        };
        let nonFullWidthSize = containerWidth;
        if (!isInsideOfBlockNode && rendererAppearance !== 'comment') {
            const isContainerSizeGreaterThanMaxFullPageWidth = containerWidth - padding >= (0, $9KcbK.akEditorDefaultLayoutWidth);
            if (isContainerSizeGreaterThanMaxFullPageWidth) nonFullWidthSize = (0, $9KcbK.akEditorDefaultLayoutWidth);
            else nonFullWidthSize = containerWidth - padding;
        }
        const minWidth = Math.min((0, $9KcbK.akEditorFullWidthLayoutWidth), containerWidth - padding);
        const lineLength = isFullWidth ? minWidth : nonFullWidthSize;
        return {
            cardDimensions: cardDimensions,
            lineLength: lineLength
        };
    }, [
        height,
        isFullWidth,
        isInsideOfBlockNode,
        layout,
        padding,
        rendererAppearance,
        width,
        widthAttr
    ]);
    const originalDimensions = (0, $5uXOq.useMemo)(()=>({
            width: width,
            height: height
        }), [
        height,
        width
    ]);
    const { setHoverTarget: setHoverTarget } = (0, $2VAFB.useAnnotationRangeDispatch)();
    const { cancelTimeout: cancelTimeout, initiateTimeout: initiateTimeout, setIsWithinRange: setIsWithinRange } = (0, $hAV1H.useAnnotationHoverDispatch)();
    const isFullPageRenderer = isFullPage || isFullWidth;
    (0, $5uXOq.useEffect)(()=>{
        const mediaSingleElement = ref.current;
        const handleMouseEnter = (event)=>{
            cancelTimeout();
            if (event.buttons === 0) {
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                setHoverTarget && setHoverTarget(event.target);
                setIsWithinRange(true);
            }
        };
        const handleMouseLeave = ()=>{
            initiateTimeout();
        };
        if (mediaSingleElement && isFullPageRenderer) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            mediaSingleElement.addEventListener('mouseenter', handleMouseEnter);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            mediaSingleElement.addEventListener('mouseleave', handleMouseLeave);
        }
        return ()=>{
            if (mediaSingleElement && isFullPageRenderer) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                mediaSingleElement.removeEventListener('mouseenter', handleMouseEnter);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                mediaSingleElement.removeEventListener('mouseleave', handleMouseLeave);
            }
        };
    }, [
        setHoverTarget,
        isFullPageRenderer,
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    // Note: in SSR mode the `window` object is not defined,
    // therefore width here is 0, see:
    // packages/editor/editor-common/src/ui/WidthProvider/index.tsx
    const { width: renderWidth } = (0, $5uXOq.useContext)((0, $jIqBR.WidthContext));
    const containerWidth = $bccdbcf50b254fc7$export$507465eaf3c57f05(renderWidth, layout);
    const { cardDimensions: cardDimensions, lineLength: lineLength } = (0, $5uXOq.useMemo)(()=>calcDimensions(containerWidth), [
        calcDimensions,
        containerWidth
    ]);
    const renderMediaSingle = ()=>{
        const mediaComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(media, {
            resizeMode: 'stretchy-fit',
            cardDimensions: cardDimensions,
            originalDimensions: originalDimensions,
            onExternalImageLoaded: onExternalImageLoaded,
            disableOverlay: true,
            featureFlags: featureFlags,
            mediaSingleElement: ref.current
        });
        const uiMediaSingleStyles = layout === 'full-width' || layout === 'wide' ? [
            $bccdbcf50b254fc7$var$uiMediaSingleBaseStyles,
            $bccdbcf50b254fc7$var$uiMediaSingleLayoutStyles
        ] : [
            $bccdbcf50b254fc7$var$uiMediaSingleBaseStyles
        ];
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2YJH4.default), {
            css: uiMediaSingleStyles,
            handleMediaSingleRef: ref,
            layout: layout,
            width: width,
            height: height,
            lineLength: isInsideOfBlockNode ? containerWidth : lineLength,
            containerWidth: containerWidth,
            size: {
                width: widthAttr,
                widthType: widthType
            },
            fullWidthMode: isFullWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            dataAttributes: dataAttributes,
            editorAppearance: editorAppearance
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, mediaComponent), allowCaptions && caption);
    };
    return renderMediaSingle();
};
const $bccdbcf50b254fc7$var$MediaSingle = (props)=>{
    const { children: children } = props;
    let media;
    const [node, caption] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children);
    if (!$bccdbcf50b254fc7$var$isMediaElement(node)) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const mediaElement = $bccdbcf50b254fc7$var$checkForMediaElement(node.props.children);
        if (!mediaElement) return node;
        media = mediaElement;
    } else media = node;
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($bccdbcf50b254fc7$var$MediaSingleWithChildren, {
        ...props,
        media: media,
        caption: caption
    });
};
var $bccdbcf50b254fc7$export$2e2bcd8739ae039 = (0, $8RXs9.default)($bccdbcf50b254fc7$var$MediaSingle);

});
parcelRegister("2YJH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1dd374a61966fb7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $9ci4W = parcelRequire("9ci4W");

var $9KcbK = parcelRequire("9KcbK");

var $hFKXd = parcelRequire("hFKXd");

var $kXjCv = parcelRequire("kXjCv");

var $3jRR8 = parcelRequire("3jRR8");

var $659Ey = parcelRequire("659Ey");

var $ij3UO = parcelRequire("ij3UO");

var $3W9Ri = parcelRequire("3W9Ri");
function $f1dd374a61966fb7$export$2e2bcd8739ae039({ layout: layout, width: width, height: height, containerWidth: containerWidth = width, isLoading: isLoading = false, pctWidth: pctWidth, size: size, className: className, children: propsChildren, nodeType: nodeType = 'mediaSingle', fullWidthMode: fullWidthMode, lineLength: editorWidth, hasFallbackContainer: hasFallbackContainer = true, handleMediaSingleRef: handleMediaSingleRef, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes }) {
    const isPixelWidth = size?.widthType === 'pixel';
    let mediaSingleWidth = size?.width || pctWidth;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(propsChildren);
    if (!mediaSingleWidth && (0, $ij3UO.shouldAddDefaultWrappedWidth)(layout, width, editorWidth)) // if width is not available, set to half of editor width
    mediaSingleWidth = isPixelWidth ? editorWidth / 2 : 50;
    // When width is not set we have an absolute height for a given embed.
    // When both width and height are set we use them to determine ratio and use that to define
    // embed height in relation to whatever width of an dom element is in runtime.
    const isHeightOnly = width === undefined;
    if (mediaSingleWidth) {
        const pxWidth = (0, $659Ey.getMediaSinglePixelWidth)(mediaSingleWidth, editorWidth, size?.widthType, (0, $3jRR8.MEDIA_SINGLE_GUTTER_SIZE));
        if (isHeightOnly) width = pxWidth - (0, $9KcbK.akEditorMediaResizeHandlerPaddingWide);
        else if (width !== undefined) {
            height = height / width * pxWidth;
            width = pxWidth;
        }
    } else if (isHeightOnly) // No mediaSingleWidth can be found on already existing pages with existing embeds
    // It's ok to use Embed specific width, because width can be not set only in embed card.
    // This value will be used only in the case of non `wide` and non `full-width` cases inside MediaSingleDimensionHelper.
    width = (0, $9KcbK.DEFAULT_EMBED_CARD_WIDTH) - (0, $9KcbK.akEditorMediaResizeHandlerPaddingWide);
    // Media wrapper controls the height of the box.
    // We can define this height
    // - via height directly
    // - via paddingBottom (if we have both height and width) which is a css trick to represent a ratio
    let mediaWrapperHeight;
    let paddingBottom;
    if (isHeightOnly) mediaWrapperHeight = height;
    else if (width !== undefined) {
        const mediaWrapperRatio = height / width * 100;
        paddingBottom = `${mediaWrapperRatio.toFixed(3)}%`;
        if (nodeType === 'embedCard') // we want to set ratio of whole box (including header) buy knowing ratio of iframe itself
        // For some reason importing `embedHeaderHeight` from '@atlaskit/smart-card' breaks
        // packages/editor/editor-core/src/plugins/table/__tests__/unit/toolbar.ts 🤷‍️, but we have a test
        // that uses imported value, so it's should be good.
        paddingBottom = `calc(${paddingBottom} + 32px)`;
    }
    const [media, caption] = children;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: handleMediaSingleRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $3W9Ri.MediaSingleDimensionHelper)({
            width: width,
            layout: layout,
            containerWidth: containerWidth,
            mediaSingleWidth: mediaSingleWidth,
            fullWidthMode: fullWidthMode,
            isExtendedResizeExperienceOn: isPixelWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            nodeType: nodeType
        }),
        ...(0, $hFKXd.fg)('platform_fix_media_image_resizing') || (0, $hFKXd.fg)('platform_editor_fix_image_size_diff_during_ssr') ? {} : {
            'data-layout': layout
        },
        "data-width": mediaSingleWidth,
        "data-width-type": size?.widthType || 'percentage',
        "data-node-type": nodeType,
        "data-vc": "media-single",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))('rich-media-item mediaSingleView-content-wrap', `image-${layout}`, className, {
            'is-loading': isLoading,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        }),
        ...dataAttributes,
        ...(0, $hFKXd.fg)('platform_exclude_media_single_from_vc') && (0, $kXjCv.VcMediaWrapperProps)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3W9Ri.MediaWrapper), {
        hasFallbackContainer: hasFallbackContainer,
        height: mediaWrapperHeight,
        paddingBottom: paddingBottom
    }, media), caption);
}

});
parcelRegister("9ci4W", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("659Ey", function(module, exports) {

$parcel$export(module.exports, "getMediaSinglePixelWidth", () => $2725fff820d29170$export$a6f4ec2edd25b07e);
$parcel$export(module.exports, "calcMediaSinglePixelWidth", () => $2725fff820d29170$export$5091b2c0d1cd2361);
$parcel$export(module.exports, "calcMediaSingleMaxWidth", () => $2725fff820d29170$export$a2e7f6320d796a21);
$parcel$export(module.exports, "getMediaSingleInitialWidth", () => $2725fff820d29170$export$4ab195f543459515);
$parcel$export(module.exports, "calculateOffsetLeft", () => $2725fff820d29170$export$ab1f1890e4428242);
$parcel$export(module.exports, "roundToNearest", () => $2725fff820d29170$export$f72673597dacfcfa);
$parcel$export(module.exports, "calcMinWidth", () => $2725fff820d29170$export$c7eaa4d46a45395);
$parcel$export(module.exports, "getMaxWidthForNestedNode", () => $2725fff820d29170$export$4147ff5cc31ec064);
$parcel$export(module.exports, "getMaxWidthForNestedNodeNext", () => $2725fff820d29170$export$bcefe8f1d5d7bbf3);
$parcel$export(module.exports, "currentMediaNodeWithPos", () => $2725fff820d29170$export$22e4c8c04f58169d);

var $gZGBX = parcelRequire("gZGBX");

var $9KcbK = parcelRequire("9KcbK");

var $ij3UO = parcelRequire("ij3UO");

var $3jRR8 = parcelRequire("3jRR8");
function $2725fff820d29170$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
    if (widthType === 'pixel') return width;
    return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}
const $2725fff820d29170$export$5091b2c0d1cd2361 = ({ width: width, widthType: widthType = 'percentage', origWidth: origWidth, layout: layout, contentWidth: contentWidth, containerWidth: containerWidth, gutterOffset: gutterOffset = 0 })=>{
    if (widthType === 'pixel' && width) return width;
    switch(layout){
        case 'wide':
            return $2725fff820d29170$var$calcLegacyWideWidth(containerWidth, origWidth, contentWidth);
        case 'full-width':
            // legacy and new experience have different definitions of full-width,
            // since it's for new experience, we convert to the new definition
            return $2725fff820d29170$export$a2e7f6320d796a21(containerWidth);
        default:
            if (width) return Math.ceil(((contentWidth || containerWidth) + gutterOffset) * (width / 100) - gutterOffset);
    }
    // Handle the case of not resized node with wrapped layout
    // It's possible that the node is first inserted with align layout (e.g. jira)
    // in which the legacy image would render the width as min(origWidth, halfContentWidth).
    // However, new experience won't be able to distinguish the two. Thus, we render halfContentWidth
    // to make sure confluence legacy node is renderered correctly
    if ((0, $3jRR8.wrappedLayouts).includes(layout)) return Math.ceil((contentWidth || containerWidth) / 2);
    // set initial width for not resized legacy image
    return $2725fff820d29170$export$4ab195f543459515(origWidth, // in case containerWidth is 0, we fallback to undefined to use akEditorDefaultLayoutWidth
    contentWidth || containerWidth || undefined);
};
/**
 * Calculate pixel width for legacy media single
 * @param contentWidth editor content width
 * @param containerWidth editor container width
 */ const $2725fff820d29170$var$calcLegacyWideWidth = (containerWidth, origWidth, contentWidth)=>{
    if (contentWidth) {
        const wideWidth = Math.ceil(contentWidth * (0, $9KcbK.breakoutWideScaleRatio));
        return wideWidth > containerWidth ? contentWidth : wideWidth;
    }
    return origWidth;
};
const $2725fff820d29170$export$a2e7f6320d796a21 = (containerWidth, editorAppearance)=>{
    const fullWidthPadding = editorAppearance === 'full-page' ? (0, $9KcbK.akEditorGutterPaddingDynamic)() * 2 : (0, $9KcbK.akEditorGutterPadding) * 2;
    return Math.min(containerWidth - fullWidthPadding, (0, $9KcbK.akEditorFullWidthLayoutWidth));
};
const $2725fff820d29170$export$4ab195f543459515 = (origWidth = (0, $3jRR8.DEFAULT_IMAGE_WIDTH), maxWidth = (0, $9KcbK.akEditorDefaultLayoutWidth), minWidth = (0, $3jRR8.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH))=>{
    return Math.max(Math.min(origWidth, maxWidth), minWidth);
};
function $2725fff820d29170$export$ab1f1890e4428242(insideInlineLike, insideLayout, pmViewDom, wrapper) {
    let offsetLeft = 0;
    if (wrapper && insideInlineLike && !insideLayout) {
        const currentNode = wrapper;
        const boundingRect = currentNode.getBoundingClientRect();
        offsetLeft = boundingRect.left - pmViewDom.getBoundingClientRect().left;
    }
    return offsetLeft;
}
const $2725fff820d29170$export$f72673597dacfcfa = (value, interval = (0, $3jRR8.DEFAULT_ROUNDING_INTERVAL))=>Math.round(value / interval) * interval;
const $2725fff820d29170$export$c7eaa4d46a45395 = (isVideoFile, contentWidth)=>{
    return Math.min(contentWidth, isVideoFile ? (0, $3jRR8.MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, $3jRR8.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH));
};
const $2725fff820d29170$export$4147ff5cc31ec064 = (view, pos)=>{
    if (typeof pos !== 'number') return null;
    if ((0, $ij3UO.isRichMediaInsideOfBlockNode)(view, pos)) {
        const $pos = view.state.doc.resolve(pos);
        const domNode = view.nodeDOM($pos.pos);
        if ($pos.nodeAfter && (0, $ij3UO.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
        if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    }
    return null;
};
const $2725fff820d29170$var$calcParentPadding = (view, resolvedPos)=>{
    // since table has constant padding, use hardcoded constant instead of query the dom
    const tablePadding = 8;
    const { tableCell: tableCell, tableHeader: tableHeader } = view.state.schema.nodes;
    return [
        tableCell,
        tableHeader
    ].includes(resolvedPos.parent.type) ? tablePadding * 2 : 0;
};
const $2725fff820d29170$export$bcefe8f1d5d7bbf3 = (view, pos, forInsertion)=>{
    if (typeof pos !== 'number') return null;
    const $pos = view.state.doc.resolve(pos);
    if ($pos && $pos.parent.type.name !== 'doc') return forInsertion ? $2725fff820d29170$export$7cc71489edfd26f8($pos, view) : $2725fff820d29170$export$4226a56ec6bfa71c($pos, view);
    return null;
};
const $2725fff820d29170$export$4226a56ec6bfa71c = (resolvedPos, view)=>{
    const domNode = view.nodeDOM(resolvedPos.pos);
    if (resolvedPos.nodeAfter && (0, $ij3UO.floatingLayouts).includes(resolvedPos.nodeAfter.attrs.layout) && domNode && domNode.parentElement) {
        const parentPadding = $2725fff820d29170$var$calcParentPadding(view, resolvedPos);
        return domNode.parentElement.offsetWidth - parentPadding;
    }
    if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    return null;
};
const $2725fff820d29170$export$7cc71489edfd26f8 = (resolvedPos, view)=>{
    const parentPos = resolvedPos.before(resolvedPos.depth);
    const parentDomNode = view.nodeDOM(parentPos);
    const parentPadding = $2725fff820d29170$var$calcParentPadding(view, resolvedPos);
    if (parentDomNode instanceof HTMLElement) return parentDomNode.offsetWidth - parentPadding;
    return null;
};
const $2725fff820d29170$export$22e4c8c04f58169d = (editorState)=>{
    const { doc: doc, selection: selection, schema: schema } = editorState;
    if (!doc || !selection || !(selection instanceof (0, $gZGBX.NodeSelection)) || selection.node.type !== schema.nodes.mediaSingle) return;
    const pos = selection.$anchor.pos + 1;
    const node = doc.nodeAt(pos);
    if (!node || node.type !== schema.nodes.media) return;
    return {
        node: node,
        pos: pos
    };
};

});


const $282e973599e7e1e7$export$12fd658e5eef0d79 = 32;
const $282e973599e7e1e7$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';




//# sourceMappingURL=media.0c697e3e.js.map
